import { TextareaAutosize, IconButton, Tooltip, Box } from '@mui/material'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import CancelIcon from '@mui/icons-material/Cancel'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import UndoIcon from '@mui/icons-material/Undo'
import LockIcon from '@mui/icons-material/Lock'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectPrescriptionViewSettingsData } from 'src/clinic/reducers/prescription/prescriptionReducer'
import { Spinner } from 'react-bootstrap'
// react-quill CSS removed - replaced by TipTap
import { useLocation } from 'react-router-dom'
import { components } from 'react-select'
import { withAsyncPaginate } from 'react-select-async-paginate'
import AsyncSelect from 'react-select/async'
import { default as Creatable } from 'react-select/creatable'
import { toast } from 'react-toastify'
import { sortArrayMomentBased } from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingsHelper'
import { getCPDataWithoutParams } from 'src/clinic/services'
import { AutocompleteHelperButton, CustomInput } from 'src/consumer/components/helperComponents'
import {
  DRUG_ADVICE_TABLE_TYPES,
  SELECTABLE_DRUG_ADVICE_TABLE_TYPE_IDS,
  HE_DRUG_ADVICE_DOSAGE,
  HE_DRUG_ADVICE_DURATION,
  HE_DRUG_ADVICE_FREQUENCY,
  HE_DRUG_ADVICE_NOTE,
  HE_DRUG_ADVICE_TIMING,
  HE_DRUG_ADVICE_TYPE,
  HE_KEY_ADVICE,
  HE_KEY_DIAGNOSIS,
  HE_KEY_DRUGS,
  HE_KEY_HEALTH_COMPLAINTS,
  HE_KEY_INSTRUCTIONS,
  HE_KEY_OBSERVATIONS,
  PRESCRIPTION_LAYOUTS,
  PRESCRIPTION_PRINT_TYPES,
  FOOTER_MODES,
  deriveFooterMode,
} from 'src/consumer/constants'
import { isValidNumber } from 'src/consumer/helpers/utilFunctions'
import { getDataWithoutParams, postDataWithoutParams } from 'src/consumer/services/featureServices'
import { MUIThemeConfig } from 'src/context/MUIThemeConfig'
import useElementDimensions from 'src/customHooks/customHooks'
import JointHomunculusComponent from 'src/emr/components/swollenJointHighlighter/SwollenJointHighlighter'
import {
  addOrUpdateAdvicesInIdb,
  addOrUpdateDiagnosisInIdb,
  addOrUpdateDrugsInIdb,
  addOrUpdateHealthComplaintsInIdb,
  addOrUpdateInstructionsInIdb,
  addOrUpdateInvestigationInIdb,
  addOrUpdateObservationsInIdb,
  addOrUpdatePsychAssessmentsInIdb,
  getAdvicesByIds,
  getDiagnosisByIds,
  getDrugsByIDs,
  getFunctionForAddOrUpdateHealthEntitySingle,
  getHealthComplaintsByIds,
  getInstructionsByIds,
  getInvestigationByIds as getInvestigationByIdsFromIdb,
  getObservationsByIds,
  getPsychAssessmentsByIds,
  searchAdvicesInIdb,
  searchDiagnosisInIdb,
  searchDrugsInIdb,
  searchHealthComplaintsInIdb,
  searchInstructionsInIdb,
  searchInvestigationInIdb,
  searchObservationsInIdb,
  searchPsychAssessmentsInIdb,
} from 'src/emr/database/indexedDbDao'
import ListPointerCenerAligned from 'src/mentor/components/PrescriptionMakingPage/prescriptionTemplate/footer/ListPointerCenerAligned'
import { PmpPatientDetails } from 'src/mentor/components/PrescriptionMakingPage/printComponents/printComponents/prescriptionPrintableItems/PatientDetails'
import PrintablePatientHistoryNotes from 'src/mentor/components/PrescriptionMakingPage/printComponents/printComponents/prescriptionPrintableItems/PrintablePatientHistoryNotes'
import {
  checkAndRenderBasedOnEmrSections,
  PRESCRIPTION_ITEM_ORDER_IDS,
} from 'src/mentor/components/PrescriptionMakingPage/printComponents/utils'
import { getImageLink, isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import { getMPDataWithoutParams, postMPDataWithoutParams } from 'src/mentor/services'
import { useVitalsForm } from 'src/reducers/vitalsFormSettings/hooks/useVitalsForm'
import { convertToFahrenheitFromCelsius } from '../VitalsListingPage'
import { PRESCRIPTION_COLORS_MAP } from './inputComponents/common/color-utils'
import {
  handleChangeHealthEntityInputType1,
  handleKeyDownAndSupportEdit,
} from './inputComponents/common/helpers'
import GenericDrugComponent from './inputComponents/drugAdvice/components/GenericDrugComponent'
import {
  CreatableDrugAdviceInput,
  CreatableDrugDoseSelection,
  CreatableDrugDoseSelectionContainer,
  CreatableDrugDurationSelection,
  CreatableDrugDurationSelectionContainer,
  CreatableDrugFrequencySelection,
  CreatableDrugFrequencySelectionContainer,
  CreatableDrugNotesSelect,
  CreatableDrugTypeSelection,
  CreatableDrugTypeSelectionContainer,
  CreatableDrugWhatTimeSelection,
  CreatableDrugWhatTimeSelectionContainer,
} from './inputComponents/drugAdvice/components/styledComponents'
import { getPercentageOfItemForDrugTableCellWidth } from './inputComponents/drugAdvice/DrugAdviceInput'
import {
  filterForDosagesDropDown,
  filterForDrugTypesDropDown,
  filterForTitleAndAliasesDropDown,
  getDrugItemOptionLabel,
  getDrugItemOptionValue,
  getDrugTypeItemOptionLabel,
  getDrugTypeItemOptionValue,
  getRenderDrugAdviceSubSectionsSet,
  isCreateDosageOptionValid,
  isCreatingOptionValidForDrugType,
  normalizeDoseText,
  normalizeTitleForDedupe,
} from './inputComponents/drugAdvice/utils'
import {
  buildRxPatientExplainerForRow,
  getRxExplainerLanguage,
  getSuggestedWhatTimeForDosage,
} from './inputComponents/drugAdvice/rxExplainer'
import './pmp.css'
import {
  AssessmentAsyncSelect,
  AssessmentCreatableSelect,
  PmpBodyContentContainer,
  PmpContentContainer,
  PMPSectionInputLabel,
  PMPSectionTextAreaBox,
  PMPSingleRowBox,
  PMPSingleRowForDrugs
} from './PrescriptionMakingPageStyles'
import { DefaultNextVisitRowComponent } from './prescriptionTemplate/body/DefaultBodyComponents'
import { ThreeColumnNextVisitRowComponent } from './prescriptionTemplate/body/ThreeColumnFooterBodyComponents'
import DefaultPrescriptionFooter from './prescriptionTemplate/footer/DefaultPrescriptionFooter'
import PrintFooterMetaBar from './printComponents/printComponents/PrintFooterMetaBar'
import ListPointersFooter from './prescriptionTemplate/footer/ListPointersFooter'
import ThreeColumnPrescriptionFooter from './prescriptionTemplate/footer/ThreeColumnPrescriptionFooter'
import TwoColumnPrescriptionFooter from './prescriptionTemplate/footer/TwoColumnPrescriptionFooter'
import TwoColumnPrescriptionWithDisclaimerFooter from './prescriptionTemplate/footer/TwoColumnPrescriptionWithDisclaimerFooter'
import PrintableAssessments from './printComponents/printComponents/prescriptionPrintableItems/PrintableAssessments'
import PrintableDiagnosis from './printComponents/printComponents/prescriptionPrintableItems/PrintableDiagnosis'
import PrintableInvestigations from './printComponents/printComponents/prescriptionPrintableItems/PrintableInvestigations'
import PrintableReferredToDoctorName from './printComponents/printComponents/prescriptionPrintableItems/PrintableReferredToDoctorName'
import { PMPBodySectionItems } from './printComponents/printComponents/prescriptionPrintableItems/styledComponent'
import {
  getCasedHeadingTextBasedOnStyleOverrides,
  getValidDiagnosisArrayForPrescription,
} from './printComponents/printComponents/prescriptionPrintableItems/util'
import { resolveDrugAdvicePrintColorStyles } from './printComponents/drugAdvicePrintColorStyles'
import {
  buildHpRowItem,
  getGenericDrugItemObject,
  getPrescriptionBreaksWithWhereInHeight,
  isHomunculusValid,
  saveAndAddToIdbGenericNames,
} from './utils'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(customParseFormat)

export function getDateOfPrescription(prescriptionData, withTime) {
  let format = 'DD/MM/YYYY'
  if (withTime) {
    format = 'DD/MM/YYYY h:mmA'
  }
  if (
    prescriptionData?.prescriptionData?.startTime ||
    prescriptionData?.prescriptionData?.createdTime ||
    prescriptionData?.prescriptionData?.modifiedTime
  ) {
    const dateString =
      prescriptionData?.prescriptionData?.startTime ||
      prescriptionData?.prescriptionData?.createdTime ||
      prescriptionData?.prescriptionData?.modifiedTime
    
    if (!dateString) {
      return dayjs().format(format)
    }
    
    // Parse the date string as UTC, then convert to local time
    // dayjs.utc() can parse ISO strings and many date formats automatically
    const utcDate = dayjs.utc(dateString)
    if (utcDate.isValid()) {
      return utcDate.local().format(format)
    }
    
    // Fallback: try parsing with format string
    const parsed = dayjs(dateString, 'YYYY-MM-DD HH:mm:ss')
    if (parsed.isValid()) {
      return parsed.utc().local().format(format)
    }
    
    // Final fallback: return current date
    return dayjs().format(format)
  }
  return dayjs().format(format)
}

const DrugItemsAdviceOption = (props) => {
  const { children, ...rest } = props

  const currentOption = props.data

  return (
    <components.Option {...rest}>
      <div className="d-flex justify-content-start align-items-center gap-4">
        {!currentOption?.__isNew__ ? (
          <>
            <div className="d-flex flex-column gap-2">
              <div>{children}</div>
              <div>{currentOption?.translations?.hi?.title}</div>
            </div>
          </>
        ) : (
          <>
            <span>Create: {currentOption?.value}</span>
          </>
        )}
      </div>
    </components.Option>
  )
}

const DrugItemsAdviceSelectedItemOption = ({ children, ...props }) => {
  const currentOption = props.data

  return (
    <components.SingleValue {...props}>
      <div className="d-flex flex-column gap-2">
        <div>{children}</div>
        <div>{currentOption?.translations?.hi?.title}</div>
      </div>
    </components.SingleValue>
  )
}

export async function putAllDrugsInDB() {
  // if (isDrugDatabaseUpdateNeeded()){
  //   try {
  //     const response = await getCPDataWithoutParams(
  //       '/api/secure/drug/list?search=&clinicId=CLN-ee233e80966946948dea2b518719081b&clinicBrandId=sakra-world-brand&page=1&pageSize=100',
  //     )
  //     const responseData = response?.data
  //     const indexedDB =
  //       window.indexedDB ||
  //       window.mozIndexedDB ||
  //       window.webkitIndexedDB ||
  //       window.msIndexedDB ||
  //       window.shimIndexedDB
  //     const dbRequest = indexedDB.open('amhmDB', 1)
  //     dbRequest.onerror = function (event) {
  //       console.error('IndexedDB error:', event.target.errorCode)
  //     }
  //     dbRequest.onupgradeneeded = function () {
  //       const db = dbRequest.result
  //       if (!db?.objectStoreNames?.contains('drugs')) {
  //         const store = db?.createObjectStore('drugs', { keyPath: 'id' })
  //         store.createIndex('title', ['title'], { unique: false })
  //       }
  //     }
  //     dbRequest.onsuccess = function () {
  //       const db = dbRequest.result
  //       const transaction = db.transaction('drugs', 'readwrite')
  //       const store = transaction.objectStore('drugs')
  //       const clearRequest = store.clear()
  //       clearRequest.onsuccess = function () {
  //         console.log('IDB-PUT: cleared old data')
  //         responseData.forEach((drug) => {
  //           store.put(drug)
  //         })
  //         console.log('IDB-PUT: New Data successfully stored')
  //         sessionStorage.setItem("drugDatabaseUpdated", dayjs().format())
  //       }
  //       clearRequest.onerror = function (event) {
  //         console.log('IDB-PUT: could not clear old data')
  //       }
  //     }
  //   } catch (error) {
  //     console.error('Putting all drugs in client DB failed:', error)
  //   }
  // } else {
  //   console.log('IDB-PUT: Drugs database update not needed.')
  // }
}

export function readAllDrugDataFromDB() {
  return new Promise((resolve, reject) => {
    const indexedDB =
      window.indexedDB ||
      window.mozIndexedDB ||
      window.webkitIndexedDB ||
      window.msIndexedDB ||
      window.shimIndexedDB

    const dbRequest = indexedDB.open('DrugData', 1)

    dbRequest.onerror = function (event) {
      console.error('IndexedDB error:', event.target.errorCode)
      reject(event.target.errorCode)
    }

    dbRequest.onsuccess = function () {
      const db = dbRequest.result
      const transaction = db.transaction('drugs', 'readonly')
      const store = transaction.objectStore('drugs')

      const getAllRequest = store.getAll()

      getAllRequest.onsuccess = function () {
        const drugs = getAllRequest.result
        resolve(drugs)
      }

      getAllRequest.onerror = function (event) {
        console.error('Error retrieving data from IndexedDB:', event.target.errorCode)
        reject(event.target.errorCode)
      }
    }
  })
}

export function PmpPrintableVitals({
  vital,
  leaveSpace,
  debug,
  prescriptionViewSettings,
  practitionerId,
  vitalsDisplayFormat = 'list',
  vitalsNameBold = true,
  listItemSeparator = ', ',
}) {
  // 11 Sep 1906
  //
  // REFACTORED TO USE CENTRALIZED HOOK
  // All complex vitals logic moved to useVitalsForm hook for easier maintenance
  //

  // Detect portal and construct appropriate API signature
  const vitalsFormApiSignature = (() => {
    if (typeof window !== 'undefined') {
      const pathname = window.location.pathname
      if (pathname.startsWith('/support-home/') || pathname.startsWith('/support/')) {
        // Support portal - use support portal API
        if (practitionerId) {
          return `/api/secure/cc/support/practitioner/vitals/form?practitioner-id=${practitionerId}`
        }
        return '/api/secure/cc/support/practitioner/vitals/form'
      }
    }
    // Mentor portal - use practitioner API
    return '/api/secure/practitioner/vitals/form'
  })()

  // Use centralized vitals hook (read-only mode)
  const { vitalsFields, getDisplayValue, getDefaultUnit } = useVitalsForm({
    existingVitalData: vital,
    autoFetch: true,
    vitalsFormGetApiSignature: vitalsFormApiSignature,
    practitionerId,
  })

  // Check if any vital data exists using dynamic fields
  const isVitalsVisible = vitalsFields.some((field) => {
    const value = vital?.[field.id]
    return value !== null && value !== undefined
  })

  // Compute a {label, valueText, referenceText} display item for a vital field, or null
  // when there is no value / the field is the non-header half of a grouped pair.
  const computeVitalDisplay = (field) => {
    const value = vital?.[field.id]
    if (value === null || value === undefined) return null

    const defaultUnit = getDefaultUnit(field)
    const displayValue = getDisplayValue(field)
    const unitText = defaultUnit?.label || ''
    const referenceText =
      field.referenceInterval || field.normalRange || field.biologicalReferenceInterval || ''

    // Grouped blood pressure — the header field carries both systolic/diastolic.
    if (field.ui?.groupId === 'bp' && field.ui?.groupHeader) {
      const otherBpField = vitalsFields.find((f) => f.ui?.groupId === 'bp' && f.id !== field.id)
      if (otherBpField) {
        const otherDisplayValue = getDisplayValue(otherBpField)
        const roundedDisplayValue =
          displayValue && !isNaN(displayValue) ? parseFloat(displayValue).toFixed(0) : displayValue || '-'
        const roundedOtherValue =
          otherDisplayValue && !isNaN(otherDisplayValue)
            ? parseFloat(otherDisplayValue).toFixed(0)
            : otherDisplayValue || '-'
        return {
          id: field.id,
          label: field.ui.groupLabel || field.label,
          valueText: `${roundedDisplayValue}/${roundedOtherValue} ${unitText} (systolic/diastolic)`.trim(),
          referenceText,
        }
      }
    } else if (field.ui?.groupId === 'bp' && !field.ui?.groupHeader) {
      return null
    }

    // Temperature: dual unit (°C / °F).
    if (field.id === 'tempInCelsius' && displayValue) {
      const roundedCelsius = parseFloat(displayValue).toFixed(1)
      const fahrenheit = convertToFahrenheitFromCelsius(displayValue)
      return { id: field.id, label: field.label, valueText: `${roundedCelsius}°C / ${fahrenheit}°F`, referenceText }
    }

    // Numeric rounding by unit config / field-type heuristics.
    let formattedValue = displayValue
    if (displayValue !== null && displayValue !== undefined && !isNaN(displayValue)) {
      let decimals = defaultUnit?.decimals
      if (decimals === undefined) {
        if (field.type === 'calculated') decimals = 2
        else if (field.id.includes('temp') || field.id.includes('Temp')) decimals = 1
        else if (field.id.includes('bp') || field.id.includes('Bp') || field.id.includes('BP')) decimals = 0
        else if (field.id.includes('bpm') || field.id.includes('Rate') || field.id.includes('rate')) decimals = 0
        else if (field.id.includes('sp02') || field.id.includes('SpO2') || field.id.includes('spo2')) decimals = 0
        else if (field.id.includes('weight') || field.id.includes('Weight')) decimals = 1
        else if (field.id.includes('height') || field.id.includes('Height')) decimals = 1
        else decimals = 2
      }
      formattedValue = parseFloat(displayValue).toFixed(decimals)
    }

    return {
      id: field.id,
      label: field.label,
      valueText: `${formattedValue}${unitText ? ` ${unitText}` : ''}`.trim(),
      referenceText,
    }
  }

  if (!isVitalsVisible) return <></>

  const vitalItems = vitalsFields.map(computeVitalDisplay).filter(Boolean)
  if (vitalItems.length === 0) return <></>

  const nameBold = vitalsNameBold !== false
  const NameTag = nameBold ? 'b' : 'span'
  const sep = listItemSeparator || ', '

  // TABLE format — Vital / Observation / Biological Reference Interval.
  if (vitalsDisplayFormat === 'table') {
    const thStyle = {
      textAlign: 'left',
      padding: '6px 10px',
      border: '1px solid #cbd5e1',
      background: '#eef2ff',
      fontWeight: 700,
    }
    const tdStyle = { padding: '5px 10px', border: '1px solid #cbd5e1', verticalAlign: 'top' }
    return (
      <div style={{ padding: '5px 20px', width: '100%' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 'inherit' }}>
          <thead>
            <tr>
              <th style={thStyle}>Vital</th>
              <th style={thStyle}>Observation</th>
              <th style={thStyle}>Biological Reference Interval</th>
            </tr>
          </thead>
          <tbody>
            {vitalItems.map((it) => (
              <tr key={it.id}>
                <td style={tdStyle}>
                  <NameTag>{it.label}</NameTag>
                </td>
                <td style={tdStyle}>{it.valueText}</td>
                <td style={tdStyle}>{it.referenceText || ''}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }

  // BULLET format — one vital per bullet line.
  if (vitalsDisplayFormat === 'bullet') {
    return (
      <ul style={{ padding: '5px 20px 5px 38px', margin: 0, width: '100%' }}>
        {vitalItems.map((it) => (
          <li key={it.id}>
            <NameTag>{it.label}</NameTag> - {it.valueText}
          </li>
        ))}
      </ul>
    )
  }

  // LIST format (default) — inline key/value joined by the configured separator.
  return (
    <div className="w-100" style={{ padding: '5px 20px' }}>
      {vitalItems.map((it, idx) => (
        <span key={it.id}>
          <NameTag>{it.label}</NameTag>: {it.valueText}
          {idx < vitalItems.length - 1 ? sep : ''}
        </span>
      ))}
    </div>
  )
}

export const PrescriptionDrugAdviceTable = ({
  drugsAdvice,
  prescriptionData,
  prescriptionViewSettings,
  debug,
  drugAdviceTableRef,
  debugHighlightStates,
  showDrugsInCaps = true,
  isCellBold = true,
  drugAdviceSubSections,
  styleOverrides,
  colorMode = 'colored',
  getSectionColor,
  isContinuation = false,
  chunkRange = null,
  totalDrugsCount = null, // Total number of drugs for intelligent title
  allDrugsAdvice = null, // full (unchunked) list, needed for taper-aware numbering across page chunks
}) => {
  const filteredDrugsAdvice = drugsAdvice?.filter((item) => item?.drug?.label)
  
  // Calculate total drugs for intelligent title display
  const totalDrugs = totalDrugsCount || filteredDrugsAdvice?.length || 0
  
  // Get latest settings from Redux store as fallback if prop settings are incomplete
  const prescrpitionViewSettingsStoreData = useSelector(selectPrescriptionViewSettingsData)
  const storeSettings = prescrpitionViewSettingsStoreData?.data
  
  // Get drugAdviceTablePrintType from settings, with multiple fallbacks:
  // 1. Per-template body setting (template editor / template-derived prescriptions)
  // 2. Main prescriptionViewSettings prop
  // 3. paperPrintSettings (in case drawer uses paper settings)
  // 4. Redux store settings (if prop is incomplete)
  // 5. Default to 'default'
  const rawDrugAdviceTableType = prescriptionData?.body?.drugAdviceTablePrintType
    || prescriptionViewSettings?.drugAdviceTablePrintType
    || prescriptionViewSettings?.paperPrintSettings?.drugAdviceTablePrintType
    || storeSettings?.drugAdviceTablePrintType
    || 'default'
  // Legacy 'HP' (and anything unknown) renders as the Default Table; list /
  // paragraphList pass through to their own (non-table) render branches.
  const drugAdviceTableType = SELECTABLE_DRUG_ADVICE_TABLE_TYPE_IDS.includes(rawDrugAdviceTableType)
    ? rawDrugAdviceTableType
    : 'default'
  // Table-style → render dimensions. Only meaningful for the four TABLE presets;
  // list / paragraphList render via separate branches and ignore these:
  //   default        → boxed, no quantity, remarks COLUMN
  //   boxedQty       → boxed, quantity col, remarks SUB-ROW
  //   openQty        → open,  quantity col, remarks SUB-ROW
  //   openQtyRemarks → open,  quantity col, remarks COLUMN
  const isOpenRxTable =
    drugAdviceTableType === 'openQty' || drugAdviceTableType === 'openQtyRemarks'
  const showRxQuantityColumn =
    drugAdviceTableType === 'boxedQty' ||
    drugAdviceTableType === 'openQty' ||
    drugAdviceTableType === 'openQtyRemarks'
  const rxRemarksAsColumn =
    drugAdviceTableType === 'default' || drugAdviceTableType === 'openQtyRemarks'
  const rxRemarksAsSubRow = showRxQuantityColumn && !rxRemarksAsColumn

  // The template's explicit "Preferred Language" (when set) wins; otherwise fall back to the
  // practitioner-wide preferred languages (unchanged behaviour for templates that set none).
  const explicitPrintLanguage = prescriptionData?.preferredLanguage
  const showPrescriptionInHindi = explicitPrintLanguage
    ? explicitPrintLanguage === 'hi'
    : prescriptionViewSettings
      ? prescriptionViewSettings?.preferredPrescriptionLanguages?.includes('hi')
      : prescriptionData?.prescriptionLanguages?.includes('hi')

  const debugStyles = debug ? { background: 'transparent' } : {}
  const genericDrugStyles =
    prescriptionViewSettings?.styleOverridesForPrintedEmrSections?.['drug-generic-formula']
  const rxColorStyles = useMemo(
    () => resolveDrugAdvicePrintColorStyles(styleOverrides, colorMode),
    [styleOverrides, colorMode],
  )

  // Taper continuation rows ("↳") belong to the medicine above them, so the visible
  // numbering skips them. Numbering is computed over the full list when provided, so
  // it stays correct when the Rx table is split into per-page chunks.
  const rxNumberingSourceRows = useMemo(() => {
    return Array.isArray(allDrugsAdvice) && allDrugsAdvice.length > 0
      ? allDrugsAdvice.filter((item) => item?.drug?.label)
      : drugsAdvice?.filter((item) => item?.drug?.label) || []
  }, [allDrugsAdvice, drugsAdvice])

  const taperAwareNumberLabels = useMemo(() => {
    let counter = 0
    return rxNumberingSourceRows.map((row) => {
      if (row?.isTaperContinuation && counter > 0) {
        return '↳'
      }
      counter += 1
      return `${counter}`
    })
  }, [rxNumberingSourceRows])

  const getRxRowNumberDisplay = (localIndex) => {
    const absoluteIndex = (chunkRange?.startRow ? chunkRange.startRow - 1 : 0) + localIndex
    return (
      taperAwareNumberLabels[absoluteIndex] ??
      `${chunkRange?.startRow ? chunkRange.startRow + localIndex : localIndex + 1}`
    )
  }

  const taperContinuationMarker = (fontSize = '0.85em') => (
    <span style={{ fontStyle: 'italic', fontWeight: 400, fontSize }}>
      {' '}
      ({!showPrescriptionInHindi ? 'contd.' : 'जारी'})
    </span>
  )

  // patient-friendly explainer sentence per row, in the single prescription language
  const rxExplainerLanguage = getRxExplainerLanguage(prescriptionViewSettings, prescriptionData)
  const getRowExplainerForPrint = (drugAdviceItem, localIndex) => {
    if (!drugAdviceItem || drugAdviceItem?.explainerExcluded) {
      return ''
    }
    // resolve the previous row across page chunks so taper steps can say
    // "After the first 15 days:" even when the chain splits over pages
    const absoluteIndex =
      (chunkRange?.startRow ? chunkRange.startRow - 1 : 0) + (localIndex ?? -1)
    const previousRow = absoluteIndex > 0 ? rxNumberingSourceRows[absoluteIndex - 1] : undefined
    return (
      buildRxPatientExplainerForRow(drugAdviceItem, rxExplainerLanguage, previousRow) ||
      drugAdviceItem?.drug?.patientExplainer ||
      ''
    )
  }

  // Computed total quantity for a drug row:
  //   quantity = doseCount × dosesPerDay × durationInDays   (unit taken from the dose)
  // e.g. dose "1 tablet" + freq "1-0-1" (2/day) + "1 Week" (7d) → "14 tablet".
  // Returns '' when any factor can't be parsed, so the cell simply stays blank.
  const computeRxQuantity = (drugAdviceItem) => {
    const doseLabel = (drugAdviceItem?.dosage?.label || '').trim()
    const freqLabel = (drugAdviceItem?.frequency?.label || '').trim()
    const durationLabel = (drugAdviceItem?.duration?.label || '').trim()
    if (!doseLabel || !freqLabel || !durationLabel) return ''

    // dose → leading number + unit ("1 tablet" → 1 / "tablet", "5 ml" → 5 / "ml")
    const doseMatch = doseLabel.match(/([\d.]+)\s*(.*)$/)
    if (!doseMatch) return ''
    const doseCount = parseFloat(doseMatch[1])
    const doseUnit = (doseMatch[2] || '').trim()

    // dosesPerDay → sum of dash-separated digits ("1-0-1" → 2); else first number
    let dosesPerDay = NaN
    if (/\d\s*-\s*\d/.test(freqLabel)) {
      dosesPerDay = freqLabel
        .split('-')
        .map((part) => parseFloat(part.trim()))
        .filter((n) => !Number.isNaN(n))
        .reduce((sum, n) => sum + n, 0)
    } else {
      const freqMatch = freqLabel.match(/[\d.]+/)
      dosesPerDay = freqMatch ? parseFloat(freqMatch[0]) : NaN
    }

    // durationInDays → number × {day:1, week:7, month:30}
    const durMatch = durationLabel.match(/[\d.]+/)
    let durationDays = NaN
    if (durMatch) {
      const n = parseFloat(durMatch[0])
      if (/month/i.test(durationLabel)) durationDays = n * 30
      else if (/week/i.test(durationLabel)) durationDays = n * 7
      else durationDays = n // days (default unit)
    }

    if (Number.isNaN(doseCount) || Number.isNaN(dosesPerDay) || Number.isNaN(durationDays)) {
      return ''
    }
    const total = doseCount * dosesPerDay * durationDays
    if (!Number.isFinite(total) || total <= 0) return ''
    const totalStr = Number.isInteger(total) ? `${total}` : `${Math.round(total)}`
    return doseUnit ? `${totalStr} ${doseUnit}` : totalStr
  }

  const getRxHeaderRowStyle = (baseStyle = {}) => ({
    ...baseStyle,
    background: rxColorStyles.headerBackground,
    color: rxColorStyles.headerText,
    // Open presets drop the box outline and keep only a stronger rule under the
    // header; boxed presets keep the full 1px outline.
    ...(isOpenRxTable
      ? { border: 'none', borderBottom: `2px solid ${rxColorStyles.border}` }
      : { border: `1px solid ${rxColorStyles.border}` }),
  })

  const getRxBodyRowStyle = (rowIndex, baseStyle = {}) => ({
    ...baseStyle,
    // No zebra striping — every row uses the same (unshaded) background. Open
    // presets keep horizontal separators only; boxed presets keep the full grid.
    background: rxColorStyles.rowBackground,
    ...(isOpenRxTable
      ? { border: 'none', borderBottom: `1px solid ${rxColorStyles.border}` }
      : { border: `1px solid ${rxColorStyles.border}` }),
  })

  const getRxCellStyle = (textColor, baseStyle = {}, { header = false, keepBackground = false } = {}) => ({
    ...baseStyle,
    color: textColor,
    background: keepBackground ? baseStyle.background : 'transparent',
    // Leaner, evenly-padded cells for a cleaner, denser grid. Headers get a touch
    // more vertical room plus crisp bold weight + tight line-height so single-word
    // labels sit centered and well-fitted (matches the reference layout).
    padding: header ? '9px 10px' : '8px 10px',
    ...(header ? { fontWeight: 700, lineHeight: 1.2, letterSpacing: '0.2px' } : {}),
    ...(baseStyle.padding ? { padding: baseStyle.padding } : {}),
    // Vertical cell separators only in boxed presets; open presets have none.
    ...(!isOpenRxTable ? { borderRight: `1px solid ${rxColorStyles.border}` } : {}),
  })

  // Default to true if not explicitly set to false in settings
  var hideEmptyRxColumns = prescriptionViewSettings?.hideEmptyDrugAdviceColumns !== false

  const showDrugName = getRenderDrugAdviceSubSectionsSet(drugAdviceSubSections).has('drug_name')
  const showDosage = getRenderDrugAdviceSubSectionsSet(drugAdviceSubSections).has('dosage')
  const showWhen = getRenderDrugAdviceSubSectionsSet(drugAdviceSubSections).has('when')
  const showFrequency = getRenderDrugAdviceSubSectionsSet(drugAdviceSubSections).has('frequency')
  const showDuration = getRenderDrugAdviceSubSectionsSet(drugAdviceSubSections).has('duration')
  const showNotes = getRenderDrugAdviceSubSectionsSet(drugAdviceSubSections).has('notes')
  const hasAnySelectedDrugAdviceSubSection =
    showDrugName || showDosage || showWhen || showFrequency || showDuration || showNotes
  const shouldShowDrugNameInPrint = showDrugName || !hasAnySelectedDrugAdviceSubSection

  // Check if columns have any data (when hideEmptyRxColumns is true)
  const hasDosageData = hideEmptyRxColumns 
    ? filteredDrugsAdvice?.some(item => item?.dosage?.label) 
    : true
  const hasWhenData = hideEmptyRxColumns 
    ? filteredDrugsAdvice?.some(item => item?.whatTime?.label) 
    : true
  const hasFrequencyData = hideEmptyRxColumns 
    ? filteredDrugsAdvice?.some(item => item?.frequency?.label) 
    : true
  const hasDurationData = hideEmptyRxColumns 
    ? filteredDrugsAdvice?.some(item => item?.duration?.label) 
    : true
  const hasNotesData = hideEmptyRxColumns
    ? filteredDrugsAdvice?.some(item => item?.notes?.label)
    : true

  // Remarks column = the patient-friendly sentence (+ any doctor note), shown to the
  // right of the table instead of as a full-width sub-row under each medicine. When a
  // Duration column is already present we drop the trailing "for N days" from the
  // sentence so it isn't repeated next to the Duration value.
  const isDurationColumnVisibleInTable = showDuration && hasDurationData
  const getRemarkNoteForPrint = (drugAdviceItem) =>
    showNotes && drugAdviceItem?.notes?.label ? drugAdviceItem.notes.label : ''
  const getRemarkExplainerForPrint = (drugAdviceItem, localIndex) => {
    if (!drugAdviceItem || drugAdviceItem?.explainerExcluded) {
      return ''
    }
    const absoluteIndex =
      (chunkRange?.startRow ? chunkRange.startRow - 1 : 0) + (localIndex ?? -1)
    const previousRow = absoluteIndex > 0 ? rxNumberingSourceRows[absoluteIndex - 1] : undefined
    return (
      buildRxPatientExplainerForRow(drugAdviceItem, rxExplainerLanguage, previousRow, {
        includeDuration: !isDurationColumnVisibleInTable,
      }) ||
      drugAdviceItem?.drug?.patientExplainer ||
      ''
    )
  }
  const hasRemarksData = (filteredDrugsAdvice || []).some(
    (item, idx) => Boolean(getRemarkNoteForPrint(item)) || Boolean(getRemarkExplainerForPrint(item, idx)),
  )

  const defaultTableVisibleColumnsSet = useMemo(() => {
    const visibleSet = new Set()
    if (shouldShowDrugNameInPrint) visibleSet.add('drug_name')
    if (showDosage && hasDosageData) visibleSet.add('dosage')
    // Frequency + When share one column (frequency bold, timing below)
    if ((showFrequency && hasFrequencyData) || (showWhen && hasWhenData)) {
      visibleSet.add('freqWhen')
    }
    if (showDuration && hasDurationData) visibleSet.add('duration')
    // Remarks is a column only for the column-style presets (default / openQtyRemarks);
    // for boxedQty / openQty it renders as a full-width sub-row instead.
    if (rxRemarksAsColumn && hasRemarksData) visibleSet.add('remarks')
    // Quantity column for the quantity-bearing presets (always shown, value computed).
    if (showRxQuantityColumn) visibleSet.add('quantity')

    if (visibleSet.size === 0) {
      visibleSet.add('drug_name')
    }

    return visibleSet
  }, [
    shouldShowDrugNameInPrint,
    showDosage,
    showWhen,
    showFrequency,
    showDuration,
    hasDosageData,
    hasWhenData,
    hasFrequencyData,
    hasDurationData,
    hasRemarksData,
    rxRemarksAsColumn,
    showRxQuantityColumn,
  ])

  const showHpConsolidatedColumn =
    (showWhen && hasWhenData) ||
    (showFrequency && hasFrequencyData) ||
    (showDuration && hasDurationData) ||
    (showNotes && hasNotesData)

  const hpTableVisibleColumnsSet = useMemo(() => {
    const visibleSet = new Set()
    if (shouldShowDrugNameInPrint) visibleSet.add('drug_name')
    if (showDosage && hasDosageData) visibleSet.add('dosage')
    if (showHpConsolidatedColumn) visibleSet.add('hpConsolidatedColumn')

    if (visibleSet.size === 0) {
      visibleSet.add('drug_name')
    }

    return visibleSet
  }, [shouldShowDrugNameInPrint, showDosage, hasDosageData, showHpConsolidatedColumn])

  const activeTableVisibleColumnsSet =
    drugAdviceTableType === DRUG_ADVICE_TABLE_TYPES.HP.id
      ? hpTableVisibleColumnsSet
      : defaultTableVisibleColumnsSet

  if (filteredDrugsAdvice?.length > 0) {
    // Use switch statement for cleaner code organization
    switch (drugAdviceTableType) {
      case DRUG_ADVICE_TABLE_TYPES.list.id: {
        // List format: render each drug on separate lines (not table)
        return (
        <PMPBodySectionItems
          ref={drugAdviceTableRef}
          debug={debug}
          debugColor={PRESCRIPTION_COLORS_MAP.drugAdvice?.color}
          debugHighlight={debugHighlightStates?.drugAdvice}
          borderLeft={styleOverrides?.borderLeft}
          paddingLeft={styleOverrides?.paddingLeft}
          style={{
            width: '100%',
            maxWidth: '100%',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              paddingTop: '10px',
              fontWeight: 600,
              fontSize: `${styleOverrides?.headingFontSize || 16}px`,
              color: styleOverrides?.headingColor || styleOverrides?.color || 'inherit',
            }}
          >
            {getCasedHeadingTextBasedOnStyleOverrides({
              headingText: (() => {
                // Intelligent title: "Rx" for single chunk or last single item, "Rx (1-5 of 10)" for multiple chunks
                if (chunkRange && chunkRange.startRow && chunkRange.endRow && totalDrugs > 0) {
                  // Case 1: Full chunk (all items from 1 to totalDrugs)
                  const isFullChunk = chunkRange.startRow === 1 && chunkRange.endRow === totalDrugs
                  if (isFullChunk) {
                    return 'Rx' // Single chunk with all items
                  }
                  // Case 2: Last single item (e.g., 12 of 12) - no need for numbering
                  if (chunkRange.startRow === chunkRange.endRow && chunkRange.endRow === totalDrugs) {
                    return 'Rx'
                  }
                  const rangeText = chunkRange.startRow === chunkRange.endRow 
                    ? `${chunkRange.startRow}` 
                    : `${chunkRange.startRow}-${chunkRange.endRow}`
                  return `Rx (${rangeText} of ${totalDrugs})`
                }
                return 'Rx'
              })(),
              styleOverrides,
            })}
          </div>

          <div
            style={{
              width: '100%',
              maxWidth: '100%',
              padding: '12px 0',
            }}
          >
            {filteredDrugsAdvice?.map((drugAdviceItem, drugAdviceItemIndex) => {
              const isTaperRow = Boolean(drugAdviceItem?.isTaperContinuation)
              const rowNumberDisplay = getRxRowNumberDisplay(drugAdviceItemIndex)

                const detailParts = []
                const drugName = `${drugAdviceItem?.drugType?.label || ''} ${drugAdviceItem?.drug?.label || ''}`.trim()
                const genericName = isTaperRow ? null : drugAdviceItem?.drug?.genericName
                const showDrugNameForThisRow = shouldShowDrugNameInPrint && drugName

                if (showDosage && drugAdviceItem?.dosage?.label) {
                  const dosageText = drugAdviceItem.drugType?.label
                    ? `${drugAdviceItem.dosage.label} (${drugAdviceItem.drugType.label.toLowerCase()})`
                    : drugAdviceItem.dosage.label
                  detailParts.push(`- ${!showPrescriptionInHindi ? 'Dose' : 'डोज़'}: ${dosageText}`)
                }

                if (showWhen && drugAdviceItem?.whatTime?.label) {
                  detailParts.push(`- ${!showPrescriptionInHindi ? 'When' : 'कब'}: ${drugAdviceItem.whatTime.label}`)
                }

                if (showFrequency && drugAdviceItem?.frequency?.label) {
                  detailParts.push(`- ${!showPrescriptionInHindi ? 'Frequency' : 'आवृत्ति'}: ${drugAdviceItem.frequency.label}`)
                }

                if (showDuration && drugAdviceItem?.duration?.label) {
                  detailParts.push(`- ${!showPrescriptionInHindi ? 'Duration' : 'अवधि'}: ${drugAdviceItem.duration.label}`)
                }

                const primaryText = showDrugNameForThisRow
                  ? drugName
                  : detailParts.shift() || drugName

              return (
                <div
                  key={drugAdviceItemIndex}
                  style={{
                    marginBottom: drugAdviceItemIndex + 1 === filteredDrugsAdvice?.length ? '0' : '6px',
                    paddingBottom: drugAdviceItemIndex + 1 === filteredDrugsAdvice?.length ? '0' : '6px',
                  }}
                >
                  <div
                    style={{
                      fontSize: styleOverrides?.fontSizePixels
                        ? `${styleOverrides?.fontSizePixels}px`
                        : '14px',
                      color: rxColorStyles.medicineText,
                      lineHeight: '1.4',
                    }}
                  >
                    <div style={{ fontWeight: isCellBold ? '600' : '400', marginBottom: '2px' }}>
                      <span className="fw-light" style={{ marginRight: '4px' }}>
                        {isTaperRow ? '↳' : `${rowNumberDisplay}.)`}
                      </span>
                        <span style={{ textTransform: showDrugNameForThisRow && showDrugsInCaps ? 'uppercase' : 'none' }}>
                          {primaryText || ''}
                        </span>
                        {isTaperRow && taperContinuationMarker()}
                        {showDrugNameForThisRow && genericName && (
                          <span
                            style={{
                              fontSize: genericDrugStyles?.fontSizePixels
                                ? `${genericDrugStyles?.fontSizePixels}px`
                              : '11px',
                            color: genericDrugStyles?.color || rxColorStyles.genericText,
                            textTransform: 'capitalize',
                            marginLeft: '6px',
                            fontWeight: '400',
                            }}
                          >
                            ({genericName})
                          </span>
                        )}
                      </div>
                      {detailParts.length > 0 && (
                        <div style={{ paddingLeft: '20px', marginTop: '2px' }}>
                          {detailParts.map((part, idx) => (
                            <div key={idx} style={{ marginBottom: '1px' }}>
                              {part}
                            </div>
                          ))}
                        </div>
                      )}
                      {showNotes && drugAdviceItem?.notes?.label && (
                      <div
                        style={{
                          marginTop: '4px',
                          paddingLeft: '20px',
                          fontSize: styleOverrides?.fontSizePixels
                            ? `${styleOverrides?.fontSizePixels}px`
                            : '13px',
                          color: rxColorStyles.notesText,
                          fontStyle: 'italic',
                        }}
                      >
                        <span style={{ fontWeight: '600', marginRight: '8px' }}>
                          {!showPrescriptionInHindi ? 'Note:' : 'टिप्पणी:'}
                        </span>
                        {drugAdviceItem.notes.label}
                      </div>
                    )}
                      {getRowExplainerForPrint(drugAdviceItem, drugAdviceItemIndex) && (
                        <div
                          style={{
                            marginTop: '2px',
                            paddingLeft: '20px',
                            fontSize: styleOverrides?.fontSizePixels
                              ? `${Math.max(styleOverrides?.fontSizePixels - 2, 9)}px`
                              : '11px',
                            color: rxColorStyles.genericText,
                            fontStyle: 'italic',
                          }}
                        >
                          {getRowExplainerForPrint(drugAdviceItem, drugAdviceItemIndex)}
                        </div>
                      )}
                  </div>
                </div>
              )
            })}
          </div>
        </PMPBodySectionItems>
      )
      }

      case DRUG_ADVICE_TABLE_TYPES.paragraphList.id: {
        // Paragraph List format: render each drug as a single compact paragraph
        return (
        <PMPBodySectionItems
          ref={drugAdviceTableRef}
          debug={debug}
          debugColor={PRESCRIPTION_COLORS_MAP.drugAdvice?.color}
          debugHighlight={debugHighlightStates?.drugAdvice}
          borderLeft={styleOverrides?.borderLeft}
          paddingLeft={styleOverrides?.paddingLeft}
          style={{
            width: '100%',
            maxWidth: '100%',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              paddingTop: '10px',
              fontWeight: 600,
              fontSize: `${styleOverrides?.headingFontSize || 16}px`,
              color: styleOverrides?.headingColor || styleOverrides?.color || 'inherit',
            }}
          >
            {getCasedHeadingTextBasedOnStyleOverrides({
              headingText: (() => {
                // Intelligent title for list format
                if (chunkRange && chunkRange.startRow && chunkRange.endRow && totalDrugs > 0) {
                  // Case 1: Full chunk (all items from 1 to totalDrugs)
                  const isFullChunk = chunkRange.startRow === 1 && chunkRange.endRow === totalDrugs
                  if (isFullChunk) {
                    return 'Rx'
                  }
                  // Case 2: Last single item (e.g., 12 of 12) - no need for numbering
                  if (chunkRange.startRow === chunkRange.endRow && chunkRange.endRow === totalDrugs) {
                    return 'Rx'
                  }
                  const rangeText = chunkRange.startRow === chunkRange.endRow 
                    ? `${chunkRange.startRow}` 
                    : `${chunkRange.startRow}-${chunkRange.endRow}`
                  return `Rx (${rangeText} of ${totalDrugs})`
                }
                return 'Rx'
              })(),
              styleOverrides,
            })}
          </div>

          <div
            style={{
              width: '100%',
              maxWidth: '100%',
              padding: '12px 0',
            }}
          >
            {filteredDrugsAdvice?.map((drugAdviceItem, drugAdviceItemIndex) => {
              const isTaperRow = Boolean(drugAdviceItem?.isTaperContinuation)
              const rowNumberDisplay = getRxRowNumberDisplay(drugAdviceItemIndex)

              const drugName = `${drugAdviceItem?.drugType?.label || ''} ${drugAdviceItem?.drug?.label || ''}`.trim()
              const genericName = isTaperRow ? null : drugAdviceItem?.drug?.genericName
              const dosage = drugAdviceItem?.dosage?.label
              const drugType = drugAdviceItem?.drugType?.label
              const when = drugAdviceItem?.whatTime?.label
              const frequency = drugAdviceItem?.frequency?.label
                const duration = drugAdviceItem?.duration?.label
                const notes = drugAdviceItem?.notes?.label
                const hasVisibleParagraphDetails =
                  (showDosage && dosage) ||
                  (showWhen && when) ||
                  (showFrequency && frequency) ||
                  (showDuration && duration) ||
                  (showNotes && notes)
                const showParagraphDrugName = shouldShowDrugNameInPrint || !hasVisibleParagraphDetails

                return (
                <div
                  key={drugAdviceItemIndex}
                  style={{
                    marginBottom: drugAdviceItemIndex + 1 === filteredDrugsAdvice?.length ? '0' : '10px',
                    fontSize: styleOverrides?.fontSizePixels
                      ? `${styleOverrides?.fontSizePixels}px`
                      : '13px',
                    color: rxColorStyles.medicineText,
                    lineHeight: '1.7',
                    paddingBottom: drugAdviceItemIndex + 1 === filteredDrugsAdvice?.length ? '0' : '8px',
                  }}
                >
                  {/* First line: Row number, Drug name, and all details */}
                  <div style={{ display: 'block' }}>
                    <span className="fw-light" style={{ marginRight: '8px', fontSize: '0.9em', fontWeight: '500' }}>
                      {isTaperRow ? '↳' : `${rowNumberDisplay}.)`}
                    </span>

                      {showParagraphDrugName && (
                        <span
                          style={{
                            fontWeight: '700',
                            textTransform: showDrugsInCaps ? 'uppercase' : 'none',
                            fontSize: '1em',
                            marginRight: '10px',
                          }}
                        >
                          {drugName}
                          {isTaperRow && taperContinuationMarker()}
                        </span>
                      )}

                      {/* Dosage - Bold */}
                      {showDosage && dosage && (
                      <>
                        <span style={{ fontWeight: '600', marginRight: '6px' }}>
                          {!showPrescriptionInHindi ? 'Dose:' : 'डोज़:'}
                        </span>
                        <span style={{ fontWeight: '500', marginRight: '14px' }}>
                          {dosage}
                          {drugType && (
                            <span style={{ fontSize: '0.9em', fontWeight: '400', marginLeft: '4px' }}>
                              ({drugType.toLowerCase()})
                            </span>
                          )}
                        </span>
                      </>
                    )}

                      {/* When - Italic, Smaller */}
                      {showWhen && when && (
                      <>
                        <span style={{ fontStyle: 'italic', fontSize: '0.9em', marginRight: '6px' }}>
                          {!showPrescriptionInHindi ? 'When:' : 'कब:'}
                        </span>
                        <span style={{ textTransform: 'capitalize', fontStyle: 'italic', marginRight: '14px' }}>
                          {when}
                        </span>
                      </>
                    )}

                      {/* Frequency - Bold, Uppercase */}
                      {showFrequency && frequency && (
                      <>
                        <span style={{ fontWeight: '600', fontSize: '0.95em', marginRight: '6px' }}>
                          {!showPrescriptionInHindi ? 'Freq:' : 'आवृत्ति:'}
                        </span>
                        <span style={{ fontWeight: '600', textTransform: 'uppercase', fontSize: '0.9em', marginRight: '14px' }}>
                          {frequency}
                        </span>
                      </>
                    )}

                      {/* Duration - Bold */}
                      {showDuration && duration && (
                      <>
                        <span style={{ fontWeight: '600', marginRight: '6px' }}>
                          {!showPrescriptionInHindi ? 'Duration:' : 'अवधि:'}
                        </span>
                        <span style={{ fontWeight: '600', marginRight: '14px' }}>
                          {duration}
                        </span>
                      </>
                    )}

                      {/* Notes - Italic, Smaller, Different Color */}
                      {showNotes && notes && (
                      <>
                        <span
                          style={{
                            fontStyle: 'italic',
                            fontSize: '0.9em',
                            color: rxColorStyles.notesText,
                            marginLeft: '8px',
                            marginRight: '6px',
                          }}
                        >
                          {!showPrescriptionInHindi ? 'Note:' : 'टिप्पणी:'}
                        </span>
                        <span
                          style={{
                            fontStyle: 'italic',
                            fontSize: '0.9em',
                            color: rxColorStyles.notesText,
                            marginLeft: '0',
                          }}
                        >
                          {notes}
                        </span>
                      </>
                    )}
                    </div>

                    {/* Second line: Generic Name - Italic, Smaller, Indented */}
                    {showParagraphDrugName && genericName && (
                    <div
                      style={{
                        display: 'block',
                        marginTop: '4px',
                        paddingLeft: '24px', // Indent to align with content after row number
                        fontSize: '0.85em',
                        color: genericDrugStyles?.color || rxColorStyles.genericText,
                        fontStyle: 'italic',
                      }}
                    >
                      ({genericName})
                    </div>
                  )}
                    {getRowExplainerForPrint(drugAdviceItem, drugAdviceItemIndex) && (
                      <div
                        style={{
                          display: 'block',
                          marginTop: '2px',
                          paddingLeft: '24px',
                          fontSize: '0.85em',
                          color: rxColorStyles.genericText,
                          fontStyle: 'italic',
                        }}
                      >
                        {getRowExplainerForPrint(drugAdviceItem, drugAdviceItemIndex)}
                      </div>
                    )}
                </div>
              )
            })}
          </div>
        </PMPBodySectionItems>
      )
      }

      case DRUG_ADVICE_TABLE_TYPES.default.id:
      case DRUG_ADVICE_TABLE_TYPES.HP.id:
      default: {
        // Table format: default and HP types
        return (
      <PMPBodySectionItems
        ref={drugAdviceTableRef}
        debug={debug}
        debugColor={PRESCRIPTION_COLORS_MAP.drugAdvice?.color}
        debugHighlight={debugHighlightStates?.drugAdvice}
        borderLeft={styleOverrides?.borderLeft}
        paddingLeft={styleOverrides?.paddingLeft}
        style={{
          width: '100%',
          maxWidth: '100%',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            paddingTop: '10px',
            fontWeight: 600,
            fontSize: `${styleOverrides?.headingFontSize || 16}px`,
            color: styleOverrides?.headingColor || styleOverrides?.color || 'inherit',
          }}
        >
          {getCasedHeadingTextBasedOnStyleOverrides({
            headingText: (() => {
              // Intelligent title for table format (default/HP)
              if (chunkRange && chunkRange.startRow && chunkRange.endRow && totalDrugs > 0) {
                // Case 1: Full chunk (all items from 1 to totalDrugs)
                const isFullChunk = chunkRange.startRow === 1 && chunkRange.endRow === totalDrugs
                if (isFullChunk) {
                  return 'Rx'
                }
                // Case 2: Last single item (e.g., 12 of 12) - no need for numbering
                if (chunkRange.startRow === chunkRange.endRow && chunkRange.endRow === totalDrugs) {
                  return 'Rx'
                }
                const rangeText = chunkRange.startRow === chunkRange.endRow 
                  ? `${chunkRange.startRow}` 
                  : `${chunkRange.startRow}-${chunkRange.endRow}`
                return `Rx (${rangeText} of ${totalDrugs})`
              }
              return 'Rx'
            })(),
            styleOverrides,
          })}
        </div>

        <div
          style={{
            width: '100%',
            maxWidth: '100%',
            overflowX: 'hidden',
            overflowY: 'visible',
            boxSizing: 'border-box',
          }}
        >
          <PMPSingleRowForDrugs
          isHeaderRow
          colorMode={colorMode}
          style={getRxHeaderRowStyle({
            width: '100%',
            margin: '0 auto',
            fontSize: styleOverrides?.fontSizePixels
              ? `${styleOverrides?.fontSizePixels}px`
              : '14px',
            color: rxColorStyles.headerText,
            fontWeight: '700',
            letterSpacing: '0.3px',
          })}
        >
            {shouldShowDrugNameInPrint && (
            <PMPSingleRowBox
              colorMode={colorMode}
              style={getRxCellStyle(rxColorStyles.headerText, {
                ...debugStyles,
                width: getPercentageOfItemForDrugTableCellWidth(
                  'drug_name',
                  100,
                  activeTableVisibleColumnsSet,
                ),
                maxWidth: getPercentageOfItemForDrugTableCellWidth(
                  'drug_name',
                  100,
                  activeTableVisibleColumnsSet,
                ),
                boxSizing: 'border-box',
                overflow: 'hidden',
                textAlign: 'center',
              }, { header: true })}
              borderRight={!isOpenRxTable}
              noFlex
            >
              {!showPrescriptionInHindi ? 'Medicine' : 'दवाएँ'}
            </PMPSingleRowBox>
          )}

          {showDosage && hasDosageData && (
            <PMPSingleRowBox
              colorMode={colorMode}
              style={getRxCellStyle(rxColorStyles.headerText, {
                ...debugStyles,
                width: getPercentageOfItemForDrugTableCellWidth(
                  'dosage',
                  100,
                  activeTableVisibleColumnsSet,
                ),
                maxWidth: getPercentageOfItemForDrugTableCellWidth(
                  'dosage',
                  100,
                  activeTableVisibleColumnsSet,
                ),
                boxSizing: 'border-box',
                overflow: 'hidden',
                textAlign: 'center',
              }, { header: true })}
              borderRight={!isOpenRxTable}
              noFlex
            >
              {!showPrescriptionInHindi ? 'Dose' : 'डोज़'}
            </PMPSingleRowBox>
          )}

          {drugAdviceTableType !== DRUG_ADVICE_TABLE_TYPES.HP.id ? (
            <>
              {defaultTableVisibleColumnsSet.has('freqWhen') && (
                <PMPSingleRowBox
                  colorMode={colorMode}
                  style={getRxCellStyle(rxColorStyles.headerText, {
                    ...debugStyles,
                    width: getPercentageOfItemForDrugTableCellWidth(
                      'freqWhen',
                      100,
                      activeTableVisibleColumnsSet,
                    ),
                    maxWidth: getPercentageOfItemForDrugTableCellWidth(
                      'freqWhen',
                      100,
                      activeTableVisibleColumnsSet,
                    ),
                    boxSizing: 'border-box',
                    overflow: 'hidden',
                    position: 'relative',
                    zIndex: 25,
                    textAlign: 'center',
                  }, { header: true })}
                  borderRight={!isOpenRxTable}
                  noFlex
                >
                  {!showPrescriptionInHindi ? 'Frequency' : 'आवृत्ति'}
                </PMPSingleRowBox>
              )}

              {showDuration && hasDurationData && (
                <PMPSingleRowBox
                  colorMode={colorMode}
                  style={getRxCellStyle(rxColorStyles.headerText, {
                    ...debugStyles,
                    width: getPercentageOfItemForDrugTableCellWidth(
                      'duration',
                      100,
                      activeTableVisibleColumnsSet,
                    ),
                    maxWidth: getPercentageOfItemForDrugTableCellWidth(
                      'duration',
                      100,
                      activeTableVisibleColumnsSet,
                    ),
                    boxSizing: 'border-box',
                    overflow: 'hidden',
                    textAlign: 'center',
                  }, { header: true })}
                  borderRight={!isOpenRxTable}
                  noFlex
                >
                  {!showPrescriptionInHindi ? 'Duration' : 'अवधि'}
                </PMPSingleRowBox>
              )}

              {defaultTableVisibleColumnsSet.has('remarks') && (
                <PMPSingleRowBox
                  colorMode={colorMode}
                  style={getRxCellStyle(rxColorStyles.headerText, {
                    ...debugStyles,
                    width: getPercentageOfItemForDrugTableCellWidth(
                      'remarks',
                      100,
                      activeTableVisibleColumnsSet,
                    ),
                    maxWidth: getPercentageOfItemForDrugTableCellWidth(
                      'remarks',
                      100,
                      activeTableVisibleColumnsSet,
                    ),
                    boxSizing: 'border-box',
                    overflow: 'hidden',
                    textAlign: 'center',
                  }, { header: true })}
                  borderRight={!isOpenRxTable}
                  noFlex
                >
                  {!showPrescriptionInHindi ? 'Remarks' : 'टिप्पणी'}
                </PMPSingleRowBox>
              )}

              {defaultTableVisibleColumnsSet.has('quantity') && (
                <PMPSingleRowBox
                  colorMode={colorMode}
                  style={getRxCellStyle(rxColorStyles.headerText, {
                    ...debugStyles,
                    width: getPercentageOfItemForDrugTableCellWidth(
                      'quantity',
                      100,
                      activeTableVisibleColumnsSet,
                    ),
                    maxWidth: getPercentageOfItemForDrugTableCellWidth(
                      'quantity',
                      100,
                      activeTableVisibleColumnsSet,
                    ),
                    boxSizing: 'border-box',
                    overflow: 'hidden',
                    textAlign: 'center',
                  }, { header: true })}
                  borderRight={!isOpenRxTable}
                  noFlex
                >
                  {!showPrescriptionInHindi ? 'Quantity' : 'मात्रा'}
                </PMPSingleRowBox>
              )}

              {/* Notes folded into the Remarks column above */}
            </>
          ) : (
            <>
                {showHpConsolidatedColumn && (
                <PMPSingleRowBox
                  style={getRxCellStyle(rxColorStyles.headerText, {
                    ...debugStyles,
                    width: getPercentageOfItemForDrugTableCellWidth(
                      'hpConsolidatedColumn',
                      100,
                      hpTableVisibleColumnsSet,
                    ),
                  }, { header: true })}
                  borderRight={!isOpenRxTable}
                >
                  {buildHpRowItem({
                    showWhen: showWhen && hasWhenData,
                    showDuration: showDuration && hasDurationData,
                    showFrequency: showFrequency && hasFrequencyData,
                    showNotes: showNotes && hasNotesData,
                    isHeader: true,
                  })}
                </PMPSingleRowBox>
                )}
            </>
          )}
        </PMPSingleRowForDrugs>
        {filteredDrugsAdvice?.map((drugAdviceItem, drugAdviceItemIndex) => {
          const isTaperRow = Boolean(drugAdviceItem?.isTaperContinuation)
          const rowNumberDisplay = getRxRowNumberDisplay(drugAdviceItemIndex)

          return (
            <React.Fragment key={drugAdviceItemIndex}>
              <PMPSingleRowForDrugs
                isLastRow={drugAdviceItemIndex + 1 === filteredDrugsAdvice?.length}
                colorMode={colorMode}
                rowIndex={drugAdviceItemIndex}
                style={getRxBodyRowStyle(drugAdviceItemIndex, { width: '100%', margin: '0 auto' })}
              >
              {shouldShowDrugNameInPrint && (
                <PMPSingleRowBox
                  colorMode={colorMode}
                  style={getRxCellStyle(rxColorStyles.medicineText, {
                    ...debugStyles,
                    width: getPercentageOfItemForDrugTableCellWidth(
                      'drug_name',
                      100,
                      activeTableVisibleColumnsSet,
                    ),
                    maxWidth: getPercentageOfItemForDrugTableCellWidth(
                      'drug_name',
                      100,
                      activeTableVisibleColumnsSet,
                    ),
                    boxSizing: 'border-box',
                    overflow: 'hidden',
                    // taper continuation rows get an accent "rail" on the left so they
                    // read as steps of the medicine above them, not standalone drugs
                    ...(isTaperRow
                      ? {
                          borderLeft: `3px solid ${rxColorStyles.headerText}`,
                          padding: '8px 10px 8px 10px',
                        }
                      : {}),
                  })}
                  whiteBG
                  borderRight={!isOpenRxTable}
                  isCellBold={isCellBold}
                  isCellCapitalized={showDrugsInCaps}
                  noFlex
                >
                  <div style={{ width: '100%', minWidth: 0, maxWidth: '100%', boxSizing: 'border-box' }}>
                    {isTaperRow ? (
                      // Continuation step of the medicine above: lead with an accent
                      // "↳ then" connector, then repeat the drug name de-emphasized so
                      // the new dose/frequency/duration in this row read as the next phase.
                      <div style={{ display: 'block', wordBreak: 'break-word', overflowWrap: 'break-word', width: '100%', maxWidth: '100%' }}>
                        <span
                          style={{
                            color: rxColorStyles.headerText,
                            fontWeight: 600,
                            fontStyle: 'italic',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          ↳ {!showPrescriptionInHindi ? 'then' : 'फिर'}
                        </span>{' '}
                        <span style={{ fontWeight: 400, color: rxColorStyles.genericText }}>
                          {drugAdviceItem?.drugType?.label || ''} {drugAdviceItem?.drug?.label}
                        </span>
                      </div>
                    ) : (
                      <>
                        <div style={{ display: 'block', wordBreak: 'break-word', overflowWrap: 'break-word', width: '100%', maxWidth: '100%' }}>
                          <span className="fw-light">{`${rowNumberDisplay}.)`}</span>{' '}
                          <span style={{ fontWeight: 700 }}>
                            {drugAdviceItem?.drugType?.label || ''} {drugAdviceItem?.drug?.label}
                          </span>
                        </div>
                        {drugAdviceItem?.drug?.genericName && (
                          <div
                            style={{
                              // generic name sits in the SAME cell, in regular weight and
                              // a readable size right under the bold medicine name (no chip)
                              fontSize: genericDrugStyles?.fontSizePixels
                                ? `${genericDrugStyles?.fontSizePixels}px`
                                : styleOverrides?.fontSizePixels
                                ? `${styleOverrides?.fontSizePixels}px`
                                : '13px',
                              fontWeight: 400,
                              color: genericDrugStyles?.color || rxColorStyles.genericText,
                              textTransform: 'capitalize',
                              wordBreak: 'break-word',
                              overflowWrap: 'break-word',
                              maxWidth: '100%',
                              display: 'block',
                              marginTop: '2px',
                              width: '100%',
                              boxSizing: 'border-box',
                              whiteSpace: 'normal',
                            }}
                          >
                            {drugAdviceItem?.drug?.genericName}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </PMPSingleRowBox>
              )}
              {showDosage && hasDosageData && (
                <PMPSingleRowBox
                  colorMode={colorMode}
                  style={getRxCellStyle(rxColorStyles.doseText, {
                    ...debugStyles,
                    width: getPercentageOfItemForDrugTableCellWidth(
                      'dosage',
                      100,
                      activeTableVisibleColumnsSet,
                    ),
                    maxWidth: getPercentageOfItemForDrugTableCellWidth(
                      'dosage',
                      100,
                      activeTableVisibleColumnsSet,
                    ),
                    boxSizing: 'border-box',
                    overflow: 'hidden',
                    textAlign: 'center',
                  })}
                  whiteBG
                  borderRight={!isOpenRxTable}
                  noFlex
                >
                  {drugAdviceItem?.dosage?.label ? (
                    <>
                      {drugAdviceItem?.dosage?.label}{' '}
                      {drugAdviceItem?.drugType?.label
                        ? `(${drugAdviceItem?.drugType?.label.toLowerCase()})`
                        : ''}
                    </>
                  ) : (
                    ''
                  )}
                </PMPSingleRowBox>
              )}
              {drugAdviceTableType !== DRUG_ADVICE_TABLE_TYPES.HP.id ? (
                <>
                  {defaultTableVisibleColumnsSet.has('freqWhen') && (
                    <PMPSingleRowBox
                  colorMode={colorMode}
                      style={getRxCellStyle(rxColorStyles.frequencyText, {
                        ...debugStyles,
                        width: getPercentageOfItemForDrugTableCellWidth(
                          'freqWhen',
                          100,
                          activeTableVisibleColumnsSet,
                        ),
                        maxWidth: getPercentageOfItemForDrugTableCellWidth(
                          'freqWhen',
                          100,
                          activeTableVisibleColumnsSet,
                        ),
                        boxSizing: 'border-box',
                        overflow: 'hidden',
                        position: 'relative',
                        zIndex: 10,
                        textAlign: 'center',
                      })}
                      whiteBG
                      borderRight={!isOpenRxTable}
                      noFlex
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          textAlign: 'center',
                          width: '100%',
                        }}
                      >
                        {showFrequency && drugAdviceItem?.frequency?.label && (
                          <span
                            style={{
                              fontWeight: 600,
                              color: rxColorStyles.frequencyText,
                              wordBreak: 'break-word',
                              overflowWrap: 'break-word',
                              whiteSpace: 'normal',
                            }}
                          >
                            {drugAdviceItem?.frequency?.label}
                          </span>
                        )}
                        {showWhen && drugAdviceItem?.whatTime?.label && (
                          <span
                            style={{
                              fontWeight: 400,
                              color: rxColorStyles.whenText,
                              textTransform: 'capitalize',
                              marginTop: drugAdviceItem?.frequency?.label ? '2px' : 0,
                              wordBreak: 'break-word',
                              overflowWrap: 'break-word',
                              whiteSpace: 'normal',
                            }}
                          >
                            {drugAdviceItem?.whatTime?.label}
                          </span>
                        )}
                      </div>
                    </PMPSingleRowBox>
                  )}

                  {showDuration && hasDurationData && (
                    <PMPSingleRowBox
                  colorMode={colorMode}
                      style={getRxCellStyle(rxColorStyles.durationText, {
                        ...debugStyles,
                        width: getPercentageOfItemForDrugTableCellWidth(
                          'duration',
                          100,
                          activeTableVisibleColumnsSet,
                        ),
                        maxWidth: getPercentageOfItemForDrugTableCellWidth(
                          'duration',
                          100,
                          activeTableVisibleColumnsSet,
                        ),
                        boxSizing: 'border-box',
                        overflow: 'hidden',
                        textAlign: 'center',
                      })}
                      whiteBG
                      borderRight={!isOpenRxTable}
                      noFlex
                    >
                      <span style={{ fontWeight: 600 }}>{drugAdviceItem?.duration?.label}</span>
                    </PMPSingleRowBox>
                  )}

                  {defaultTableVisibleColumnsSet.has('remarks') && (() => {
                    const remarkNote = getRemarkNoteForPrint(drugAdviceItem)
                    const remarkExplainer = getRemarkExplainerForPrint(
                      drugAdviceItem,
                      drugAdviceItemIndex,
                    )
                    return (
                      <PMPSingleRowBox
                        colorMode={colorMode}
                        style={getRxCellStyle(rxColorStyles.notesText, {
                          ...debugStyles,
                          width: getPercentageOfItemForDrugTableCellWidth(
                            'remarks',
                            100,
                            activeTableVisibleColumnsSet,
                          ),
                          maxWidth: getPercentageOfItemForDrugTableCellWidth(
                            'remarks',
                            100,
                            activeTableVisibleColumnsSet,
                          ),
                          boxSizing: 'border-box',
                          overflow: 'hidden',
                          fontSize: styleOverrides?.fontSizePixels
                            ? `${Math.max(styleOverrides?.fontSizePixels - 1, 10)}px`
                            : '12px',
                        })}
                        whiteBG
                        borderRight={!isOpenRxTable}
                        noFlex
                      >
                        <div style={{ width: '100%', minWidth: 0, maxWidth: '100%', boxSizing: 'border-box' }}>
                          {remarkNote && (
                            <div style={{ marginBottom: remarkExplainer ? '2px' : '0' }}>
                              <span style={{ fontWeight: 600 }}>
                                {!showPrescriptionInHindi ? 'Note: ' : 'टिप्पणी: '}
                              </span>
                              {remarkNote}
                            </div>
                          )}
                          {remarkExplainer && (
                            <div style={{ fontStyle: 'italic', color: rxColorStyles.genericText }}>
                              {remarkExplainer}
                            </div>
                          )}
                        </div>
                      </PMPSingleRowBox>
                    )
                  })()}

                  {defaultTableVisibleColumnsSet.has('quantity') && (
                    <PMPSingleRowBox
                      colorMode={colorMode}
                      style={getRxCellStyle(rxColorStyles.doseText, {
                        ...debugStyles,
                        width: getPercentageOfItemForDrugTableCellWidth(
                          'quantity',
                          100,
                          activeTableVisibleColumnsSet,
                        ),
                        maxWidth: getPercentageOfItemForDrugTableCellWidth(
                          'quantity',
                          100,
                          activeTableVisibleColumnsSet,
                        ),
                        boxSizing: 'border-box',
                        overflow: 'hidden',
                        textAlign: 'center',
                      })}
                      whiteBG
                      borderRight={!isOpenRxTable}
                      noFlex
                    >
                      {computeRxQuantity(drugAdviceItem)}
                    </PMPSingleRowBox>
                  )}
                </>
              ) : (
                <>
                    {showHpConsolidatedColumn && (
                    <PMPSingleRowBox
                    colorMode={colorMode}
                      style={getRxCellStyle(rxColorStyles.frequencyText, {
                        ...debugStyles,
                        width: getPercentageOfItemForDrugTableCellWidth(
                          'hpConsolidatedColumn',
                          100,
                          hpTableVisibleColumnsSet,
                        ),
                      })}
                      whiteBG
                    borderRight={!isOpenRxTable}
                  >
                      {buildHpRowItem({
                        showWhen: showWhen && hasWhenData,
                        showDuration: showDuration && hasDurationData,
                        showFrequency: showFrequency && hasFrequencyData,
                        showNotes: showNotes && hasNotesData,
                        drugAdviceItem,
                      })}
                    </PMPSingleRowBox>
                    )}
                </>
              )}
            </PMPSingleRowForDrugs>
            {/* For the quantity presets without a Remarks column (boxedQty / openQty),
                the patient sentence + any note render as a full-width sub-row below the
                medicine, with a "Nil" fallback so the layout stays consistent. */}
            {rxRemarksAsSubRow && (() => {
              const remarkNote = getRemarkNoteForPrint(drugAdviceItem)
              const remarkExplainer = getRemarkExplainerForPrint(
                drugAdviceItem,
                drugAdviceItemIndex,
              )
              const remarkText = [remarkNote, remarkExplainer].filter(Boolean).join(' ')
              return (
                <PMPSingleRowForDrugs
                  colorMode={colorMode}
                  style={getRxBodyRowStyle(drugAdviceItemIndex, { width: '100%', margin: '0 auto' })}
                >
                  <PMPSingleRowBox
                    colorMode={colorMode}
                    style={getRxCellStyle(rxColorStyles.notesText, {
                      ...debugStyles,
                      width: '100%',
                      maxWidth: '100%',
                      boxSizing: 'border-box',
                      overflow: 'hidden',
                      fontSize: styleOverrides?.fontSizePixels
                        ? `${Math.max(styleOverrides?.fontSizePixels - 1, 10)}px`
                        : '12px',
                    })}
                    whiteBG
                    borderRight={false}
                    noFlex
                  >
                    <span style={{ fontWeight: 600 }}>
                      {!showPrescriptionInHindi ? 'Remarks: ' : 'टिप्पणी: '}
                    </span>
                    {remarkText || (!showPrescriptionInHindi ? 'Nil' : 'कोई नहीं')}
                  </PMPSingleRowBox>
                </PMPSingleRowForDrugs>
              )
            })()}
            </React.Fragment>
          )
        })}
        </div>
      </PMPBodySectionItems>
      )
      }
    }
  } else {
    return null
  }
}

export const PrescriptionBodyFirstSection = ({
  selectedObservations,
  selectedComplaints,
  selectedDiagnosis,
  prescriptionData,
  debug = false,
}) => {
  const validDiagnosisList = selectedDiagnosis
  // const validDiagnosisList = getValidDiagnosisArray(selectedDiagnosis)

  var layoutStyles
  var lenOfData = useMemo(() => {
    var len = 0
    if (Array.isArray(selectedObservations) && selectedObservations?.length > 0) {
      len += 1
    }
    if (Array.isArray(selectedComplaints) && selectedComplaints?.length > 0) {
      len += 1
    }
    if (Array.isArray(validDiagnosisList) && validDiagnosisList?.length > 0) {
      len += 1
    }
    return len || 1
  }, [selectedObservations, selectedComplaints, validDiagnosisList])

  switch (prescriptionData?.layout) {
    case PRESCRIPTION_LAYOUTS.largerFontLayout:
      layoutStyles = {
        display: 'grid',
        gridTemplateColumns: `repeat(${lenOfData}, 1fr)`,
        gap: '10px',
        width: '100%',
      }
      break
    default:
      layoutStyles = {}
      break
  }
  return (
    <div style={layoutStyles}>
      {Array.isArray(selectedObservations) && selectedObservations?.length > 0 && (
        <div style={{ background: debug ? PRESCRIPTION_COLORS_MAP.observations?.color : 'unset' }}>
          <strong>Observations</strong>
          <div>{selectedObservations.map((observation) => observation.label).join(', ')}</div>
        </div>
      )}
      {Array.isArray(selectedComplaints) && selectedComplaints?.length > 0 && (
        <div style={{ background: debug ? PRESCRIPTION_COLORS_MAP.complaints?.color : 'unset' }}>
          <strong>Complaints</strong>
          <div>{selectedComplaints.map((complaint) => complaint.label).join(', ')}</div>
        </div>
      )}
      {Array.isArray(getValidDiagnosisArrayForPrescription(selectedDiagnosis)) &&
        getValidDiagnosisArrayForPrescription(selectedDiagnosis)?.length > 0 && (
          <PrintableDiagnosis selectedDiagnosis={selectedDiagnosis} />
        )}
    </div>
  )
}

export const PrescriptionBody = ({
  value,
  setValue,
  placeholder,
  alsoChangePropValue,
  setPropValue,
  selectedTherapies,
  selectedAdvice,
  nextVisitInputType,
  nextVisitInputValue,
  prescriptionData,
  selectedObservations,
  selectedComplaints,
  selectedDiagnosis,
  selectedAssessments,
  drugsAdvice,
  selectedInstructions,
  suggestedBookingTherapy,
  selectedInvestigations,
  jointHomunculusData,
  prescriptionViewSettings,
  debug = false,
  headerHeight,
  footerHeight,
  printType,
  drugEmrSubSections,
  finalRequestedTestsBy,
  referredToDoctorName,
  prescriptionHeight,
  A4Height,
  hidePatientDetails = false,
  patientHistoryNotes,
  emrSections,
}) => {
  var layoutStyles
  var lenOfData = useMemo(() => {
    var len = 0
    if (Array.isArray(selectedObservations) && selectedObservations?.length > 0) {
      len += 1
    }
    if (Array.isArray(selectedComplaints) && selectedComplaints?.length > 0) {
      len += 1
    }
    if (Array.isArray(selectedDiagnosis) && selectedDiagnosis?.length > 0) {
      len += 1
    }
    return len || 1
  }, [selectedObservations, selectedComplaints, selectedDiagnosis])

  const { dimensions: bodyDimensions, ref: prescriptionBodyRef } = useElementDimensions()

  const { dimensions: patientDetailsDimensions, ref: patientDetailsRef } = useElementDimensions()
  const { dimensions: observationDimensions, ref: observationRef } = useElementDimensions()

  const A4SinglePageBodyHeight = A4Height - (headerHeight - footerHeight)

  const breakPointsInPixels = useMemo(() => {
    return getPrescriptionBreaksWithWhereInHeight({
      a4PageHeight: A4SinglePageBodyHeight,
      prescriptionHeight: bodyDimensions?.height,
    })
  }, [])

  switch (prescriptionData?.layout) {
    case PRESCRIPTION_LAYOUTS.largerFontLayout:
      layoutStyles = {
        display: 'grid',
        gridTemplateColumns: `repeat(${lenOfData}, 1fr)`,
        gap: '10px',
        width: '100%',
      }
      break
    default:
      layoutStyles = {}
      break
  }

  const showHomunculus = useMemo(() => {
    return isHomunculusValid(jointHomunculusData)
  }, [jointHomunculusData])

  const NextVisitColumn = useMemo(() => {
    switch (prescriptionData?.layout) {
      case PRESCRIPTION_LAYOUTS.threeColumnFooter:
      case PRESCRIPTION_LAYOUTS.largerFontLayout:
      case PRESCRIPTION_LAYOUTS.twoColumnFooter:
      case PRESCRIPTION_LAYOUTS.twoColumnWithDisclaimerFooter:
      case PRESCRIPTION_LAYOUTS.twoColumnWithDisclaimerFooterWithDegreesInSeperateLines:
      case PRESCRIPTION_LAYOUTS.listPointersFooter:
      case PRESCRIPTION_LAYOUTS.boxHeaderWithTwoColumnFooter:
        return ThreeColumnNextVisitRowComponent
      default:
        return DefaultNextVisitRowComponent
    }
  }, [prescriptionData?.layout])

  useEffect(() => {
    if (alsoChangePropValue) {
      setPropValue(value)
    }
  }, [value])

  return (
    <div ref={prescriptionBodyRef}>
      <PmpBodyContentContainer
        // headerHeight={headerDimensions?.height}
        // footerHeight={footerDimensions?.height}
        headerHeight={headerHeight}
        footerHeight={footerHeight}
        debug={debug}
      >
        {!hidePatientDetails && (
          <div ref={patientDetailsRef}>
            <PmpPatientDetails
              prescriptionData={prescriptionData}
              leaveSpace={printType === PRESCRIPTION_PRINT_TYPES.withHeaderAndFooterBlankSpace}
              debug={debug}
            />
          </div>
        )}
        <PmpContentContainer noPadding debug={debug}>
          <div className="d-flex flex-column gap-3">
            <div
              style={{
                width: '100%',
              }}
            >
              <div style={layoutStyles}>
                {Array.isArray(selectedObservations) && selectedObservations?.length > 0 && (
                  <div
                    style={{
                      background: debug ? PRESCRIPTION_COLORS_MAP.observations?.color : 'unset',
                    }}
                    ref={observationRef}
                  >
                    <strong>Observations</strong>
                    <div>
                      {selectedObservations.map((observation) => observation.label).join(', ')}
                    </div>
                  </div>
                )}
                {Array.isArray(selectedComplaints) && selectedComplaints?.length > 0 && (
                  <div
                    style={{
                      background: debug ? PRESCRIPTION_COLORS_MAP.complaints?.color : 'unset',
                    }}
                  >
                    <strong>Complaints</strong>
                    <div>{selectedComplaints.map((complaint) => complaint.label).join(', ')}</div>
                  </div>
                )}
                {Array.isArray(selectedDiagnosis) && selectedDiagnosis?.length > 0 && (
                  <div
                    style={{
                      background: debug ? PRESCRIPTION_COLORS_MAP.diagnosis?.color : 'unset',
                    }}
                  >
                    <strong>Diagnosis</strong>
                    <div>
                      {selectedDiagnosis.map((diagnosisItem) => diagnosisItem.label).join(', ')}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div
              style={{
                width: '100%',
                background: debug ? PRESCRIPTION_COLORS_MAP.drugAdvice?.color : 'unset',
              }}
            >
              <PrescriptionDrugAdviceTable
                prescriptionData={prescriptionData}
                drugsAdvice={drugsAdvice}
                prescriptionViewSettings={prescriptionViewSettings}
                debug={debug}
                drugAdviceSubSections={drugEmrSubSections}
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              paddingTop: '20px',
            }}
          >
            {Array.isArray(selectedAdvice) && selectedAdvice.length > 0 && (
              <div style={{ background: debug ? PRESCRIPTION_COLORS_MAP.advice.color : 'unset' }}>
                <strong>Advice</strong>
                <div style={{ whiteSpace: 'pre-wrap' }}>
                  {selectedAdvice?.map((item) => item?.label)?.join(', ')}
                </div>
              </div>
            )}
            {Array.isArray(selectedInvestigations) && selectedInvestigations.length > 0 && (
              <PrintableInvestigations
                debug={debug}
                selectedInvestigations={selectedInvestigations}
                finalRequestedTestsBy={finalRequestedTestsBy}
              />
            )}
            {Array.isArray(selectedAssessments) && selectedAssessments?.length > 0 && (
              <PrintableAssessments
                debug={debug}
                debugHighlightStates={{}}
                selectedAssessments={selectedAssessments}
              />
            )}
            {Array.isArray(patientHistoryNotes) &&
              patientHistoryNotes?.length > 0 &&
              checkAndRenderBasedOnEmrSections(
                PRESCRIPTION_ITEM_ORDER_IDS.patientHistoryNotes,
                emrSections,
              ) && (
                <PrintablePatientHistoryNotes
                  patientHistoryNotes={patientHistoryNotes}
                  prescriptionViewSettings={prescriptionViewSettings}
                  debug={debug}
                />
              )}
            {suggestedBookingTherapy && (
              <div
                style={{
                  background: debug ? PRESCRIPTION_COLORS_MAP.selectedTherapy.color : 'unset',
                }}
              >
                <strong>Psychotherapy Recommended:</strong> {suggestedBookingTherapy ? 'Yes' : 'No'}
              </div>
            )}
            {Array.isArray(selectedTherapies) && selectedTherapies.length > 0 && (
              <div
                style={{
                  background: debug ? PRESCRIPTION_COLORS_MAP.suggestedTherapy.color : 'unset',
                }}
              >
                <strong>Suggested Therapies</strong>
                <div>{selectedTherapies?.map((item) => item?.label)?.join(', ')}</div>
              </div>
            )}
            {showHomunculus && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  background: debug ? PRESCRIPTION_COLORS_MAP.homunculus.color : 'unset',
                }}
              >
                <JointHomunculusComponent editable={false} data={jointHomunculusData} />
              </div>
            )}
            {Array.isArray(selectedInstructions) && selectedInstructions.length > 0 && (
              <div
                style={{ background: debug ? PRESCRIPTION_COLORS_MAP.instructions.color : 'unset' }}
              >
                <strong>Advised Instructions</strong>
                <ul className="d-flex flex-column">
                  {selectedInstructions?.map((item, idx) => (
                    <li key={idx}>{item?.label}</li>
                  ))}
                </ul>
              </div>
            )}
            <PrintableReferredToDoctorName
              debug={debug}
              referredToDoctorName={referredToDoctorName}
              prescriptionData={prescriptionData}
              styleOverrides={
                prescriptionViewSettings?.styleOverridesForPrintedEmrSections?.[
                  'referredToDoctorName'
                ]
              }
            />
            <NextVisitColumn
              debug={debug}
              nextVisitInputType={nextVisitInputType}
              nextVisitInputValue={nextVisitInputValue}
              prescriptionData={prescriptionData}
              hideQr
            />
          </div>
        </PmpContentContainer>
      </PmpBodyContentContainer>
    </div>
  )
}

export const PrescriptionFooter = ({
  prescriptionData,
  leaveSpace,
  debug,
  // footerRef,
  prescriptionWidth,
  styleOverrides,
  useCompleteImageLink = false,
  footerHeight, // Add footerHeight prop to use for blank space
  currentPage, // Optional: enables "Page X of Y" in the footer meta bar
  totalPages,
}) => {
  let imageIdToUse = getImageLink(prescriptionData?.footer?.imageId)
  if (useCompleteImageLink) {
    imageIdToUse = prescriptionData?.footer?.imageId
  }
  const location = useLocation()
  const queryString = location.search
  const urlParams = new URLSearchParams(queryString)
  const showQr = urlParams.get('show-qr') || false

  const FooterComponent = useMemo(() => {
    switch (prescriptionData?.layout) {
      case PRESCRIPTION_LAYOUTS.threeColumnFooter:
        return ThreeColumnPrescriptionFooter
      case PRESCRIPTION_LAYOUTS.twoColumnFooter:
        return TwoColumnPrescriptionFooter
      case PRESCRIPTION_LAYOUTS.twoColumnWithDisclaimerFooter:
      case PRESCRIPTION_LAYOUTS.twoColumnWithDisclaimerFooterWithDegreesInSeperateLines:
      case PRESCRIPTION_LAYOUTS.boxHeaderWithTwoColumnFooter:
        return TwoColumnPrescriptionWithDisclaimerFooter
      case PRESCRIPTION_LAYOUTS.listPointersFooter:
        return ListPointersFooter
      case PRESCRIPTION_LAYOUTS.twoDoctorHeaderWithListPointers:
        return ListPointerCenerAligned
      default:
        return DefaultPrescriptionFooter
    }
  }, [prescriptionData?.layout])

  if (prescriptionData?.layout === PRESCRIPTION_LAYOUTS.manasthan) {
    return <></>
  }

  if (leaveSpace) {
    // Use footerHeight from print settings, fallback to 120px if not provided
    const blankFooterHeight = typeof footerHeight === 'number' ? `${footerHeight}px` : (footerHeight || '120px')
    const blankFooterHeightNum = typeof footerHeight === 'number' ? footerHeight : 120
    
    return (
      <div 
        className="blank-footer-space" 
        style={{ 
          height: blankFooterHeight, 
          minHeight: blankFooterHeight, 
          maxHeight: blankFooterHeight,
          width: '100%',
          display: 'block', 
          visibility: 'visible', 
          boxSizing: 'border-box', 
          flexShrink: 0,
          flexGrow: 0,
          flex: `0 0 ${blankFooterHeight}`,
          backgroundColor: 'transparent',
          border: '1px solid transparent',
          margin: 0,
          padding: 0,
          overflow: 'hidden',
          position: 'relative',
        }}
        aria-hidden="true"
        data-footer-height={blankFooterHeightNum}
      >
        {/* Invisible spacer with zero-width space to prevent collapse */}
        <span style={{ 
          display: 'inline-block', 
          height: blankFooterHeight, 
          width: '1px', 
          opacity: 0, 
          visibility: 'hidden', 
          position: 'absolute', 
          fontSize: '1px', 
          lineHeight: blankFooterHeight 
        }}>&#8203;</span>
      </div>
    )
  }

  // Footer has three modes (footer.footerMode), with a derived fallback for templates that
  // predate the explicit field:
  //   auto   → the auto-sizing PrintFooterMetaBar (no DefaultPrescriptionFooter, so no hard
  //            border line and it hugs its content)
  //   image  → the uploaded footer image
  //   custom → the hand-authored headline/subtext footer (FooterComponent)
  const footerMode = deriveFooterMode(prescriptionData?.footer)

  if (footerMode === FOOTER_MODES.auto) {
    return (
      <PrintFooterMetaBar
        prescriptionData={prescriptionData}
        currentPage={currentPage}
        totalPages={totalPages}
      />
    )
  }

  if (footerMode === FOOTER_MODES.image && prescriptionData?.footer?.imageId) {
    return (
      <div>
        <img style={{ width: '100%', height: '100%' }} src={imageIdToUse} alt="Footer" crossOrigin="anonymous" />
      </div>
    )
  }

  return (
    <FooterComponent
      prescriptionData={prescriptionData}
      noColor={true}
      hideQr={!showQr}
      debug={debug}
      styleOverrides={styleOverrides}
    />
  )
}

/////////////////////////////////////////////////////////////////////// NEW prescription drug selection related components:

/**
 * Helper function to format option labels with highlighted matching text
 * @param {Object} option - The option object
 * @param {Object} context - Context object containing inputValue
 * @returns {JSX.Element|string} - Formatted label with highlights
 */
export const formatOptionLabelWithHighlight = (option, { context, inputValue }) => {
  if (!inputValue || context === 'value') {
    // Fall back to `title` — saved/reloaded therapy + health-entity objects carry `title`, not `label`.
    return option?.label || option?.title || option?.value || ''
  }

  const label = option?.label || option?.title || option?.value || ''
  const searchText = inputValue.toLowerCase()
  const labelLower = label.toLowerCase()
  
  // Find the index of the match
  const matchIndex = labelLower.indexOf(searchText)
  
  if (matchIndex === -1) {
    return label
  }

  // Split the label into parts
  const before = label.slice(0, matchIndex)
  const match = label.slice(matchIndex, matchIndex + inputValue.length)
  const after = label.slice(matchIndex + inputValue.length)

  // Return JSX with highlighted match
  return (
    <span>
      {before}
      <span style={{ 
        fontWeight: 700, 
        color: '#4338ca',
        backgroundColor: 'rgba(67, 56, 202, 0.1)',
        padding: '1px 3px',
        borderRadius: '3px',
      }}>
        {match}
      </span>
      {after}
    </span>
  )
}

export const commonStylesPrescriptionSelectWithRequiredParams = (
  isRequired = false,
  hasValue = false,
) => ({
  input: (baseStyles, state) => {
    let showCustomPlaceholder = false
    if (state?.selectProps?.isMulti) {
      if (state?.selectProps?.value?.length > 0) {
        showCustomPlaceholder = true
      }
      if (state?.selectProps?.inputValue?.length > 0) {
        showCustomPlaceholder = false
      }
    }

    return {
      ...baseStyles,
      '&:before': {
        content: showCustomPlaceholder ? `"${state?.selectProps?.placeholder}"` || '' : '""',
        // opacity: 0.5,
        color: '#807f80',
        position: 'absolute',
      },
    }
  },
  menuList: (provided, state) => ({
    ...provided,
    maxHeight: '200px',
    overflowY: 'scroll',
    scrollbarWidth: 'thin',
    height: '100%',
    '::-webkit-scrollbar': {
      width: '5px',
    },
    '::-webkit-scrollbar-track': {
      background: '#fafafa',
    },
    '::-webkit-scrollbar-thumb': {
      background: '#888',
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  }),
  menuPortal: (provided, state) => ({
    ...provided,
    zIndex: state?.selectProps?.maxZIndex ? 9999 : 1,
  }),
  menu: (provided, state) => {
    return {
      ...provided,
      borderRadius: 0,
    }
  },
  control: (provided, state) => {
    const defaultBorder = isRequired && !hasValue ? '1px solid #d32f2f' : provided.border
    return {
      ...provided,
      borderRadius: 0,
      backgroundColor: state.menuIsOpen ? '#fff8dc' : '#FFF',
      border: state.isFocused
        ? `1px solid ${MUIThemeConfig.palette.emrPrimary.default}`
        : defaultBorder,
      borderBottom: state?.selectProps?.noBottomBorder
        ? 'none'
        : state.isFocused
        ? `1px solid ${MUIThemeConfig.palette.emrPrimary.default}`
        : defaultBorder,
      boxShadow: 'none',
      '&:hover': {
        border: `1px solid ${MUIThemeConfig.palette.emrPrimary.default}`,
      },
      height: '100%',
    }
  },
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none', // Hide the default arrow separator
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    display: 'none', // Hide the default dropdown arrow
  }),
  singleValue: (provided, state) => ({
    ...provided,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  }),
  option: (provided, state) => ({
    ...provided,
    padding: '4px 8px',
    fontSize: '14px',
  }),
})
export const commonStylesPrescriptionSelect = {
  input: (baseStyles, state) => {
    let showCustomPlaceholder = false
    if (state?.selectProps?.isMulti) {
      if (state?.selectProps?.value?.length > 0) {
        showCustomPlaceholder = true
      }
      if (state?.selectProps?.inputValue?.length > 0) {
        showCustomPlaceholder = false
      }
    }

    return {
      ...baseStyles,
      fontSize: '14px',
      color: '#1f2937', // Ensure input text is visible (dark gray)
      '&:before': {
        content: showCustomPlaceholder ? `"${state?.selectProps?.placeholder}"` || '' : '""',
        color: 'rgba(0, 0, 0, 0.4)',
        position: 'absolute',
      },
    }
  },
  placeholder: (provided, state) => ({
    ...provided,
    color: 'rgba(0, 0, 0, 0.4)',
    fontSize: '14px',
    fontWeight: 400,
  }),
  menuList: (provided, state) => ({
    ...provided,
    maxHeight: '280px',
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    padding: '4px',
    '::-webkit-scrollbar': {
      width: '6px',
    },
    '::-webkit-scrollbar-track': {
      background: 'rgba(0, 0, 0, 0.05)',
      borderRadius: '10px',
    },
    '::-webkit-scrollbar-thumb': {
      background: 'rgba(67, 56, 202, 0.3)',
      borderRadius: '10px',
      '&:hover': {
        background: 'rgba(67, 56, 202, 0.5)',
      },
    },
  }),
  menuPortal: (provided, state) => ({
    ...provided,
    zIndex: state?.selectProps?.maxZIndex ? 9999 : 10000,
  }),
  menu: (provided, state) => ({
    ...provided,
    width: 'max-content',
    minWidth: '100%',
    maxWidth: '95vw', // Don't exceed viewport width on mobile
    borderRadius: '8px',
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08)',
    border: '1px solid rgba(67, 56, 202, 0.1)',
    marginTop: '4px',
    overflow: 'hidden',
    zIndex: 10000, // Higher z-index to appear above other cards
    position: 'absolute', // Ensure proper positioning
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: '42px',
    borderRadius: '8px',
    background: state.menuIsOpen 
      ? 'linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(250, 250, 255, 1) 100%)'
      : state.isFocused
      ? 'rgba(255, 255, 255, 1)'
      : 'linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(250, 250, 255, 0.95) 100%)',
    border: state.isFocused || state.menuIsOpen
      ? `2px solid ${MUIThemeConfig.palette.emrPrimary.default}`
      : '1.5px solid rgba(67, 56, 202, 0.15)',
    borderBottom: state?.selectProps?.noBottomBorder
      ? 'none'
      : state.isFocused || state.menuIsOpen
      ? `2px solid ${MUIThemeConfig.palette.emrPrimary.default}`
      : '1.5px solid rgba(67, 56, 202, 0.15)',
    boxShadow: state.isFocused || state.menuIsOpen
      ? '0 0 0 3px rgba(67, 56, 202, 0.08)'
      : '0 1px 3px rgba(0, 0, 0, 0.05)',
    transition: 'all 0.2s ease',
    '&:hover': {
      border: state.isFocused || state.menuIsOpen
        ? `2px solid ${MUIThemeConfig.palette.emrPrimary.default}`
        : '1.5px solid rgba(67, 56, 202, 0.3)',
      boxShadow: state.isFocused || state.menuIsOpen
        ? '0 0 0 3px rgba(67, 56, 202, 0.08)'
        : '0 2px 6px rgba(67, 56, 202, 0.1)',
    },
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    padding: '2px 12px',
    gap: '4px',
  }),
  multiValue: (provided, state) => ({
    ...provided,
    borderRadius: '6px',
    background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.08) 0%, rgba(99, 102, 241, 0.08) 100%)',
    border: '1px solid rgba(67, 56, 202, 0.2)',
    padding: '2px 4px',
    transition: 'all 0.15s ease',
    '&:hover': {
      background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.12) 0%, rgba(99, 102, 241, 0.12) 100%)',
      transform: 'translateY(-1px)',
    },
  }),
  multiValueLabel: (provided, state) => ({
    ...provided,
    color: '#4338ca',
    fontWeight: 500,
    fontSize: '13px',
    padding: '2px 4px',
  }),
  multiValueRemove: (provided, state) => ({
    ...provided,
    borderRadius: '4px',
    color: 'rgba(67, 56, 202, 0.6)',
    transition: 'all 0.15s ease',
    '&:hover': {
      backgroundColor: 'rgba(239, 68, 68, 0.1)',
      color: '#dc2626',
    },
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    display: 'flex',
    padding: '8px',
    color: state.isFocused || state.selectProps.menuIsOpen ? MUIThemeConfig.palette.emrPrimary.default : 'rgba(0, 0, 0, 0.4)',
    transition: 'all 0.2s ease',
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
    '&:hover': {
      color: MUIThemeConfig.palette.emrPrimary.default,
    },
  }),
  clearIndicator: (provided, state) => ({
    ...provided,
    padding: '8px',
    color: 'rgba(0, 0, 0, 0.4)',
    transition: 'all 0.15s ease',
    '&:hover': {
      color: '#dc2626',
    },
  }),
  singleValue: (provided, state) => ({
    ...provided,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    color: '#1f2937', // Dark color to ensure visibility on white background
    fontSize: '14px',
  }),
  option: (provided, state) => ({
    ...provided,
    padding: '10px 12px',
    fontSize: '14px',
    borderRadius: '6px',
    margin: '2px 0',
    cursor: 'pointer',
    transition: 'all 0.15s ease',
    backgroundColor: state.isSelected
      ? 'linear-gradient(135deg, rgba(67, 56, 202, 0.95) 0%, rgba(99, 102, 241, 0.95) 100%)'
      : state.isFocused
      ? 'rgba(67, 56, 202, 0.08)'
      : 'transparent',
    color: state.isSelected ? '#ffffff' : state.isFocused ? '#4338ca' : '#1f2937', // Ensure text is visible
    fontWeight: state.isSelected ? 600 : state.isFocused ? 500 : 400,
    '&:active': {
      backgroundColor: 'rgba(67, 56, 202, 0.15)',
    },
  }),
  loadingIndicator: (provided, state) => ({
    ...provided,
    color: MUIThemeConfig.palette.emrPrimary.default,
  }),
  noOptionsMessage: (provided, state) => ({
    ...provided,
    padding: '12px',
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.5)',
  }),
}

const removeDuplicateOptionsByCommonId = (optionsArray) => {
  // Create a Set of all commonIds in optionsArray
  const commonIdSet = new Set(optionsArray.map((item) => item.commonId))

  // Filter out items whose id appears in commonIdSet
  return optionsArray.filter((item) => !commonIdSet.has(item.id))
}

export const loadOptionsDrugs = async (
  search,
  loadedOptions,
  { page, clinicId, clinicBrandId, recommendedDrugs = [] },
) => {
  var optionsArray = []

  let filteredDrugsFromDb = []
  try {
    filteredDrugsFromDb = await searchDrugsInIdb(search) // Search all drugs from IndexedDB
  } catch (idbErr) {
    // IndexedDB errors are non-fatal; fall through to API search
  }
  const indexedDbOptions = filteredDrugsFromDb.map((drug) => ({
    ...drug,
    value: drug?.title,
    label: drug?.title,
  }))

  optionsArray = [...indexedDbOptions]

  var hasMore = true
  if (indexedDbOptions.length === 0) {
    const response = await getCPDataWithoutParams(
      `/api/secure/drug/list?search=${search}&clinicId=${clinicId}&clinicBrandId=${clinicBrandId}&page=${page}&pageSize=10`,
    )
    if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
      addOrUpdateDrugsInIdb(response.data)
      optionsArray = response?.data?.map((option, index) => {
        const title = `${option?.title || ''} ${
          !!option?.unit && option?.qty ? `(${option?.qty} ${option?.unit})` : ''
        }`
        return {
          ...option,
          value: title,
          label: title,
        }
      })
    } else {
      hasMore = false
    }
  } else {
    hasMore = false
  }

  if (page === 1 && !search) {
    var foundRecommendedDrugs = await getDrugsByIDs(recommendedDrugs)
    if ((foundRecommendedDrugs?.length || 0) < (recommendedDrugs?.length || 0)) {
      const missingDrugIds = recommendedDrugs?.filter((investId) => {
        return !foundRecommendedDrugs?.find((invest) => invest.id === investId)
      })
      const missingResp = await getCPDataWithoutParams(
        `/api/secure/drug/list?ids=${missingDrugIds.join(',')}`,
      )
      if (
        missingResp.status === 200 &&
        Array.isArray(missingResp.data) &&
        missingResp.data.length > 0
      ) {
        addOrUpdateDrugsInIdb(missingResp.data)
        foundRecommendedDrugs = [...foundRecommendedDrugs, ...missingResp.data]
      }
    }
    optionsArray = [
      ...foundRecommendedDrugs?.map((drug) => ({
        ...drug,
        value: drug?.title,
        label: drug?.title,
      })),
      ...optionsArray,
    ]
  }

  optionsArray = optionsArray
    .map((drug) => ({
      ...drug,
    }))
    .slice(0, 25)

  return {
    options: removeDuplicateOptionsByCommonId(optionsArray),
    hasMore,
    additional: {
      page: page + 1,
      clinicId,
    },
  }
}

// export const loadOptionsDrugsWithSorting = async (search, loadedOptions, additional) => {
//   const {
//     options,
//     hasMore,
//     additional: newAdditional,
//   } = await loadOptionsDrugs(search, loadedOptions, additional)

//   if (!search) return { options, hasMore, additional: newAdditional }

//   const lowerInput = search.toLowerCase()

//   // Exact matches first
//   const exactMatches = options.filter((o) => o.label.toLowerCase() === lowerInput)

//   // Other matches
//   const otherMatches = options.filter(
//     (o) => o.label.toLowerCase().includes(lowerInput) && o.label.toLowerCase() !== lowerInput,
//   )

//   return {
//     // options: [...exactMatches, ...otherMatches],
//     options: options,
//     hasMore,
//     additional: newAdditional,
//   }
// }

export const DrugSelectMenu = ({
  clinicId,
  clinicBrandId,
  selectedDrug,
  setSelectedDrug,
  recommendedDrugs,
  doctorSpecializations = [],
  menuPortalTarget,
}) => {
  const [inputValue, setInputValue] = useState()

  useEffect(() => {
    setInputValue(selectedDrug?.label || '')
    // if (selectedDrug?.label) {
    // }
    // if (!selectedDrug?.id && !selectedDrug?.__isNew__) {
    //   setInputValue('')
    // }
  }, [selectedDrug])

  // Stable reference for additional — prevents withAsyncPaginate from resetting
  // its cache on every parent re-render (which causes infinite loading loop)
  const stableAdditional = useMemo(
    () => ({ page: 1, clinicId, clinicBrandId, recommendedDrugs }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [clinicId, clinicBrandId, JSON.stringify(recommendedDrugs)],
  )

  const portalStyles = menuPortalTarget
    ? {
        ...commonStylesPrescriptionSelect,
        menuPortal: (provided) => ({ 
          ...provided, 
          zIndex: 99999,
        }),
        menu: (provided) => ({ 
          ...provided, 
          zIndex: 99999,
        }),
      }
    : commonStylesPrescriptionSelect

  return (
    <div 
      style={{ 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        position: 'relative',
        zIndex: 20, // For dropdown menu, but GenericDrugComponent inside has lower z-index (1)
      }}
    >
      <CreatableDrugAdviceInput
        id="drugSelection"
        classNamePrefix="drug_name_selection"
        placeholder="Drug"
        isClearable={true}
        components={{
          ClearIndicator: () => null,
          Input: TextAreaInputTextAreaInputForEMR,
          Placeholder: () => null,
        }}
        isSearchable={true}
        defaultOptions={false}
        inputValue={inputValue}
        controlShouldRenderValue={false}
        createOptionPosition="first"
        noBottomBorder
        loadOptions={loadOptionsDrugs}
        getOptionValue={(option) => option?.label}
        getOptionLabel={(option) => option?.label}
        value={selectedDrug}
        onInputChange={(value, actionMeta) => {
          if (actionMeta.action === 'input-blur') {
            if (selectedDrug?.label) {
              setInputValue(selectedDrug?.label)
            }
          }
          if (actionMeta.action === 'input-change') {
            setInputValue(value)
          }
        }}
        onChange={(value) => {
          setSelectedDrug(value, false)
          setInputValue(value?.label)
        }}
        debounceTimeout={200}
        additional={stableAdditional}
        styles={portalStyles}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPortalTarget ? 'absolute' : undefined}
        menuPlacement="auto"
      />
      <GenericDrugComponent
        selectedDrug={selectedDrug}
        setSelectedDrug={(val) => {
          setSelectedDrug(val, true)
        }}
      />
    </div>
  )
}

export const DrugTypeSelectMenu = ({
  allowEnteringValue,
  options,
  selectedType,
  setSelectedType,
  prescriptionViewSettings,
  menuPortalTarget,
}) => {
  const selectOptions =
    options?.map((optn) => {
      return {
        ...optn,
        label: getDrugTypeItemOptionLabel(optn, prescriptionViewSettings),
        value: getDrugTypeItemOptionValue(optn, prescriptionViewSettings),
      }
    }) || []


  const portalStyles = menuPortalTarget
    ? {
        ...commonStylesPrescriptionSelect,
        menuPortal: (provided) => ({ 
          ...provided, 
          zIndex: 99999,
        }),
        menu: (provided) => ({ 
          ...provided, 
          zIndex: 99999,
        }),
      }
    : commonStylesPrescriptionSelect

  return (
    <CreatableDrugTypeSelectionContainer>
      <CreatableDrugTypeSelection
        id="drugTypeSelection"
        isDisabled={!allowEnteringValue}
        key={selectedType?.value}
        classNamePrefix="drug_type_selection"
        placeholder="Type"
        isClearable={true}
        components={{ ClearIndicator: () => null }}
        createOptionPosition="first"
        filterOption={filterForDrugTypesDropDown}
        isSearchable={true}
        options={selectOptions}
        getOptionValue={(option) => option?.label}
        getOptionLabel={(option) => option?.label}
        isValidNewOption={(inpString, val, options) =>
          !!inpString
            ? options?.every((optn) => isCreatingOptionValidForDrugType(optn || [], inpString))
            : false
        }
        value={selectedType ?? null}
        onChange={(value) => {
          if (allowEnteringValue) {
            setSelectedType(value)
          }
        }}
        styles={portalStyles}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPortalTarget ? 'absolute' : undefined}
        menuPlacement="auto"
      />
    </CreatableDrugTypeSelectionContainer>
  )
}
export const DosageSelectMenu = ({
  allowEnteringValue,
  options,
  selectedDosage,
  setSelectedDosage,
  prescriptionViewSettings,
  menuPortalTarget,
}) => {
  // dedupe entries that are the same dose written differently ("1-0-1" vs "1 0 1");
  // options are ordered personalized-first, so the first occurrence wins
  const seenNormalizedDoses = new Set()
  const selectOptions = []
  options?.forEach((optn) => {
    const label = getDrugItemOptionLabel(optn, prescriptionViewSettings)
    const normalizedLabel = normalizeDoseText(label)
    if (normalizedLabel && seenNormalizedDoses.has(normalizedLabel)) {
      return
    }
    seenNormalizedDoses.add(normalizedLabel)
    selectOptions.push({
      ...optn,
      label,
      value: label,
    })
  })

  const portalStyles = menuPortalTarget
    ? {
        ...commonStylesPrescriptionSelect,
        menuPortal: (provided) => ({ 
          ...provided, 
          zIndex: 99999,
        }),
        menu: (provided) => ({ 
          ...provided, 
          zIndex: 99999,
        }),
      }
    : commonStylesPrescriptionSelect

  return (
    <CreatableDrugDoseSelectionContainer>
      <CreatableDrugDoseSelection
        id="dosageSelection"
        isDisabled={!allowEnteringValue}
        classNamePrefix="drug_dosage_selection"
        placeholder="Dosage"
        isClearable={true}
        components={{ ClearIndicator: () => null }}
        filterOption={filterForDosagesDropDown}
        isValidNewOption={(inpString, val, options) =>
          !!inpString
            ? options?.every((optn) => isCreateDosageOptionValid(optn || [], inpString))
            : false
        }
        createOptionPosition="first"
        isSearchable={true}
        options={selectOptions}
        getOptionValue={(option) => option?.label}
        getOptionLabel={(option) => option?.label}
        value={selectedDosage}
        onChange={(value) => {
          allowEnteringValue && setSelectedDosage(value)
        }}
        styles={portalStyles}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPortalTarget ? 'absolute' : undefined}
        menuPlacement="auto"
      />
    </CreatableDrugDoseSelectionContainer>
  )
}

export const WhatTimeSelectMenu = ({
  allowEnteringValue,
  selectedWhatTime,
  setSelectedWhatTime,
  options,
  prescriptionViewSettings,
  menuPortalTarget,
}) => {
  const optionsArray = options?.map((option, index) => {
    return {
      ...option,
      value: getDrugItemOptionValue(option, prescriptionViewSettings),
      label: getDrugItemOptionLabel(option, prescriptionViewSettings),
    }
  })

  const portalStyles = menuPortalTarget
    ? {
        ...commonStylesPrescriptionSelect,
        menuPortal: (provided) => ({ 
          ...provided, 
          zIndex: 99999,
        }),
        menu: (provided) => ({ 
          ...provided, 
          zIndex: 99999,
        }),
      }
    : commonStylesPrescriptionSelect

  return (
    <CreatableDrugWhatTimeSelectionContainer>
      <CreatableDrugWhatTimeSelection
        id="whatTimeSelection"
        isDisabled={!allowEnteringValue}
        classNamePrefix="drug_what_time_selection"
        createOptionPosition="first"
        placeholder="When"
        isClearable={true}
        components={{ ClearIndicator: () => null }}
        isSearchable={true}
        options={optionsArray}
        getOptionValue={(option) => option?.label}
        getOptionLabel={(option) =>
          typeof option?.label === 'string'
            ? option.label.replace(/\b\w/g, (char) => char.toUpperCase())
            : option?.label
        }
        value={selectedWhatTime}
        onChange={(value) => {
          allowEnteringValue && setSelectedWhatTime(value)
        }}
        styles={portalStyles}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPortalTarget ? 'absolute' : undefined}
        menuPlacement="auto"
      />
    </CreatableDrugWhatTimeSelectionContainer>
  )
}

export const FrequencySelectMenu = ({
  allowEnteringValue,
  selectedFrequency,
  setSelectedFrequency,
  options,
  prescriptionViewSettings,
  menuPortalTarget,
}) => {
  const optionsArray = options?.map((option, index) => {
    return {
      ...option,
      value: getDrugItemOptionValue(option, prescriptionViewSettings),
      label: getDrugItemOptionLabel(option, prescriptionViewSettings),
    }
  })

  const portalStyles = menuPortalTarget
    ? {
        ...commonStylesPrescriptionSelect,
        menuPortal: (provided) => ({ 
          ...provided, 
          zIndex: 999999,
        }),
        menu: (provided) => ({ 
          ...provided, 
          zIndex: 999999,
        }),
      }
    : commonStylesPrescriptionSelect

  return (
    <CreatableDrugFrequencySelectionContainer>
      <CreatableDrugFrequencySelection
        id="frequencySelection"
        isDisabled={!allowEnteringValue}
        classNamePrefix="drug_frequency_selection"
        createOptionPosition="first"
        placeholder="Frequency"
        isClearable={true}
        isSearchable={true}
        components={{ ClearIndicator: () => null }}
        options={optionsArray}
        getOptionValue={(option) => option?.label}
        getOptionLabel={(option) => option?.label}
        value={selectedFrequency}
        onChange={(value) => {
          allowEnteringValue && setSelectedFrequency(value)
        }}
        styles={portalStyles}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPortalTarget ? 'absolute' : undefined}
        menuPlacement="auto"
      />
    </CreatableDrugFrequencySelectionContainer>
  )
}

export const DurationSelectMenu = ({
  allowEnteringValue,
  selectedDurationTime,
  setSelectedDurationTime,
  options,
  prescriptionViewSettings,
  menuPortalTarget,
}) => {
  // dedupe values that differ only by case/spacing; personalized-first order means
  // the first occurrence wins
  const seenDurations = new Set()
  const optionsArray = []
  options?.forEach((option) => {
    const label = getDrugItemOptionLabel(option, prescriptionViewSettings)
    const dedupeKey = normalizeTitleForDedupe(label)
    if (dedupeKey && seenDurations.has(dedupeKey)) {
      return
    }
    seenDurations.add(dedupeKey)
    optionsArray.push({
      ...option,
      value: getDrugItemOptionValue(option, prescriptionViewSettings),
      label,
    })
  })

  const portalStyles = menuPortalTarget
    ? {
        ...commonStylesPrescriptionSelect,
        menuPortal: (provided) => ({ 
          ...provided, 
          zIndex: 99999,
        }),
        menu: (provided) => ({ 
          ...provided, 
          zIndex: 99999,
        }),
      }
    : commonStylesPrescriptionSelect

  return (
    <CreatableDrugDurationSelectionContainer>
      <CreatableDrugDurationSelection
        id="durationSelection"
        isDisabled={!allowEnteringValue}
        classNamePrefix="drug_duration_selection"
        createOptionPosition="first"
        placeholder="Duration"
        isClearable={true}
        components={{ ClearIndicator: () => null }}
        isSearchable={true}
        filterOption={filterForTitleAndAliasesDropDown}
        options={optionsArray}
        getOptionValue={(option) => option?.label}
        getOptionLabel={(option) => option?.label}
        value={selectedDurationTime}
        onChange={(value) => {
          allowEnteringValue && setSelectedDurationTime(value)
        }}
        styles={portalStyles}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPortalTarget ? 'absolute' : undefined}
        menuPlacement="auto"
      />
    </CreatableDrugDurationSelectionContainer>
  )
}

export const TextAreaInputTextAreaInputForEMR = (props) => {
  // Extract react-select specific props that shouldn't be passed to DOM
  const {
    innerRef,
    selectProps,
    clearValue,
    getStyles,
    getClassNames,
    getValue,
    hasValue,
    isMulti,
    isRtl,
    selectOption,
    setValue,
    isDisabled,
    isHidden,
    cx,
    ...domProps
  } = props

  return (
    <TextareaAutosize
      {...domProps}
      ref={innerRef}
      placeholder={selectProps?.placeholder}
      style={{
        resize: 'none', // Disable manual resizing
        overflow: 'hidden', // Auto-expand height
        outline: 'none',
        ...domProps.style,
      }}
    >
      {props.children}
    </TextareaAutosize>
  )
}

export const NotesSelectMenu = ({
  allowEnteringValue,
  selectedNote,
  setSelectedNote,
  isDrugNew,
  options,
  prescriptionViewSettings,
  menuPortalTarget,
}) => {
  const [extraOptions, setExtraOptions] = useState([])
  const [inputValue, setInputValue] = useState()

  useEffect(() => {
    // if (selectedNote?.label) {
    setInputValue(selectedNote?.label)
    // }
  }, [selectedNote])

  // dedupe notes that differ only by case/spacing; personalized-first order means
  // the first occurrence wins
  const seenNotes = new Set()
  const optionsArray = []
  options?.forEach((option) => {
    const label = getDrugItemOptionLabel(option, prescriptionViewSettings)
    const dedupeKey = normalizeTitleForDedupe(label)
    if (dedupeKey && seenNotes.has(dedupeKey)) {
      return
    }
    seenNotes.add(dedupeKey)
    optionsArray.push({
      ...option,
      value: getDrugItemOptionValue(option, prescriptionViewSettings),
      label,
    })
  })

  const portalStyles = menuPortalTarget
    ? {
        ...commonStylesPrescriptionSelect,
        menuPortal: (provided) => ({ 
          ...provided, 
          zIndex: 99999,
        }),
        menu: (provided) => ({ 
          ...provided, 
          zIndex: 99999,
        }),
      }
    : commonStylesPrescriptionSelect

  return (
    <CreatableDrugNotesSelect
      id="notesSelection"
        isDisabled={!allowEnteringValue}
      classNamePrefix="drug_notes_selection"
      createOptionPosition="first"
      placeholder="Notes"
      isClearable={true}
      inputValue={inputValue}
      controlShouldRenderValue={false}
      components={{
        ClearIndicator: () => null,
        Input: TextAreaInputTextAreaInputForEMR,
        Placeholder: () => null,
      }}
      isSearchable={true}
      // options={optionsArray}
      options={[...(optionsArray || [])]}
      filterOption={filterForTitleAndAliasesDropDown}
      getOptionValue={(option) => option?.label}
      getOptionLabel={(option) => option?.label}
      onInputChange={(value, actionMeta) => {
        if (actionMeta.action === 'input-blur') {
          if (selectedNote?.label) {
            setInputValue(selectedNote?.label)
          }
        }
        if (actionMeta.action === 'input-change') {
          setInputValue(value)
        }
      }}
      // onInputChange={(newValue) => {
      //   checkAndCheckForNewOption(newValue)
      // }}
      value={selectedNote}
      onChange={(value) => {
        if (allowEnteringValue) {
          setSelectedNote(value)
          setInputValue(value?.label)
        }
      }}
      styles={portalStyles}
      menuPortalTarget={menuPortalTarget}
      menuPosition={menuPortalTarget ? 'absolute' : undefined}
      menuPlacement="auto"
    />
  )
}

////////////////////////////////////////////////////////////////////////// NEW prescription components

export const PrescriptionTextAreaComponent = ({ inputValue, setInputValue }) => {
  return (
    <PMPSectionTextAreaBox value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
  )
}

export const loadOptionsComplaints = async (
  search,
  loadedOptions,
  { page, clinicId, clinicBrandId, recommendedHealthComplaintIds, prescriptionViewSettings },
) => {
  var optionsArray = []

  const filteredComplaintsFromDb = await searchHealthComplaintsInIdb(search) // Search all complaints from IndexedDB
  const indexedDbOptions = filteredComplaintsFromDb.map((complaint) =>
    getHealthEntityDataWithLabelAndValue(complaint, prescriptionViewSettings),
  )

  optionsArray = [...indexedDbOptions]

  var hasMore = true
  if (indexedDbOptions.length === 0) {
    const response = await getCPDataWithoutParams(
      `/api/secure/clinic-practitioner/health-complaint/list?search=${search}&clinicId=${clinicId}&clinicBrandId=${clinicBrandId}&page=${page}&pageSize=10`,
    )
    if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
      addOrUpdateHealthComplaintsInIdb(response.data)
      optionsArray = response?.data?.map((option, index) =>
        getHealthEntityDataWithLabelAndValue(option, prescriptionViewSettings),
      )
    } else {
      hasMore = false
    }
  } else {
    hasMore = false
  }
  if (page === 1 && !search) {
    var foundHealthComplaints = await getHealthComplaintsByIds(recommendedHealthComplaintIds)
    if ((foundHealthComplaints?.length || 0) < (recommendedHealthComplaintIds?.length || 0)) {
      const missingComplaintIds = recommendedHealthComplaintIds?.filter((investId) => {
        return !foundHealthComplaints?.find((invest) => invest.id === investId)
      })
      const missingResp = await getCPDataWithoutParams(
        `/api/secure/clinic-practitioner/health-complaint/list?ids=${missingComplaintIds.join(',')}`,
      )
      if (
        missingResp.status === 200 &&
        Array.isArray(missingResp.data) &&
        missingResp.data.length > 0
      ) {
        addOrUpdateHealthComplaintsInIdb(missingResp.data)
        foundHealthComplaints = [...foundHealthComplaints, ...missingResp.data]
      }
    }
    optionsArray = [
      ...foundHealthComplaints?.map((complaint) =>
        getHealthEntityDataWithLabelAndValue(complaint, prescriptionViewSettings),
      ),
      ...optionsArray,
    ]
  }

  return {
    options: optionsArray,
    hasMore,
    additional: {
      page: page + 1,
      clinicId,
      prescriptionViewSettings,
    },
  }
}

export const loadOptionsDiagnosis = async (
  search,
  loadedOptions,
  { page, clinicId, clinicBrandId, recommendedDiagnosisIds, prescriptionViewSettings },
) => {
  var optionsArray = []

  const filteredDiagnosisFromDb = await searchDiagnosisInIdb(search) // Search all diagnosis from IndexedDB
  const indexedDbOptions = filteredDiagnosisFromDb.map((diagnosis) =>
    getHealthEntityDataWithLabelAndValue(diagnosis, prescriptionViewSettings),
  )

  optionsArray = [...indexedDbOptions]

  var hasMore = true
  if (indexedDbOptions.length === 0) {
    const response = await getCPDataWithoutParams(
      `/api/secure/clinic-practitioner/diagnosis/list?search=${search}&clinicId=${clinicId}&clinicBrandId=${clinicBrandId}&page=${page}&pageSize=10`,
    )
    if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
      addOrUpdateDiagnosisInIdb(response?.data)
      optionsArray = response?.data?.map((option, index) =>
        getHealthEntityDataWithLabelAndValue(option, prescriptionViewSettings),
      )
    } else {
      hasMore = false
    }
  } else {
    hasMore = false
  }

  if (page === 1 && !search) {
    var foundDiagnosis = await getDiagnosisByIds(recommendedDiagnosisIds)
    if ((foundDiagnosis?.length || 0) < (recommendedDiagnosisIds?.length || 0)) {
      const missingDiagnosisIds = recommendedDiagnosisIds?.filter((investId) => {
        return !foundDiagnosis?.find((invest) => invest.id === investId)
      })
      const missingResp = await getCPDataWithoutParams(
        `/api/secure/clinic-practitioner/diagnosis/list?ids=${missingDiagnosisIds.join(',')}`,
      )
      if (
        missingResp.status === 200 &&
        Array.isArray(missingResp.data) &&
        missingResp.data.length > 0
      ) {
        addOrUpdateDiagnosisInIdb(missingResp.data)
        foundDiagnosis = [...foundDiagnosis, ...missingResp.data]
      }
    }
    optionsArray = [
      ...foundDiagnosis?.map((diagnosis) =>
        getHealthEntityDataWithLabelAndValue(diagnosis, prescriptionViewSettings),
      ),
      ...optionsArray,
    ]
  }

  return {
    options: optionsArray,
    hasMore,
    additional: {
      page: page + 1,
      clinicId,
      prescriptionViewSettings,
    },
  }
}

export const loadOptionsInvestigations = async (
  search,
  loadedOptions,
  { page, clinicId, clinicBrandId, recommendedInvestigationIds, prescriptionViewSettings },
) => {
  var optionsArray = []

  const filteredInvestigationsFromDb = await searchInvestigationInIdb(search) // Search all complaints from IndexedDB
  const indexedDbOptions = filteredInvestigationsFromDb.map((investigation) =>
    getHealthEntityDataWithLabelAndValue(investigation, prescriptionViewSettings),
  )

  optionsArray = [...indexedDbOptions]

  var hasMore = true
  if (indexedDbOptions.length === 0) {
    const response = await getCPDataWithoutParams(
      `/api/secure/clinic-practitioner/investigation/list?search=${search}&clinicId=${clinicId}&clinicBrandId=${clinicBrandId}&page=${page}&pageSize=10`,
    )
    if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
      addOrUpdateInvestigationInIdb(response.data)
      optionsArray = response?.data?.map((option, index) =>
        getHealthEntityDataWithLabelAndValue(option, prescriptionViewSettings),
      )
    } else {
      hasMore = false
    }
  } else {
    hasMore = false
  }

  if (page === 1 && !search) {
    var foundRecommendedInvestigations = await getInvestigationByIdsFromIdb(
      recommendedInvestigationIds,
    )
    if (
      (foundRecommendedInvestigations?.length || 0) < (recommendedInvestigationIds?.length || 0)
    ) {
      const missingInvestigationsIds = recommendedInvestigationIds?.filter((investId) => {
        return !foundRecommendedInvestigations?.find((invest) => invest.id === investId)
      })
      const missingResp = await getCPDataWithoutParams(
        `/api/secure/clinic-practitioner/investigation/list?ids=${missingInvestigationsIds.join(',')}`,
      )
      if (
        missingResp.status === 200 &&
        Array.isArray(missingResp.data) &&
        missingResp.data.length > 0
      ) {
        addOrUpdateInvestigationInIdb(missingResp.data)
        foundRecommendedInvestigations = [...foundRecommendedInvestigations, ...missingResp.data]
      }
    }
    optionsArray = [
      ...foundRecommendedInvestigations?.map((investigation) =>
        getHealthEntityDataWithLabelAndValue(investigation, prescriptionViewSettings),
      ),
      ...optionsArray,
    ]
  }

  return {
    options: optionsArray,
    hasMore,
    additional: {
      page: page + 1,
      clinicId,
      prescriptionViewSettings,
    },
  }
}

export const loadOptionsObservations = async (
  search,
  loadedOptions,
  {
    page,
    clinicId,
    clinicBrandId,
    inDropDown = false,
    prescriptionViewSettings,
    recommendedObservations,
  },
) => {
  var optionsArray = []

  const filteredObservationsFromDb = (await searchObservationsInIdb(search)).slice(0, 500) // Search all observations from IndexedDB
  const indexedDbOptions = filteredObservationsFromDb.map((observation) =>
    getHealthEntityDataWithLabelAndValue(observation, prescriptionViewSettings),
  )

  optionsArray = [...indexedDbOptions]

  var hasMore = true
  if (indexedDbOptions.length === 0) {
    const response = await getCPDataWithoutParams(
      `/api/secure/clinic-practitioner/health-observation/list?search=${search}&clinicId=${clinicId}&clinicBrandId=${clinicBrandId}&page=${page}&pageSize=10`,
    )
    if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
      addOrUpdateObservationsInIdb(response.data)
      optionsArray = response?.data?.map((option, index) =>
        getHealthEntityDataWithLabelAndValue(option, prescriptionViewSettings),
      )
    } else {
      hasMore = false
    }
  } else {
    hasMore = false
  }

  if (page === 1 && !search) {
    var foundHealthObservations = await getObservationsByIds(recommendedObservations)
    if ((foundHealthObservations?.length || 0) < (recommendedObservations?.length || 0)) {
      const missingObservationIds = recommendedObservations?.filter((investId) => {
        return !foundHealthObservations?.find((invest) => invest.id === investId)
      })
      const missingResp = await getCPDataWithoutParams(
        `/api/secure/clinic-practitioner/health-observation/list?ids=${missingObservationIds.join(',')}`,
      )
      if (
        missingResp.status === 200 &&
        Array.isArray(missingResp.data) &&
        missingResp.data.length > 0
      ) {
        addOrUpdateObservationsInIdb(missingResp.data)
        foundHealthObservations = [...foundHealthObservations, ...missingResp.data]
      }
    }
    optionsArray = [
      ...foundHealthObservations?.map((adv) =>
        getHealthEntityDataWithLabelAndValue(adv, prescriptionViewSettings),
      ),
      ...optionsArray,
    ]
  }

  return {
    options: optionsArray,
    hasMore,
    additional: {
      page: page + 1,
      clinicId,
      inDropDown,
      prescriptionViewSettings,
    },
  }
}

export const loadOptionsAdvice = async (
  search,
  loadedOptions,
  { page, size = 10, clinicId, clinicBrandId, prescriptionViewSettings, recommendedAdvices },
) => {
  var optionsArray = []

  const filteredAdvicesFromDb = await searchAdvicesInIdb(search) // Search all drugs from IndexedDB
  const indexedDbOptions = filteredAdvicesFromDb.map((advice) =>
    getHealthEntityDataWithLabelAndValue(advice, prescriptionViewSettings),
  )

  optionsArray = [...indexedDbOptions]

  var hasMore = true
  if (indexedDbOptions.length === 0) {
    const response = await getCPDataWithoutParams(
      `/api/secure/clinic-practitioner/prescription-advice/list?search=${search}&clinicId=${clinicId}&clinicBrandId=${clinicBrandId}&page=${page}&pageSize=${size}`,
    )
    if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
      addOrUpdateAdvicesInIdb(response.data)
      optionsArray = response?.data?.map((option, index) => {
        return getHealthEntityDataWithLabelAndValue(option, prescriptionViewSettings)
      })
    } else {
      hasMore = false
    }
  } else {
    hasMore = false
  }

  if (page === 1 && !search) {
    var foundPrescriptionAdvices = await getAdvicesByIds(recommendedAdvices)
    if ((foundPrescriptionAdvices?.length || 0) < (recommendedAdvices?.length || 0)) {
      const missingAdviceIds = recommendedAdvices?.filter((investId) => {
        return !foundPrescriptionAdvices?.find((invest) => invest.id === investId)
      })
      const missingResp = await getCPDataWithoutParams(
        `/api/secure/clinic-practitioner/prescription-advice/list?ids=${missingAdviceIds.join(',')}`,
      )
      if (
        missingResp.status === 200 &&
        Array.isArray(missingResp.data) &&
        missingResp.data.length > 0
      ) {
        addOrUpdateAdvicesInIdb(missingResp.data)
        foundPrescriptionAdvices = [...foundPrescriptionAdvices, ...missingResp.data]
      }
    }
    optionsArray = [
      ...foundPrescriptionAdvices?.map((adv) =>
        getHealthEntityDataWithLabelAndValue(adv, prescriptionViewSettings),
      ),
      ...optionsArray,
    ]
  }

  return {
    options: optionsArray,
    hasMore,
    additional: {
      page: page + 1,
      clinicId,
      prescriptionViewSettings,
    },
  }
}

export const loadOptionsInstructions = async (
  search,
  loadedOptions,
  { page, size = 10, clinicId, clinicBrandId, prescriptionViewSettings, recommendedInstructionIds },
) => {
  var optionsArray = []

  const filteredInstructionsFromDb = await searchInstructionsInIdb(search) // Search all instructions from IndexedDB

  const indexedDbOptions = filteredInstructionsFromDb.map((instruction) =>
    getHealthEntityDataWithLabelAndValue(instruction, prescriptionViewSettings),
  )
  optionsArray = [...indexedDbOptions]

  var hasMore = true
  if (indexedDbOptions.length === 0) {
    const response = await getCPDataWithoutParams(
      `/api/secure/clinic-practitioner/instruction/list?search=${search}&clinicBrandId=${clinicBrandId}&page=${page}&pageSize=${size}`,
    )
    if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
      addOrUpdateInstructionsInIdb(response.data)
      optionsArray = response?.data?.map((option, index) =>
        getHealthEntityDataWithLabelAndValue(option, prescriptionViewSettings),
      )
    } else {
      hasMore = false
    }
  } else {
    hasMore = false
  }

  if (page === 1 && !search) {
    var foundInstructions = await getInstructionsByIds(recommendedInstructionIds)
    if ((foundInstructions?.length || 0) < (recommendedInstructionIds?.length || 0)) {
      const missingInstructionIds = recommendedInstructionIds?.filter((investId) => {
        return !foundInstructions?.find((invest) => invest.id === investId)
      })
      const missingResp = await getCPDataWithoutParams(
        `/api/secure/clinic-practitioner/instruction/list?ids=${missingInstructionIds.join(',')}`,
      )
      if (
        missingResp.status === 200 &&
        Array.isArray(missingResp.data) &&
        missingResp.data.length > 0
      ) {
        addOrUpdateInstructionsInIdb(missingResp.data)
        foundInstructions = [...foundInstructions, ...missingResp.data]
      }
    }
    optionsArray = [
      ...foundInstructions?.map((adv) =>
        getHealthEntityDataWithLabelAndValue(adv, prescriptionViewSettings),
      ),
      ...optionsArray,
    ]
  }

  return {
    options: optionsArray,
    hasMore,
    additional: {
      page: page + 1,
      clinicId,
      prescriptionViewSettings,
    },
  }
}

const loadOptionsSuggestedTherapies = async (
  search,
  loadedOptions,
  { page, clinicId, baseApiSignature = '/api/secure/practitioner/therapy-type/list' },
) => {
  const response = await getCPDataWithoutParams(
    `${baseApiSignature}?search=${search}&page=${page}&pageSize=10`,
  )
  var hasMore = true
  var optionsArray = []

  if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
    optionsArray = response?.data?.map((option, index) => {
      return {
        ...option,
        value: option?.title,
        label: option?.title,
      }
    })
  } else {
    hasMore = false
  }

  return {
    options: optionsArray,
    hasMore,
    additional: {
      page: page + 1,
      clinicId,
      baseApiSignature,
    },
  }
}

const loadOptionsSuggestedAssessments = async (
  search,
  loadedOptions,
  {
    page,
    clinicId,
    clinicBrandId,
    recommendedAssessmentIds,
    prescriptionViewSettings,
    searchApiSignature = '/api/secure/clinic-practitioner/psych-assessment/list',
    doctorSpecializations = [],
  },
) => {
  var optionsArray = []

  const filteredAssessmentsFromDb = await searchPsychAssessmentsInIdb(search) // Search all assessments from IndexedDB
  const indexedDbOptions = filteredAssessmentsFromDb.map((assessment) =>
    getHealthEntityDataWithLabelAndValue(assessment, prescriptionViewSettings),
  )

  optionsArray = [...indexedDbOptions]

  var hasMore = true
  if (indexedDbOptions.length === 0) {
    const response = await getCPDataWithoutParams(
      `${searchApiSignature}?search=${search}&clinicId=${clinicId}&clinicBrandId=${clinicBrandId}&page=${page}&pageSize=10`,
    )
    if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
      addOrUpdatePsychAssessmentsInIdb(response?.data)
      optionsArray = response?.data?.map((option, index) =>
        getHealthEntityDataWithLabelAndValue(option, prescriptionViewSettings),
      )
    } else {
      hasMore = false
    }
  } else {
    hasMore = false
  }

  if (page === 1 && !search) {
    var foundAssessments = await getPsychAssessmentsByIds(recommendedAssessmentIds)
    if ((foundAssessments?.length || 0) < (recommendedAssessmentIds?.length || 0)) {
      const missingAssessmentIds = recommendedAssessmentIds?.filter((assId) => {
        return !foundAssessments?.find((ass) => ass.id === assId)
      })
      const missingResp = await getCPDataWithoutParams(
        `/api/secure/clinic-practitioner/psych-assessment/list?ids=${missingAssessmentIds.join(',')}`,
      )
      if (
        missingResp.status === 200 &&
        Array.isArray(missingResp.data) &&
        missingResp.data.length > 0
      ) {
        addOrUpdatePsychAssessmentsInIdb(missingResp.data)
        foundAssessments = [...foundAssessments, ...missingResp.data]
      }
    }
    optionsArray = [
      ...foundAssessments?.map((ass) =>
        getHealthEntityDataWithLabelAndValue(ass, prescriptionViewSettings),
      ),
      ...optionsArray,
    ]
  }

  const isPediatrician = !!doctorSpecializations?.find((spec) => spec === 'pediatrician')
  if (isPediatrician && optionsArray.length > 0) {
    const childItems = optionsArray
      .filter((item) => item.ageGroup === 'child')
      .sort((a, b) => a.label.localeCompare(b.label))
    const otherItems = optionsArray
      .filter((item) => item.ageGroup !== 'child')
      .sort((a, b) => a.label.localeCompare(b.label))
    optionsArray = [...childItems, ...otherItems]
  }

  // Extract diagnosis and complaints IDs from optionsArray and fetch their data
  try {
    // Collect all unique diagnosis and complaints IDs from optionsArray
    const allDiagnosisIds = new Set()
    const allComplaintIds = new Set()

    optionsArray.forEach((option) => {
      // Process diagnosis field if it exists and is a string
      if (option.diagnosis && typeof option.diagnosis === 'string') {
        option.diagnosis.split(',').forEach((id) => {
          const trimmedId = id.trim()
          if (trimmedId) allDiagnosisIds.add(trimmedId)
        })
      }

      // Process complaints field if it exists and is a string
      if (option.complaints && typeof option.complaints === 'string') {
        option.complaints.split(',').forEach((id) => {
          const trimmedId = id.trim()
          if (trimmedId) allComplaintIds.add(trimmedId)
        })
      }
    })

    // Fetch all complaints and diagnosis data
    let foundComplaints = []
    let foundDiagnosis = []

    if (allComplaintIds.size > 0) {
      foundComplaints = await getHealthComplaintsByIds(Array.from(allComplaintIds))
    }

    if (allDiagnosisIds.size > 0) {
      foundDiagnosis = await getDiagnosisByIds(Array.from(allDiagnosisIds))
    }

    // Now populate each option with its corresponding complaints and diagnosis data
    optionsArray = optionsArray.map((option) => {
      const updatedOption = { ...option }

      // Add foundComplaints data for this option
      if (option.complaints && typeof option.complaints === 'string') {
        const complaintIds = option.complaints
          .split(',')
          .map((id) => id.trim())
          .filter((id) => id)
        updatedOption.foundComplaints = foundComplaints.filter((complaint) =>
          complaintIds.includes(complaint.id?.toString()),
        )?.[0]
      } else {
        updatedOption.foundComplaints = null
      }

      // Add foundDiagnosis data for this option
      if (option.diagnosis && typeof option.diagnosis === 'string') {
        const diagnosisIds = option.diagnosis
          .split(',')
          .map((id) => id.trim())
          .filter((id) => id)
        updatedOption.foundDiagnosis = foundDiagnosis.filter((diagnosis) =>
          diagnosisIds.includes(diagnosis.id?.toString()),
        )?.[0]
      } else {
        updatedOption.foundDiagnosis = null
      }

      return updatedOption
    })
  } catch (error) {
    console.error('Error fetching complaints and diagnosis data from options:', error)
  }

  return {
    options: optionsArray,
    hasMore,
    additional: {
      page: page + 1,
      clinicId,
      prescriptionViewSettings,
      searchApiSignature,
      doctorSpecializations,
    },
  }
}

const loadOptionsTherapists = async () => {
  const response = await getCPDataWithoutParams(
    `/api/external/mentor/1on1/list?categories=clinical_psychologist&page=1&pageSize=100`,
  )
  var optionsArray = []

  if (response.status === 200 && Array.isArray(response.data) && response.data.length > 0) {
    optionsArray = response?.data?.map((option, index) => {
      return {
        ...option,
        value: option?.id,
        label: option?.name,
      }
    })
  }
  return optionsArray
}

function getHealthEntityDataWithLabelAndValue(entity, prescriptionViewSettings) {
  // if (!!prescriptionViewSettings) {
  //   console.log(prescriptionViewSettings?.preferredPrescriptionLanguages)
  // }
  // else{
  //   console.log("No prescriptionViewSettings")
  // }
  if (prescriptionViewSettings?.preferredPrescriptionLanguages?.includes('hi')) {
    return {
      ...(entity || {}),
      value: entity?.title,
      label: `${entity?.title}${
        entity?.translations?.hi?.title ? ` (${entity?.translations?.hi?.title})` : ''
      }`,
    }
  } else {
    return {
      ...(entity || {}),
      value: entity?.title,
      label: entity?.title,
    }
  }
}

// export const InstructionsMenu = ({
//   clinicId,
//   clinicBrandId,
//   selectedInstructions,
//   setSelectedInstructions,
// }) => {
//   // const CreatableAsyncPaginate = withAsyncPaginate(Creatable)
//   // const onCreateOption = useCallback(async (inputValue) => {
//   //   const instructionToInsert = {
//   //     apiParam: 'instruction',
//   //     title: inputValue,
//   //     label: inputValue,
//   //     value: inputValue,
//   //     __isNew: true,
//   //   }
//   //   setSelectedInstructions((prev) => [...(prev || []), instructionToInsert])
//   // }, [])

//   return (
//     <div style={{ width: '100%' }}>
//       <InstructionsSelect
//         id="instructionsSelection"
//         classNamePrefix="instructions_selection"
//         noOptionsMessage={() => 'Type to add new a instruction'}
//         maxMenuHeight={300}
//         placeholder=""
//         menuIsOpen
//         isMulti={true}
//         closeMenuOnSelect={false}
//         debounceTimeout={500}
//         loadOptions={loadOptionsInstructions}
//         additional={{ page: 1, clinicId: clinicId, clinicBrandId: clinicBrandId }}
//         styles={commonStylesPrescriptionSelect}
//         isClearable={true}
//         isSearchable={true}
//         defaultOptions={false}
//         // onCreateOption={onCreateOption}
//         getOptionValue={(option) => option?.value}
//         getOptionLabel={(option) => option?.label}
//         value={selectedInstructions}
//         onChange={(value) => {
//           setSelectedInstructions(value)
//         }}
//       />
//     </div>
//   )
// }

// export const PrescriptionNextVisitComponent = ({
//   nextVisitInputType,
//   setNextVisitInputType,
//   nextVisitInputValue,
//   setNextVisitInputValue,
//   bookedEventInfoStartTime,
// }) => {
//   const [calendarVisible, setCalendarVisible] = useState(false)
//   const todayDate = new Date()
//   const maxDate = new Date()
//   maxDate?.setMonth(todayDate?.getMonth() + 12)

//   const minDate = new Date(bookedEventInfoStartTime)
//   minDate.setHours(0, 0, 0, 0)

//   return (
//     <>
//       <div>
//         <PMPSectionInputLabel main className="d-flex gap-2 align-items-center">
//           <div>Next Visit</div>
//           <CancelIcon
//             style={{ color: 'red', fontSize: '16px', cursor: 'pointer' }}
//             onClick={() => {
//               setNextVisitInputValue('')
//               setNextVisitInputType('days')
//             }}
//           />
//         </PMPSectionInputLabel>
//         <div className="d-flex" style={{ gap: '16px' }}>
//           <div style={{ width: '120px' }}>
//             <PMPSectionInputBox
//               className="pmpTextarea-focus:focus"
//               placeholder={`No of ${nextVisitInputType}`}
//               type="number"
//               style={{ background: '#fff' }}
//               value={nextVisitInputValue}
//               onChange={(e) => {
//                 const value = getValidNumberFromStringNumber(e.target.value)
//                 if (value >= 0) {
//                   setNextVisitInputValue(value)
//                 }
//               }}
//             />
//           </div>
//           <div style={{ width: '200px' }}>
//             <RectangleRadioButton
//               disabled={false}
//               options={[
//                 { label: 'Days', id: 'days' },
//                 { label: 'Weeks', id: 'weeks' },
//                 { label: 'Months', id: 'months' },
//               ]}
//               selectedId={nextVisitInputType}
//               selectionFunction={(id) => setNextVisitInputType(id)}
//             />
//           </div>
//           <div className="d-flex align-items-start gap-2">
//             <div>or</div>
//             <DayjsDatePicker
//               date={calculateNextVistDateInMoment(
//                 nextVisitInputValue,
//                 nextVisitInputType,
//                 dayjs.utc(bookedEventInfoStartTime),
//               ).local()}
//               calendarProps={{
//                 minDate: minDate,
//                 maxDate: maxDate,
//                 minDetail: 'decade',
//                 showNeighbouringMonth: false,
//                 locale: sessionStorage.getItem('languageCode') || 'en',
//               }}
//               format="DD/MM/YYYY, dddd"
//               buttonProps={{
//                 variant: 'outlined',
//                 size: 'small',
//                 startIcon: <CalendarMonthIcon />,
//                 sx: {
//                   background: '#fff',
//                   textTransform: 'none',
//                   border: '1px solid #cccccc',
//                 },
//                 // disableRipple: true,
//               }}
//               extraHandlingAfterOnClick={() => {
//                 if (
//                   (nextVisitInputValue === null || nextVisitInputValue === undefined) &&
//                   !calendarVisible
//                 ) {
//                   setNextVisitInputValue(7)
//                 }
//               }}
//               onChange={(nextValue) => {
//                 const differenceInDays = calculateNextVisitDaysFromDateDayjs(
//                   dayjs(nextValue).format(MOMENT_FORMATS.formatThatServerSends),
//                   dayjs.utc(bookedEventInfoStartTime).local(),
//                 )
//                 setNextVisitInputType('days')
//                 setNextVisitInputValue(differenceInDays)
//               }}
//               placeholder="Choose Next Visit Date"
//             />
//             {/* {nextVisitInputValue && nextVisitInputType && (
//               <div>
//                 (
//                 {calculateNextVisitDate(
//                   nextVisitInputValue,
//                   nextVisitInputType,
//                   'DD/MM/YYYY, dddd',
//                 )}
//                 )
//               </div>
//             )} */}
//             {/* <div className="d-flex">
//               Calendar
//               <CalendarMonthIcon
//                 style={{ cursor: 'pointer', marginLeft: '12px' }}
//                 onClick={() => {
//                   if (
//                     (nextVisitInputValue === null || nextVisitInputValue === undefined) &&
//                     !calendarVisible
//                   ) {
//                     setNextVisitInputValue(7)
//                   }
//                   setCalendarVisible((prev) => !prev)
//                 }}
//               />
//             </div> */}
//           </div>
//         </div>
//         {/* {calendarVisible && (
//           <PMPCalendarContainer>
//             <Calendar
//               onChange={(nextValue) => {
//                 const differenceInDays = calculateNextVisitDaysFromDate(nextValue)
//                 setNextVisitInputType('days')
//                 setNextVisitInputValue(differenceInDays)
//               }}
//               value={calculateNextVisitDate(nextVisitInputValue, nextVisitInputType)}
//               minDate={minDate}
//               maxDate={maxDate}
//               minDetail="decade"
//               showNeighboringMonth={false}
//               locale={sessionStorage.getItem('languageCode') || 'en'}
//             />
//           </PMPCalendarContainer>
//         )} */}
//       </div>
//     </>
//   )
// }

const CreatableAsyncPaginate = withAsyncPaginate(Creatable)

export const SuggestedTherapySelectMenu = ({
  clinicId,
  selectedTherapies,
  setSelectedTherapies,
  menuPortalTarget,
  maxZIndex,
  isMulti = true,
  closeMenuOnSelect,
}) => {
  const [inputValue, setInputValue] = useState('')

  // If closeMenuOnSelect is not provided, default to: close for single select, keep open for multi-select
  const shouldCloseOnSelect = closeMenuOnSelect !== undefined 
    ? closeMenuOnSelect 
    : !isMulti

  return (
    <div style={{ width: '100%' }}>
      <CreatableAsyncPaginate
        id="suggestedTherapiesSelection"
        placeholder="Suggest Therapies"
        isMulti={isMulti}
        isClearable={true}
        isSearchable={true}
        defaultOptions={false}
        loadOptions={loadOptionsSuggestedTherapies}
        closeMenuOnSelect={shouldCloseOnSelect}
        getOptionValue={(option) => option?.value || option?.title}
        getOptionLabel={(option) => option?.label || option?.title || option?.value || ''}
        formatOptionLabel={formatOptionLabelWithHighlight}
        value={selectedTherapies}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPortalTarget ? 'fixed' : undefined}
        menuPlacement="auto"
        maxZIndex={maxZIndex}
        onChange={(value) => {
          setSelectedTherapies(value)
        }}
        debounceTimeout={500}
        additional={{
          page: 1,
          clinicId: clinicId,
          baseApiSignature: '/api/secure/clinic-practitioner/therapy-type/list',
        }}
        styles={commonStylesPrescriptionSelect}
        inputValue={inputValue}
        onInputChange={(a, b) => {
          setInputValue((prev) => {
            if (prev === a) {
              return prev
            }
            return a || ''
          })
          handleChangeHealthEntityInputType1(a, b, setSelectedTherapies)
        }}
        onKeyDown={(e) =>
          handleKeyDownAndSupportEdit(
            e,
            inputValue,
            selectedTherapies,
            setSelectedTherapies,
            setInputValue,
          )
        }
      />
    </div>
  )
}

export const SuggestedAssessmentsSelectMenu = ({
  clinicId,
  clinicBrandId,
  selectedAssessments,
  setSelectedAssessments,
  recommendedAssessments,
  prescriptionViewSettings,
  menuPortalTarget,
  maxZIndex,
  customPlaceholder = 'Search or add new Psych Assessments...',
  isNotCreatable = false,
  searchApiSignature = '/api/secure/clinic-practitioner/psych-assessment/list',
  doctorSpecializations = [],
  isMulti = true,
  disabled = false,
}) => {
  const [inputValue, setInputValue] = useState('')
  const AssessmentSelect = isNotCreatable ? AssessmentAsyncSelect : AssessmentCreatableSelect
  
  const getAssessmentLabel = (option) => {
    if (!!option?.label) {
      if (doctorSpecializations?.includes('pediatrician')) {
        if (option?.foundDiagnosis?.title || option?.foundComplaints?.title) {
          let bracketLabel = ''
          if (option?.foundDiagnosis?.title) {
            bracketLabel = `${option?.foundDiagnosis?.title}`
          }
          if (!!bracketLabel) {
            bracketLabel = 'and ' + bracketLabel
          }
          if (option?.foundComplaints?.title) {
            bracketLabel = `${option?.foundComplaints?.title}`
          }
          return `${option?.label} (For: ${bracketLabel})`
        } else {
          return option?.label
        }
      } else {
        return option?.label
      }
    } else {
      return option?.label
    }
  }

  const formatAssessmentOptionLabel = (option, { context, inputValue: searchValue }) => {
    // For selected values in the control, just show the plain label
    if (context === 'value') {
      return getAssessmentLabel(option)
    }
    
    // For dropdown menu options, add highlighting
    if (!searchValue) {
      return getAssessmentLabel(option)
    }

    const label = getAssessmentLabel(option)
    const searchText = searchValue.toLowerCase()
    const labelLower = label.toLowerCase()
    
    const matchIndex = labelLower.indexOf(searchText)
    
    if (matchIndex === -1) {
      return label
    }

    const before = label.slice(0, matchIndex)
    const match = label.slice(matchIndex, matchIndex + searchValue.length)
    const after = label.slice(matchIndex + searchValue.length)

    return (
      <span>
        {before}
        <span style={{ 
          fontWeight: 700, 
          color: '#4338ca',
          backgroundColor: 'rgba(67, 56, 202, 0.1)',
          padding: '1px 3px',
          borderRadius: '3px',
        }}>
          {match}
        </span>
        {after}
      </span>
    )
  }

  return (
    <div style={{ width: '100%' }}>
      <AssessmentSelect
        additional={{
          page: 1,
          clinicId: clinicId,
          clinicBrandId: clinicBrandId,
          prescriptionViewSettings: prescriptionViewSettings,
          doctorSpecializations: doctorSpecializations,
        }}
        id="suggestedAssessmentsSelected"
        closeMenuOnSelect={false}
        createOptionPosition="first"
        placeholder={customPlaceholder}
        isDisabled={disabled}
        isMulti={isMulti}
        isClearable={true}
        isSearchable={true}
        defaultOptions={false}
        loadOptions={loadOptionsSuggestedAssessments}
        getOptionValue={(option) => option?.value}
        getOptionLabel={getAssessmentLabel}
        formatOptionLabel={formatAssessmentOptionLabel}
        value={selectedAssessments}
        menuPortalTarget={menuPortalTarget}
        menuPosition={menuPortalTarget ? 'fixed' : undefined}
        menuPlacement="auto"
        maxZIndex={maxZIndex}
        onChange={(value) => {
          setSelectedAssessments(value)
        }}
        debounceTimeout={200}
        styles={commonStylesPrescriptionSelect}
        inputValue={inputValue}
        onInputChange={(a, b) => {
          setInputValue((prev) => {
            if (prev === a) {
              return prev
            }
            return a || ''
          })
          handleChangeHealthEntityInputType1(a, b, setSelectedAssessments)
        }}
        onKeyDown={(e) =>
          handleKeyDownAndSupportEdit(
            e,
            inputValue,
            selectedAssessments,
            setSelectedAssessments,
            setInputValue,
          )
        }
      />
    </div>
  )
}

export const TherapistSelectMenu = ({ selectedTherapist, setSelectedTherapist }) => {
  return (
    <div style={{ width: '100%' }}>
      <AsyncSelect
        id="therapistSelection"
        defaultOptions={true}
        isClearable={true}
        isSearchable={true}
        loadOptions={loadOptionsTherapists}
        placeholder="Select Therapist"
        styles={commonStylesPrescriptionSelect}
        menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
        menuPosition="fixed"
        menuPlacement="auto"
        getOptionValue={(option) => option?.value}
        getOptionLabel={(option) => option?.label}
        value={selectedTherapist}
        onChange={(value) => {
          setSelectedTherapist(value)
        }}
      />
    </div>
  )
}

///// helper functions:

// drugs related

export function handleDrugAdviceChange(toChange, indexToChange, newValue, setDrugsAdvice) {
  if (toChange === 'drug') {
    setDrugsAdvice((prev) => {
      const prevArray = [...prev]
      prevArray[indexToChange].drug = newValue
      return prevArray
    })
  } else if (toChange === 'dosage') {
    setDrugsAdvice((prev) => {
      const prevArray = [...prev]
      const row = { ...prevArray[indexToChange], dosage: newValue }

      // A pattern dose implies the time of day, so auto-fill When to match
      // (0-0-1 -> Night) instead of leaving something unrelated like "after
      // breakfast". Only empty or previously auto-filled values are touched —
      // a When the practitioner picked themselves is never overwritten.
      const currentWhatTime = row.whatTime
      if (!currentWhatTime?.label || currentWhatTime?.__autoFilledWhatTime) {
        const suggestedWhatTime =
          newValue?.suggestedWhatTime || getSuggestedWhatTimeForDosage(newValue?.label)
        if (suggestedWhatTime) {
          row.whatTime = {
            label: suggestedWhatTime,
            value: suggestedWhatTime,
            __autoFilledWhatTime: true,
          }
        } else if (currentWhatTime?.__autoFilledWhatTime) {
          row.whatTime = null
        }
      }

      prevArray[indexToChange] = row
      return prevArray
    })
  } else if (toChange === 'whatTime') {
    setDrugsAdvice((prev) => {
      const prevArray = [...prev]
      prevArray[indexToChange].whatTime = newValue
      return prevArray
    })
  } else if (toChange === 'frequency') {
    setDrugsAdvice((prev) => {
      const prevArray = [...prev]
      prevArray[indexToChange].frequency = newValue
      return prevArray
    })
  } else if (toChange === 'duration') {
    setDrugsAdvice((prev) => {
      const prevArray = [...prev]
      prevArray[indexToChange] = { ...prevArray[indexToChange], duration: newValue }

      // Duration picked on the first medicine row becomes the default for the rows
      // below it. Only rows whose duration is empty or was itself auto-filled get
      // updated, so explicit per-row choices are never overwritten.
      const firstFilledRowIndex = prevArray.findIndex((row) => row?.drug?.label)
      if (indexToChange === firstFilledRowIndex && newValue?.label) {
        for (let i = firstFilledRowIndex + 1; i < prevArray.length; i++) {
          const row = prevArray[i]
          if (!row?.drug?.label) continue
          if (!row?.duration?.label || row?.duration?.__autoFilledDuration) {
            prevArray[i] = { ...row, duration: { ...newValue, __autoFilledDuration: true } }
          }
        }
      }
      return prevArray
    })
  } else if (toChange === 'notes') {
    setDrugsAdvice((prev) => {
      const prevArray = [...prev]
      prevArray[indexToChange].notes = newValue
      return prevArray
    })
  } else if (toChange === 'drugType') {
    setDrugsAdvice((prev) => {
      const prevArray = [...prev]
      prevArray[indexToChange].drugType = newValue
      return prevArray
    })
  }
}

export function autoSuggestDrugAdviceUsingDrug(
  indexToChange,
  newValue,
  setDrugsAdvice,
  drugTypeOptions,
) {
  setDrugsAdvice((prev) => {
    const newArray = [...prev]
    const newObject = newArray?.[indexToChange]
    if (
      Boolean(newObject?.dosage) ||
      Boolean(newObject?.duration) ||
      Boolean(newObject?.notes) ||
      Boolean(newObject?.frequency) ||
      Boolean(newObject?.medType) ||
      Boolean(newObject?.drugInfoType) ||
      Boolean(newObject?.whatTime)
    ) {
    } else {
      newObject.dosage = newValue?.dosage
        ? { value: newValue?.dosage, label: newValue?.dosage }
        : null
      // The duration chosen on the first medicine row is the default for every row
      // after it; the drug's own default timing is only used when there is none.
      const firstFilledRowIndex = newArray.findIndex((row) => row?.drug?.label)
      const firstRowDuration =
        firstFilledRowIndex >= 0 && firstFilledRowIndex < indexToChange
          ? newArray[firstFilledRowIndex]?.duration
          : null
      newObject.duration = firstRowDuration?.label
        ? { ...firstRowDuration, __autoFilledDuration: true }
        : newValue?.timing
        ? { value: newValue?.timing, label: newValue?.timing }
        : null
      newObject.notes = newValue?.note ? { value: newValue?.note, label: newValue?.note } : null
      newObject.frequency = newValue?.frequency
        ? { value: newValue?.frequency, label: newValue?.frequency }
        : null
      newObject.whatTime = newValue?.whatTime
        ? { value: newValue?.whatTime, label: newValue?.whatTime }
        : null

      if (newValue?.drugInfoType || newValue?.medType) {
        const foundMedKey =
          newValue?.drugInfoType ||
          drugTypeOptions?.find((type) => type?.medType === newValue?.medType)

        newObject.drugType = foundMedKey
          ? { value: foundMedKey?.shortTitle, label: foundMedKey?.shortTitle }
          : null
      }
      newArray[indexToChange] = newObject
    }
    return newArray
  })
}

export function nullAllValuesOfDrugAdvice(indexToChange, setDrugsAdvice) {
  setDrugsAdvice((prev) => {
    const prevArray = [...prev]
    prevArray[indexToChange] = {
      drug: null,
      dosage: null,
      whatTime: null,
      frequency: null,
      duration: null,
      notes: null,
    }
    return prevArray
  })
}

export function handleDeleteDrugAdviceItem(deletedItemIndex, setDrugsAdvice) {
  setDrugsAdvice((prev) => {
    const prevArray = [...prev]
    const deletedRow = prevArray[deletedItemIndex]
    prevArray.splice(deletedItemIndex, 1)
    // If the head row of a taper group is deleted, promote the continuation row
    // below it to a normal row so it does not point at a medicine that is gone.
    if (!deletedRow?.isTaperContinuation && prevArray[deletedItemIndex]?.isTaperContinuation) {
      prevArray[deletedItemIndex] = { ...prevArray[deletedItemIndex], isTaperContinuation: false }
    }
    return prevArray
  })
}

// Inserts a linked row below the given one for the same medicine, used for
// follow-up schedules of one medicine (e.g. tapering: 15 days at one dose,
// then a lower dose from day 16 onwards).
export function handleAddTaperDrugAdviceRow(parentRowIndex, setDrugsAdvice) {
  setDrugsAdvice((prev) => {
    const prevArray = [...(prev || [])]
    const parentRow = prevArray[parentRowIndex]
    if (!parentRow?.drug?.label) {
      return prevArray
    }
    const firstFilledRow = prevArray.find((row) => row?.drug?.label)
    const firstRowDuration = firstFilledRow?.duration?.label ? firstFilledRow.duration : null
    prevArray.splice(parentRowIndex + 1, 0, {
      drug: { ...parentRow.drug },
      drugType: parentRow.drugType ? { ...parentRow.drugType } : null,
      dosage: null,
      whatTime: null,
      frequency: null,
      duration: firstRowDuration ? { ...firstRowDuration, __autoFilledDuration: true } : null,
      notes: null,
      isTaperContinuation: true,
    })
    return prevArray
  })
}

export function handleAddDrugAdviceItem(setDrugsAdvice, drugItem) {
  setDrugsAdvice((prev) => {
    const prevArray = [...(prev || [])]
    if (drugItem) {
      prevArray.push({
        drug: drugItem,
        dosage: { label: drugItem?.dosage, value: drugItem?.dosage },
        whatTime: { label: drugItem?.whatTime, value: drugItem?.whatTime },
        frequency: { label: drugItem?.frequency, value: drugItem?.frequency },
        duration: { label: drugItem?.timing, value: drugItem?.timing },
        notes: { label: drugItem?.note, value: drugItem?.note },
      })
    } else {
      prevArray.push({
        drug: null,
        dosage: null,
        whatTime: null,
        frequency: null,
        duration: null,
        notes: null,
      })
    }
    return prevArray
  })
}

export function getDrugsListArrayForSubmission(
  drugsAdvice,
  clinicId,
  clinicBrandId,
  newlySavedItems,
  prescriptionViewSettings,
  prescriptionData,
) {
  // Bake the patient explainer in the pad's chosen print language (prescriptionData.preferredLanguage)
  // when set, else the practitioner-wide default — so a saved prescription's explainer matches the
  // language its pad prints in.
  const explainerLanguage = getRxExplainerLanguage(prescriptionViewSettings, prescriptionData)
  const toReturn = []
  if (Array.isArray(drugsAdvice) && drugsAdvice.length > 0) {
    drugsAdvice?.forEach((drugAdviceItem, drugAdviceItemIndex) => {
      if (drugAdviceItem?.drug?.label) {
        const foundDrug = getHealthEntityFromHEMapArray(
          newlySavedItems,
          HE_KEY_DRUGS,
          drugAdviceItem?.drug?.label,
        )

        toReturn.push({
          ...drugAdviceItem?.drug,
          apiParam: 'drug-info',
          clinicId: clinicId,
          clinicBrandId: clinicBrandId,
          id:
            getIdForHealthEntity(newlySavedItems, HE_KEY_DRUGS, drugAdviceItem?.drug?.label) ??
            drugAdviceItem?.drug?.id,
          name: drugAdviceItem?.drug?.label ?? null,
          doctorId: foundDrug?.doctorId,
          commonId: foundDrug?.commonId,
          dosage: drugAdviceItem?.dosage?.label ?? null,
          whatTime: drugAdviceItem?.whatTime?.label ?? null,
          frequency: drugAdviceItem?.frequency?.label ?? null,
          timing: drugAdviceItem?.duration?.label ?? null,
          note: drugAdviceItem?.notes?.label ?? null,
          drugInfoType: drugAdviceItem?.drugType
            ? {
                apiParam: HE_DRUG_ADVICE_TYPE,
                ...drugAdviceItem?.drugType,
                shortTitle: drugAdviceItem?.drugType?.label,
                title: drugAdviceItem?.drugType?.label,
              }
            : null,
          drugAdviceDosage: drugAdviceItem?.dosage?.label
            ? {
                apiParam: HE_DRUG_ADVICE_DOSAGE,
                ...drugAdviceItem?.dosage,
                title: drugAdviceItem?.dosage?.label,
              }
            : null,
          drugAdviceNote: drugAdviceItem?.notes?.label
            ? {
                apiParam: HE_DRUG_ADVICE_NOTE,
                ...drugAdviceItem?.notes,
                title: drugAdviceItem?.notes?.label,
              }
            : null,
          drugAdviceFrequency: drugAdviceItem?.frequency?.label
            ? {
                apiParam: HE_DRUG_ADVICE_FREQUENCY,
                ...drugAdviceItem?.frequency,
                title: drugAdviceItem?.frequency?.label,
              }
            : null,
          drugAdviceWhatTime: drugAdviceItem?.whatTime?.label
            ? {
                apiParam: HE_DRUG_ADVICE_TIMING,
                ...drugAdviceItem?.whatTime,
                title: drugAdviceItem?.whatTime?.label,
              }
            : null,
          drugAdviceDuration: drugAdviceItem?.duration?.label
            ? {
                apiParam: HE_DRUG_ADVICE_DURATION,
                ...drugAdviceItem?.duration,
                title: drugAdviceItem?.duration?.label,
              }
            : null,
          genericName: foundDrug?.genericName,
          genericFormulaId: foundDrug?.genericFormulaId,
          // marks this entry as a follow-up schedule (e.g. taper) of the row above;
          // undefined keys are dropped from the JSON payload for normal rows
          taperContinuation: drugAdviceItem?.isTaperContinuation === true ? true : undefined,
          // patient-friendly sentence in the prescription's language (server-rendered
          // outputs use this); an excluded row persists the practitioner's choice
          patientExplainer:
            drugAdviceItem?.explainerExcluded === true
              ? undefined
              : buildRxPatientExplainerForRow(
                  drugAdviceItem,
                  explainerLanguage,
                  drugAdviceItemIndex > 0 ? drugsAdvice[drugAdviceItemIndex - 1] : undefined,
                ) || undefined,
          patientExplainerExcluded: drugAdviceItem?.explainerExcluded === true ? true : undefined,
        })
      }
    })
  }
  return toReturn
}

export async function saveNewDrugs(drugsAdvice, clinicId, clinicBrandId, mentorId) {
  let toSave = []
  let toSaveGenericDrug = []

  const toReturn = []
  if (Array.isArray(drugsAdvice) && drugsAdvice.length > 0) {
    drugsAdvice?.forEach((drugAdviceItem) => {
      let formedDrugObject = {
        apiParam: 'drug-info',
        id: drugAdviceItem?.drug?.id,
        clinicId: clinicId,
        clinicBrandId: clinicBrandId,
        commonId: drugAdviceItem?.drug?.commonId,
        doctorId: drugAdviceItem?.drug?.doctorId,
        genericNameId: drugAdviceItem?.drug?.genericNameId,
        genericFormulaId: drugAdviceItem?.drug?.genericFormulaId,
        genericName: drugAdviceItem?.drug?.genericName,
        name: drugAdviceItem?.drug?.label ?? null,
        dosage: drugAdviceItem?.dosage?.label ?? null,
        whatTime: drugAdviceItem?.whatTime?.label ?? null,
        frequency: drugAdviceItem?.frequency?.label ?? null,
        timing: drugAdviceItem?.duration?.label ?? null,
        note: drugAdviceItem?.notes?.label ?? null,
        medKey: drugAdviceItem?.drugType?.medKey ?? null,
        drugTypeId: drugAdviceItem?.drugType?.id ?? null,
        drugInfoType: drugAdviceItem?.drugType?.label
          ? {
              apiParam: HE_DRUG_ADVICE_TYPE,
              ...drugAdviceItem?.drugType,
              shortTitle: drugAdviceItem?.drugType?.value,
              title: drugAdviceItem?.drugType?.value,
            }
          : null,
        drugAdviceDosage: drugAdviceItem?.dosage?.label
          ? { apiParam: 'drug-advice-dosage', ...drugAdviceItem?.dosage }
          : null,
        drugAdviceNote: drugAdviceItem?.notes?.label
          ? { apiParam: 'drug-advice-note', ...drugAdviceItem?.notes }
          : null,
        drugAdviceFrequency: drugAdviceItem?.frequency?.label
          ? { apiParam: 'drug-advice-frequency', ...drugAdviceItem?.frequency }
          : null,
        drugAdviceWhatTime: drugAdviceItem?.whatTime?.label
          ? { apiParam: 'drug-advice-timing', ...drugAdviceItem?.whatTime }
          : null,
        drugAdviceDuration: drugAdviceItem?.duration?.label
          ? { apiParam: 'drug-advice-duration', ...drugAdviceItem?.duration }
          : null,
      }

      if (!drugAdviceItem?.drug?.label) {
        return
      }

      // taper continuation rows reuse the medicine of their head row; only the head
      // row should create/update the drug master's defaults
      if (drugAdviceItem?.isTaperContinuation) {
        return
      }

      if (drugAdviceItem?.drug?.__isNew__) {
        formedDrugObject = { ...formedDrugObject, commonId: null, id: null }
      } else {
        if (!!drugAdviceItem?.drug?.doctorId) {
          formedDrugObject = {
            ...formedDrugObject,
            commonId: formedDrugObject?.commonId,
            id: formedDrugObject?.id,
          }
        } else {
          if (!drugAdviceItem?.drug?.doctorId) {
            formedDrugObject = {
              ...formedDrugObject,
              commonId: formedDrugObject?.id,
              id: null,
            }
          }
        }
      }
      // if (drugAdviceItem?.drug?.__isNew__) {
      //   formedDrugObject = { ...formedDrugObject, id: null }
      // } else {
      //   if (!formedDrugObject?.doctorId) {
      //     formedDrugObject = { ...formedDrugObject, commonId: formedDrugObject?.id, id: null }
      //   }
      // }

      formedDrugObject = { ...formedDrugObject, doctorId: mentorId }
      toSave.push(formedDrugObject)
    })
  }

  toSaveGenericDrug = await Promise.all(
    toSave.map(async (drugItem, index) => {
      if (!drugItem?.genericName) {
        return
      }
      const foundGenericDrug = await getGenericDrugItemObject({
        clinicBrandId: clinicBrandId,
        clinicId: clinicId,
        doctorId: mentorId,
        genericNameId: drugItem?.genericFormulaId,
        genericNameTitle: drugItem?.genericName,
      })
      return foundGenericDrug
      //if no id push into the save Array
      //
      //else check if title change, if yes push to save idx with the id
    }),
  )

  toSaveGenericDrug = (toSaveGenericDrug || [])?.filter((item) => item)
  //save the generic drugs
  const savedGenericNames = await saveAndAddToIdbGenericNames({
    genericDrugs: toSaveGenericDrug,
    clinicBrandId,
    clinicId,
  })

  //put the new formed genericNameId in the toSaveDrug array
  toSave = toSave.map((item, index) => {
    if (item?.genericName) {
      const foundGenericName = savedGenericNames?.find(
        (genName) => genName?.title === item?.genericName,
      )
      if (foundGenericName) {
        return { ...item, genericFormulaId: foundGenericName?.id }
      }
    }
    return item
  })

  const promises = toSave.map(async (item) => {
    const response = await postMPDataWithoutParams(
      `/api/secure/drug/save?clinicId=${clinicId}&clinicBrandId=${clinicBrandId}`,
      item,
    )
    let drugItem = item
    if (
      response?.status === 200 &&
      isCommonResponseSuccessful(response?.data?.code) &&
      response?.data?.data?.drugInfo?.id &&
      response?.data?.data?.drugInfo?.title
    ) {
      await addOrUpdateDrugsInIdb([response?.data?.data?.drugInfo])
      drugItem = response?.data?.data?.drugInfo
    }
    toReturn.push(drugItem)
  })

  await Promise.all(promises)
  return toReturn
}

export async function saveNewHealthComplaints(healthComplaints = [], clinicId, clinicBrandId) {
  const toSave = []
  if (Array.isArray(healthComplaints) && healthComplaints.length > 0) {
    healthComplaints?.forEach((healthComplaintItem) => {
      if (healthComplaintItem?.value && healthComplaintItem?.__isNew__) {
        toSave.push({
          apiParam: 'health-complaint',
          clinicId: clinicId,
          clinicBrandId: clinicBrandId,
          title: healthComplaintItem?.value ?? null,
          translations: healthComplaintItem?.translations,
        })
      }
    })
  }
  return await Promise.all(
    toSave.map(async (item) => {
      const response = await postMPDataWithoutParams(
        `/api/secure/doctor/health-complaint/save?clinicId=${clinicId}&clinicBrandId=${clinicBrandId}`,
        item,
      )
      if (
        response?.status === 200 &&
        isCommonResponseSuccessful(response?.data?.code) &&
        response?.data?.data?.['health-complaint']?.id &&
        response?.data?.data?.['health-complaint']?.title
      ) {
        await addOrUpdateHealthComplaintsInIdb([response?.data?.data?.['health-complaint']])
        return response?.data?.data?.['health-complaint']
      }
    }),
  )
}

export async function saveNewHealthEntityList(
  healthEntityObjects = [],
  healthEntityType,
  clinicId,
  clinicBrandId,
  isApplyingCompleteObject = false,
) {
  const toSave = []
  if (!healthEntityType) {
    throw new Error(`healthEntityType is required: saving data -> ${healthEntityObjects}`)
  }

  if (Array.isArray(healthEntityObjects) && healthEntityObjects.length > 0) {
    healthEntityObjects?.forEach((heItem) => {
      if (heItem?.label && heItem?.__isNew__) {
        toSave.push({
          apiParam: healthEntityType,
          ...(isApplyingCompleteObject ? heItem : {}),

          clinicId: clinicId,
          clinicBrandId: clinicBrandId,
          title: heItem?.value ?? null,
          translations: heItem?.translations,
        })
      }
    })
  }
  return await Promise.all(
    toSave.map(async (item) => {
      try {
        const response = await postMPDataWithoutParams(
          `/api/secure/doctor/${healthEntityType}/save?clinicId=${clinicId}&clinicBrandId=${clinicBrandId}`,
          item,
        )
        if (
          response?.status === 200 &&
          isCommonResponseSuccessful(response?.data?.code) &&
          response?.data?.data?.[healthEntityType]?.id &&
          response?.data?.data?.[healthEntityType]?.title
        ) {
          await getFunctionForAddOrUpdateHealthEntitySingle(
            healthEntityType,
            response?.data?.data?.[healthEntityType],
          )
          return response?.data?.data?.[healthEntityType]
        }
      } catch (error) {
        console.error(`Error saving ${healthEntityType}:`, error)
      }
    }),
  )
}

export async function saveNewDiagnosis(diagnosis = [], clinicId, clinicBrandId) {
  const toSave = []
  if (Array.isArray(diagnosis) && diagnosis.length > 0) {
    diagnosis?.forEach((diagnosisItem) => {
      if (diagnosisItem?.label && diagnosisItem?.__isNew__) {
        toSave.push({
          apiParam: 'diagnosis',
          clinicId: clinicId,
          clinicBrandId: clinicBrandId,
          title: diagnosisItem?.value ?? null,
          translations: diagnosisItem?.translations,
        })
      }
    })
  }
  return await Promise.all(
    toSave.map(async (item) => {
      const response = await postMPDataWithoutParams(
        `/api/secure/doctor/diagnosis/save?clinicId=${clinicId}&clinicBrandId=${clinicBrandId}`,
        item,
      )
      if (
        response?.status === 200 &&
        isCommonResponseSuccessful(response?.data?.code) &&
        response?.data?.data?.diagnosis?.id &&
        response?.data?.data?.diagnosis?.title
      ) {
        await addOrUpdateDiagnosisInIdb([response?.data?.data?.diagnosis])
        return response?.data?.data?.diagnosis
      }
    }),
  )
}

export async function saveNewObservations(observationsArray = [], clinicId, clinicBrandId) {
  const toSave = []
  if (Array.isArray(observationsArray) && observationsArray.length > 0) {
    observationsArray?.forEach((observationItem) => {
      if (observationItem?.label && observationItem?.__isNew__) {
        toSave.push({
          apiParam: 'health-observation',
          clinicId: clinicId,
          clinicBrandId: clinicBrandId,
          title: observationItem?.value ?? null,
          translations: observationItem?.translations,
        })
      }
    })
  }
  return await Promise.all(
    toSave.map(async (item) => {
      const response = await postMPDataWithoutParams(
        `/api/secure/doctor/health-observation/save?clinicId=${clinicId}&clinicBrandId=${clinicBrandId}`,
        item,
      )
      if (
        response?.status === 200 &&
        isCommonResponseSuccessful(response?.data?.code) &&
        response?.data?.data?.['health-observation']?.id &&
        response?.data?.data?.['health-observation']?.title
      ) {
        await addOrUpdateObservationsInIdb([response?.data?.data?.['health-observation']])
        return response?.data?.data?.['health-observation']
      }
    }),
  )
}

export async function saveNewPrescriptionAdvice(
  prescriptionAdviceArray = [],
  clinicId,
  clinicBrandId,
) {
  const toSave = []
  if (Array.isArray(prescriptionAdviceArray) && prescriptionAdviceArray.length > 0) {
    prescriptionAdviceArray?.forEach((adviceItem) => {
      if (adviceItem?.label && adviceItem?.__isNew__) {
        toSave.push({
          apiParam: 'prescription-advice',
          clinicId: clinicId,
          clinicBrandId: clinicBrandId,
          title: adviceItem?.value ?? null,
          translations: adviceItem?.translations,
        })
      }
    })
  }
  return await Promise.all(
    toSave.map(async (item) => {
      const response = await postMPDataWithoutParams(
        `/api/secure/doctor/prescription-advice/save?clinicId=${clinicId}&clinicBrandId=${clinicBrandId}`,
        item,
      )
      if (
        response?.status === 200 &&
        isCommonResponseSuccessful(response?.data?.code) &&
        response?.data?.data?.['prescription-advice']?.id &&
        response?.data?.data?.['prescription-advice']?.title
      ) {
        await addOrUpdateAdvicesInIdb([response?.data?.data?.['prescription-advice']])
        return response?.data?.data?.['prescription-advice']
      }
    }),
  )
}

export async function saveNewInstructions(instructionsArray = [], clinicId, clinicBrandId) {
  const toSave = []
  if (Array.isArray(instructionsArray) && instructionsArray.length > 0) {
    instructionsArray?.forEach((instructionItem) => {
      if (instructionItem?.value && instructionItem?.__isNew__) {
        toSave.push({
          apiParam: 'instruction',
          clinicId: clinicId,
          clinicBrandId: clinicBrandId,
          title: instructionItem?.value ?? null,
          translations: instructionItem?.translations,
        })
      }
    })
  }
  return Promise.all(
    toSave.map(async (item) => {
      const response = await postMPDataWithoutParams(
        `/api/secure/doctor/instruction/save?clinicId=${clinicId}&clinicBrandId=${clinicBrandId}`,
        item,
      )
      if (
        response?.status === 200 &&
        isCommonResponseSuccessful(response?.data?.code) &&
        response?.data?.data?.['instruction']?.id &&
        response?.data?.data?.['instruction']?.title
      ) {
        await addOrUpdateInstructionsInIdb([response?.data?.data?.['instruction']])
        return response?.data?.data?.['instruction']
      }
    }),
  )
}

export async function saveNewInvestigation(testName, clinicId, clinicBrandId) {
  const newItem = {
    apiParam: 'investigation',
    clinicId: clinicId,
    clinicBrandId: clinicBrandId,
    title: testName,
  }
  const response = await postMPDataWithoutParams(
    `/api/secure/doctor/investigation/save?clinicId=${clinicId}&clinicBrandId=${clinicBrandId}`,
    newItem,
  )
  if (response.status === 200) {
    toast.success('New Investigation Added')
  } else {
    toast.error('Failed to add')
  }
}

export const getInitialDataForSettingExistingDrugAdvice = (existingData, drugAdviceTypes) => {
  const toReturn = []
  if (Array.isArray(existingData) && existingData.length > 0) {
    existingData?.forEach((item) => {
      const dosageObj = getInitialDataForSettingSingleExistingHealthEntity(
        item?.drugAdviceDosage,
        item?.dosage,
      )

      const whatTimeObj = getInitialDataForSettingSingleExistingHealthEntity(
        item?.drugAdviceWhatTime,
        item?.whatTime,
      )
      const frequencyObj = getInitialDataForSettingSingleExistingHealthEntity(
        item?.drugAdviceFrequency,
        item?.frequency,
      )
      const durationObj = getInitialDataForSettingSingleExistingHealthEntity(
        item?.drugAdviceDuration,
        item?.timing,
      )
      const notesObj = getInitialDataForSettingSingleExistingHealthEntity(
        item?.drugAdviceNote,
        item?.note,
      )
      let drugType = item?.drugInfoType
        ? {
            label: item?.drugInfoType?.shortTitle,
            value: item?.drugInfoType?.shortTitle,
          }
        : null

      // Only resolve the type from medType when it is actually set. Otherwise the find matches a
      // stray drug-type whose medType is also undefined (e.g. a legacy "Cream" entry), wrongly
      // pre-filling Type — leave it blank instead.
      if (!drugType && item?.medType != null) {
        drugType = drugAdviceTypes?.find((type) => type?.medType === item?.medType)
        if (!!drugType) {
          drugType = { ...drugType, label: drugType?.shortTitle, value: drugType?.shortTitle }
        }
      }

      toReturn.push({
        drug: item?.title ? { ...item, label: item?.title, value: item?.title } : null,
        dosage: dosageObj,
        whatTime: whatTimeObj,
        frequency: frequencyObj,
        duration: durationObj,
        drugType: drugType,
        notes: notesObj,
        isTaperContinuation: item?.taperContinuation === true,
        explainerExcluded: item?.patientExplainerExcluded === true,
        // whatTime: item?.whatTime ? { label: item?.whatTime, value: item?.whatTime } : null,
        // frequency: item?.frequency ? { label: item?.frequency, value: item?.frequency } : null,
        // duration: item?.timing ? { label: item?.timing, value: item?.timing } : null,
        // notes: item?.note ? { label: item?.note, value: item?.note } : null,
      })
    })
  }
  return toReturn
}

export function getHealthEntityArrayForSubmission(
  healthEntityArray,
  healthEntityType,
  clinicId,
  clinicBrandId,
  newlySavedItems = [],
  returnAsStringArrays = false,
) {
  const toReturn = []
  if (Array.isArray(healthEntityArray) && healthEntityArray.length > 0) {
    healthEntityArray?.forEach((healthEntityItem) => {
      if (healthEntityItem?.label) {
        const entityObj = {
          ...healthEntityItem,
          id:
            healthEntityItem?.id ??
            getIdForHealthEntity(newlySavedItems, healthEntityType, healthEntityItem?.value),
          apiParam: healthEntityType,
          clinicId: clinicId,
          clinicBrandId: clinicBrandId,
          title: healthEntityItem?.label,
        }
        toReturn.push(entityObj)
      }
    })
  }
  if (returnAsStringArrays) {
    return toReturn.map((item) => item?.title)
  }
  return toReturn
}
// complaints array related:

export function getComplaintsArrayForSubmission(complaintsArray, clinicId, newlySavedItems) {
  const toReturn = []
  if (Array.isArray(complaintsArray) && complaintsArray.length > 0) {
    complaintsArray?.forEach((complaintItem) => {
      if (complaintItem?.label) {
        toReturn.push({
          ...complaintItem,
          id:
            complaintItem?.id ??
            getIdForHealthEntity(newlySavedItems, HE_KEY_HEALTH_COMPLAINTS, complaintItem?.value),
          apiParam: 'health-complaint',
          clinicId: clinicId,
          title: complaintItem?.label,
        })
      }
    })
  }
  return toReturn
}

export const getInitialDataForSettingExistingSelectedComplaints = (complaintsFromServer) => {
  const toReturn = []
  if (Array.isArray(complaintsFromServer) && complaintsFromServer.length > 0) {
    complaintsFromServer?.forEach((item) => {
      toReturn.push({ ...item, label: item?.title, value: item?.title })
    })
  }
  return toReturn
}

// diagnosis array related:

export function getDiagnosisArrayForSubmission(diagnosisArray, clinicId, newlySavedItems) {
  const toReturn = []
  if (Array.isArray(diagnosisArray) && diagnosisArray.length > 0) {
    diagnosisArray?.forEach((diagnosisItem) => {
      if (diagnosisItem?.label) {
        toReturn.push({
          ...diagnosisItem,
          id:
            diagnosisItem?.id ??
            getIdForHealthEntity(newlySavedItems, HE_KEY_DIAGNOSIS, diagnosisItem?.value),
          apiParam: 'diagnosis',
          clinicId: clinicId,
          title: diagnosisItem?.label,
        })
      }
    })
  }
  return toReturn
}

export const getInitialDataForSettingExistingSelectedDiagnosis = (diagnosisFromServer) => {
  const toReturn = []
  if (Array.isArray(diagnosisFromServer) && diagnosisFromServer.length > 0) {
    diagnosisFromServer?.forEach((item) => {
      toReturn.push({ ...item, label: item?.title, value: item?.title })
    })
  }
  return toReturn
}

// investigations array related:

export function getInvestigationsArrayForSubmission(investigationsArray, clinicId) {
  const toReturn = []
  if (Array.isArray(investigationsArray) && investigationsArray.length > 0) {
    investigationsArray?.forEach((investigationItem) => {
      if (investigationItem?.label) {
        toReturn.push({
          ...investigationItem,
          apiParam: 'investigation',
          clinicId: clinicId,
          title: investigationItem?.label,
        })
      }
    })
  }
  return toReturn
}

export const getInitialDataForSettingExistingSelectedInvestigations = (
  investigationsFromServer,
) => {
  const toReturn = []
  if (Array.isArray(investigationsFromServer) && investigationsFromServer.length > 0) {
    investigationsFromServer?.forEach((item) => {
      toReturn.push({ ...item, label: item?.title, value: item?.title })
    })
  }
  return toReturn
}

// therapies needed array related:

export function getSelectedTherapiesArrayForSubmission(selectedTherapies) {
  const toReturn = []
  if (Array.isArray(selectedTherapies) && selectedTherapies.length > 0) {
    selectedTherapies?.forEach((selectedTherapy) => {
      toReturn.push(selectedTherapy?.label)
    })
  }
  return toReturn
}

export const getInitialDataForSettingExistingSelectedTherapies = (therapiesFromServer) => {
  const toReturn = []
  if (Array.isArray(therapiesFromServer) && therapiesFromServer.length > 0) {
    therapiesFromServer?.forEach((item) => {
      // `item` is normally a therapy-name string. Defensive: when a full health-entity object
      // (e.g. a therapy-type or clinical-assessment master) lands here, never use the raw object
      // as the label — some consumers (e.g. the therapy report preview) render `.label` directly
      // as a React child, and an object child crashes the page (React error #31). Derive its text
      // while keeping the original item as `value` so existing consumers are unaffected.
      const label =
        item && typeof item === 'object'
          ? item.title ?? item.label ?? item.value ?? item.name ?? ''
          : item
      toReturn.push({ label, value: item })
    })
  }
  return toReturn
}

export const getInitialDataForSettingSelectedTherapist = async (therapist) => {
  const response = await getCPDataWithoutParams(
    `/api/external/mentor/1on1/list?categories=clinical_psychologist&page=1&pageSize=100`,
  )
  if (response.status === 200) {
    const selectedTherapist = response.data.find(
      (therapistFromList) => therapistFromList?.id === therapist?.id,
    )
    if (selectedTherapist?.name) {
      return { value: selectedTherapist?.id, label: selectedTherapist?.name }
    }
    return null
  }
}

// observations array related

export const getInitialDataForSettingExistingSelectedObservations = (observations) => {
  const toReturn = []
  if (Array.isArray(observations) && observations.length > 0) {
    observations?.forEach((item) => {
      toReturn.push({ label: item, value: item })
    })
  }
  return toReturn
}

export const getObservationsArrayForSubmission = (observationsArray, clinicId, newlySavedItems) => {
  const toReturn = []
  if (Array.isArray(observationsArray) && observationsArray.length > 0) {
    observationsArray?.forEach((observationItem) => {
      if (observationItem?.label) {
        toReturn.push({
          ...observationItem,
          apiParam: 'health-observation',
          id:
            observationItem?.id ??
            getIdForHealthEntity(newlySavedItems, HE_KEY_OBSERVATIONS, observationItem?.value),
          clinicId: clinicId,
          title: observationItem?.label,
        })
      }
    })
  }
  return toReturn?.map((observation) => observation?.label)
}

// advice array related

export const getInitialDataForSettingExistingSelectedAdvice = (advices) => {
  const toReturn = []
  if (Array.isArray(advices) && advices.length > 0) {
    advices?.forEach((item) => {
      toReturn.push({ label: item, value: item })
    })
  }
  return toReturn
}

export const getAdviceArrayForSubmission = (adviceArray, clinicId, newlySavedItems) => {
  const toReturn = []
  if (Array.isArray(adviceArray) && adviceArray.length > 0) {
    adviceArray?.forEach((adviceItem) => {
      if (adviceItem?.label) {
        toReturn.push({
          ...adviceItem,
          apiParam: 'prescription-advice',
          clinicId: clinicId,
          id:
            adviceItem?.id ??
            getIdForHealthEntity(newlySavedItems, HE_KEY_ADVICE, adviceItem?.value),
          title: adviceItem?.label,
        })
      }
    })
  }
  return toReturn?.map((observation) => observation?.label)
}

// instructions array related:

function getInitialDataForHealthEntity(healthEntityArray, hasFullObjects = false) {
  const toReturn = []
  if (Array.isArray(healthEntityArray) && healthEntityArray.length > 0) {
    healthEntityArray?.forEach((item) => {
      toReturn.push(getInitialDataForSingleHealthEntity(item, hasFullObjects))
    })
  }
  return toReturn
}

function getInitialDataForSingleHealthEntity(healthEntity, hasFullObject = false) {
  if (hasFullObject) {
    return { ...healthEntity, label: healthEntity?.title, value: healthEntity?.title }
  }
  // The "string list" branch is sometimes fed full objects (e.g. psychAssessments stored as
  // objects when there's no prescribedAssessments). Never let label/value be a raw object —
  // rendering it as a React child crashes the page (React error #31). Derive its text instead.
  if (healthEntity && typeof healthEntity === 'object') {
    const text =
      healthEntity.title ?? healthEntity.label ?? healthEntity.value ?? healthEntity.name ?? ''
    return { ...healthEntity, label: text, value: text }
  }
  return { label: healthEntity, value: healthEntity }
}

export function getInitialDataForSettingSingleExistingHealthEntity(
  healthEntity,
  stringHealthEntity,
  prescriptionViewSettings,
) {
  if (healthEntity) {
    return getInitialDataForSingleHealthEntity(healthEntity, true, prescriptionViewSettings)
  } else if (stringHealthEntity) {
    return getInitialDataForSingleHealthEntity(stringHealthEntity, prescriptionViewSettings)
  }
  return null
}

export function getInitialDataForSettingExistingHealthEntity(
  fullObjectHealthEntityArray,
  stringListHealthEntityArray = [],
) {
  let toReturn = []
  if (!!fullObjectHealthEntityArray && fullObjectHealthEntityArray.length > 0) {
    toReturn = getInitialDataForHealthEntity(fullObjectHealthEntityArray, true)
  } else {
    if (!!stringListHealthEntityArray && stringListHealthEntityArray.length > 0) {
      toReturn = getInitialDataForHealthEntity(stringListHealthEntityArray)
    }
  }
  return toReturn
}

export function getInitialDataForSettingExistingSelectedInstructions(instructions) {
  const toReturn = []
  if (Array.isArray(instructions) && instructions.length > 0) {
    instructions?.forEach((item) => {
      toReturn.push({ label: item, value: item })
    })
  }
  return toReturn
}

export function getInstructionArrayForSubmission(instructionsArray, clinicId, newlySavedItems) {
  const toReturn = []
  if (Array.isArray(instructionsArray) && instructionsArray.length > 0) {
    instructionsArray?.forEach((instructionItem) => {
      if (instructionItem?.label) {
        toReturn.push({
          ...instructionItem,
          apiParam: 'instruction',
          clinicId: clinicId,
          id:
            instructionItem?.id ??
            getIdForHealthEntity(newlySavedItems, HE_KEY_INSTRUCTIONS, instructionItem?.value),
          title: instructionItem?.label,
        })
      }
    })
  }
  return toReturn?.map((instruction) => instruction?.label)
}

// next date related

export const calculateNextVisitDateInDayjs = (
  nextVisitInputValue,
  nextVisitInputType,
  dateFrom = dayjs(),
) => {
  if (!isValidNumber(nextVisitInputValue)) {
    return null
  }

  // Clone the date to avoid mutating the original
  const currentDate = dayjs(dateFrom)

  // Map the input type to the corresponding moment method
  const methodMap = {
    days: 'add',
    months: 'add',
    weeks: 'add',
  }

  // Calculate the next visit date based on input type and value
  if (methodMap[nextVisitInputType]) {
    currentDate.add(nextVisitInputValue, nextVisitInputType)
  } else {
    console.error('Invalid input type')
    return null
  }

  // Return the calculated date
  return currentDate
}

// Fixed function name (correct spelling) with proper date cloning and validation
export const calculateNextVisitDateInMoment = (
  nextVisitInputValue,
  nextVisitInputType,
  dateFrom = dayjs(),
) => {
  // Add validation for input value
  if (!isValidNumber(nextVisitInputValue) || nextVisitInputValue <= 0) {
    // Handle UTC date strings consistently
    if (typeof dateFrom === 'string') {
      return dayjs.utc(dateFrom).local()
    }
    return dayjs(dateFrom)
  }

  // Validate input type
  if (!nextVisitInputType || !['days', 'weeks', 'months'].includes(nextVisitInputType)) {
    console.error('Invalid input type:', nextVisitInputType)
    if (typeof dateFrom === 'string') {
      return dayjs.utc(dateFrom).local()
    }
    return dayjs(dateFrom)
  }

  // Handle UTC date strings consistently - clone to avoid mutation
  let baseDate
  if (typeof dateFrom === 'string') {
    // If it's a string, assume it's UTC and convert to local
    baseDate = dayjs.utc(dateFrom).local()
  } else {
    // If it's already a dayjs object, clone it
    baseDate = dayjs(dateFrom)
  }

  // Calculate the next visit date based on input type and value
  const calculatedDate = baseDate.add(nextVisitInputValue, nextVisitInputType)
  
  return calculatedDate
}

// Keep old typo function as alias for backward compatibility
// @deprecated Use calculateNextVisitDateInMoment instead
export const calculateNextVistDateInMoment = calculateNextVisitDateInMoment

export const calculateNextVistDateInDayjs = (
  nextVisitInputValue,
  nextVisitInputType,
  dateFrom = dayjs(),
) => {
  // Add validation for input value
  if (!isValidNumber(nextVisitInputValue) || nextVisitInputValue <= 0) {
    return dayjs(dateFrom)
  }

  // Validate input type
  if (!nextVisitInputType || !['days', 'weeks', 'months'].includes(nextVisitInputType)) {
    console.error('Invalid input type:', nextVisitInputType)
    return dayjs(dateFrom)
  }

  // Clone the date to avoid mutating the original
  const currentDate = dayjs(dateFrom)

  // Map the input type to the corresponding moment method
  const methodMap = {
    days: 'add',
    months: 'add',
    weeks: 'add',
  }

  // Calculate the next visit date based on input type and value
  currentDate[methodMap[nextVisitInputType]](nextVisitInputValue, nextVisitInputType)
  
  return currentDate
}

export const calculateNextVisitDate = (nextVisitInputValue, nextVisitInputType, format) => {
  const currentDate = calculateNextVisitDateInMoment(nextVisitInputValue, nextVisitInputType)

  if (!currentDate || !currentDate.isValid()) {
    return format ? '' : null
  }

  if (format) {
    return currentDate.format(format)
  }
  // if no format:
  return currentDate.toDate()
}

export const calculateNextVisitDaysFromDate = (selectedDate, dateFrom = dayjs()) => {
  if (!selectedDate) {
    return 0
  }
  // Clone to avoid mutation
  const currentDate = dayjs(dateFrom).startOf('day')
  const targetDate = dayjs(selectedDate).startOf('day')
  
  if (!currentDate.isValid() || !targetDate.isValid()) {
    return 0
  }
  
  return targetDate.diff(currentDate, 'days')
}

export const calculateNextVisitDaysFromDateDayjs = (selectedDate, dateFrom = dayjs()) => {
  if (!selectedDate) {
    return 0
  }
  // Clone to avoid mutation
  const currentDate = dayjs(dateFrom).startOf('day')
  const targetDate = dayjs(selectedDate).startOf('day')
  
  if (!currentDate.isValid() || !targetDate.isValid()) {
    return 0
  }
  
  return targetDate.diff(currentDate, 'days')
}

export const getNextVisitDateForSubmission = (
  nextVisitInputValue,
  nextVisitInputType,
  nextVisitCalendarInput,
  bookedEventInfoStartTime, // Add as optional parameter for backward compatibility
) => {
  if (!nextVisitInputValue || !nextVisitInputType) {
    return null
  }

  // Use bookedEventInfoStartTime if provided, otherwise fall back to current time
  // This maintains backward compatibility with existing calls
  const baseDate = bookedEventInfoStartTime 
    ? dayjs(bookedEventInfoStartTime) 
    : dayjs()

  // dayjs is immutable — .add() returns a NEW object, does NOT mutate the original
  let resultDate = dayjs(baseDate)

  // Map the input type to the corresponding dayjs unit
  const unitMap = {
    days: 'day',
    months: 'month',
    weeks: 'week',
  }

  const unit = unitMap[nextVisitInputType]
  if (unit) {
    resultDate = resultDate.add(Number(nextVisitInputValue), unit)
  } else {
    console.error('Invalid input type', nextVisitInputType)
    return null
  }
  
  // Convert to UTC before formatting
  const formatted = resultDate.utc().format('YYYY-MM-DDTHH:mm:ss[Z]')
  return formatted
}

export const getInitialDataForSettingDaysOfNextVisit = (
  nextDate,
  createdTime,
  nextVisitInputType = 'days',
) => {
  if (nextDate) {
    // Parse nextDate - it comes from server as UTC
    const nextDateMoment = dayjs.utc(nextDate)
    
    if (createdTime) {
      // Parse createdTime as UTC as well (server stores in UTC)
      // Parse with format first, then convert to UTC
      let createdTimeMoment = dayjs(createdTime, 'YYYY-MM-DD HH:mm:ss')
      if (!createdTimeMoment.isValid()) {
        // Fallback: try parsing as UTC directly (for ISO strings)
        createdTimeMoment = dayjs.utc(createdTime)
      } else {
        createdTimeMoment = createdTimeMoment.utc()
      }
      return nextDateMoment.diff(createdTimeMoment, nextVisitInputType)
    } else {
      // Compare with current time in UTC
      return nextDateMoment.diff(dayjs.utc(), nextVisitInputType)
    }
  }
  return null
}

// latestvitalid in prescriptionData

// next visit
// threapy chosen
// therpast chosen from list
// therpast chosen manually
// new complaints fire api, id in complaints
// new diagnosis fire api, id in diagnosis

// decide what to do with save, print and save as it is taking a lot of time
// something to do with all these fields : newly created drug is not showing up
// if "genericName" coming, then show

// find solution 1: rerendering and slowing down fix - typing
// find solution 2:

function isDrugDatabaseUpdateNeeded() {
  const dataLastUpdated = sessionStorage.getItem('drugDatabaseUpdated')
  if (dataLastUpdated) {
    const momentObj = dayjs(dataLastUpdated)
    var isSameDate = momentObj.isSame(dayjs(), 'day')
    return !isSameDate
  }
  return true
}

export const AutoFillFromLastPrescriptionComponent = ({
  patientId,
  thisBookedEventId,
  clickFunction,
}) => {
  const [pastPrescriptionsLoading, setPastPrescriptionsLoading] = useState(false)
  const [lastPrescriptionData, setLastPrescriptionData] = useState(null)

  const setupThings = useCallback(async () => {
    if (!patientId) return
    
    setPastPrescriptionsLoading(true)
    try {
      const response = await getMPDataWithoutParams(
        `/api/secure/doctor/prescription/patient/list?patientId=${patientId}`,
      )
      setPastPrescriptionsLoading(false)
      if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
        let prescriptionDataList = response?.data?.data?.prescriptionDataList || []
        prescriptionDataList = sortArrayMomentBased(
          prescriptionDataList,
          'bookedEventStartTime',
          false,
        )
        const prescriptionTemplateToConsider =
          response?.data?.data?.prescriptionTemplateList?.[0] || {}
        const resultArray = prescriptionDataList?.map(
          (pastPrecriptionsDataOnly, pastPrecriptionsDataOnlyIndex) => ({
            ...prescriptionTemplateToConsider,
            prescriptionData: pastPrecriptionsDataOnly,
          }),
        )
        const filteredResult = resultArray?.filter(
          (item) => item?.prescriptionData?.bookedEventId !== thisBookedEventId,
        )?.[0]
        setLastPrescriptionData(filteredResult)
      } else {
        setLastPrescriptionData(null)
      }
    } catch (error) {
      console.error('Error fetching past prescriptions:', error)
      setPastPrescriptionsLoading(false)
      setLastPrescriptionData(null)
    }
  }, [patientId, thisBookedEventId])

  useEffect(() => {
    setupThings()
  }, [setupThings])

  function handleOnClick() {
    clickFunction(lastPrescriptionData)
  }

  return (
    <>
      {pastPrescriptionsLoading ? (
        <div style={{ margin: '8px 0' }}>
          <Spinner animation="border" variant="dark" size="sm" />
          <span>{' Checking if past prescriptions are available '}</span>
        </div>
      ) : (
        <>
          {lastPrescriptionData ? (
            <div style={{ margin: '32px 0 16px' }}>
              <AutocompleteHelperButton
                text={'Autofill from latest Prescription'}
                Icon={AutoFixHighIcon}
                iconProps={{ fontSize: '8px' }}
                clickFunction={handleOnClick}
              />
              <div style={{ fontSize: '12px', marginLeft: '12px' }}>
                from{' '}
                {dayjs
                  .utc(
                    lastPrescriptionData?.bookedEventStartTime ||
                      lastPrescriptionData?.createdTime ||
                      lastPrescriptionData?.modifiedTime,
                  )
                  ?.local()
                  ?.format('DD/MM/YYYY h:mmA')}
              </div>
            </div>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  )
}

export const AddNewTestComponent = ({ closeFunc, clinicId, clinicBrandId }) => {
  const [nameOfTest, setNameOfTest] = useState('')
  const [loading, setLoading] = useState(false)

  async function saveNewTestAndClose(testName) {
    setLoading(true)
    if (nameOfTest) {
      await saveNewInvestigation(testName, clinicId, clinicBrandId)
      if (closeFunc) {
        closeFunc()
      }
    }
    setLoading(false)
  }

  return (
    <div
      style={{ padding: '8px', width: '256px', border: '1px solid #d3d3d3', borderRadius: '4px' }}
    >
      <div style={{ marginBottom: '24px' }}>
        <b>Add Test</b>
      </div>
      <CustomInput
        type={'text'}
        value={nameOfTest}
        onChange={(e) => setNameOfTest(e.target.value)}
      />
      <button
        style={{
          marginTop: '16px',
          background: `${nameOfTest ? '#000' : '#fff'}`,
          borderRadius: '4px',
          border: `${nameOfTest ? '1px solid #000' : '1px solid #d3d3d3'}`,
          color: `${nameOfTest ? '#fff' : '#000'}`,
        }}
        disabled={!nameOfTest}
        onClick={() => saveNewTestAndClose(nameOfTest)}
      >
        Add {loading && <Spinner animation="border" variant="light" size="sm" />}
      </button>
    </div>
  )
}

const buildQueryParams = (params) => {
  const query = Object.entries(params)
    .filter(([_, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&')

  return query ? `?${query}` : ''
}

function getIdForHealthEntity(map, key, title) {
  const found = getHealthEntityFromHEMapArray(map, key, title)
  if (!!found?.id) {
    return found?.id
  }
  return null
}
function getHealthEntityFromHEMapArray(map, key, title) {
  if (map && map[key] && Array.isArray(map[key]) && map[key].length > 0) {
    const healthEntityArrayToConsider = map?.[key] || []

    let found = healthEntityArrayToConsider.find((item) => item?.title === title)
    if (!!found) {
      return found
    }
  }
  return null
}

function getMultipleHealthEntityFromArray(map, key, title) {
  if (map && map[key] && Array.isArray(map[key]) && map[key].length > 0) {
    const healthEntityArrayToConsider = map?.[key] || []

    let found = healthEntityArrayToConsider.filter((item) => item?.title === title)
    if (!!found) {
      return found
    }
  }
  return null
}

{
  /* 
const data = [
    drug,
    {
      apiParam: 'drug-info',
      clinicId: 1,
      clinicBrandId: 1,
      id: 0,
      name: 'drug1',
      dosage: null,
      whatTime: null,
      frequency: null,
      timing: null,
      note: null,
    },
    {
      apiParam: 'drug-info',
      clinicId: 1,
      clinicBrandId: 1,
      id: 0,
      name: 'drug2',
      dosage: null,
      whatTime: null,
      frequency: null,
      timing: null,
      note: null,
    },
  ] */
}

export const PatientNotesSectionForReports = forwardRef(
  ({ patientName, thisBookedEventId, patientId, hideHeader = false }, ref) => {
    const [thisEventNoteData, setThisEventNoteData] = useState()
    const [allNotes, setAllNotes] = useState([])

    const [allNotesSectionOpen, setAllNotesSectionOpen] = useState(false)

    const [loading, setLoading] = useState(false)
    const [saving, setSaving] = useState()

    async function getAllNotes() {
      setLoading(true)
      const response = await getDataWithoutParams(
        `/api/secure/teacher/private-notes?patientId=${patientId}`,
      )
      if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
        setAllNotes(response?.data?.data?.['mentor-private-notes'])
        if (Array.isArray(response?.data?.data?.['mentor-private-notes'])) {
          const thisSessionNote = response?.data?.data?.['mentor-private-notes']?.find(
            (item) => item?.bookedEventId === thisBookedEventId,
          )
          if (thisSessionNote) {
            setThisEventNoteData(thisSessionNote)
          } else {
            setThisEventNoteData({
              bookedEventId: thisBookedEventId,
              content: '',
            })
          }
        }
      }
      setLoading(false)
    }

    async function saveNote() {
      if (!Boolean(thisEventNoteData?.id) && !Boolean(thisEventNoteData?.content)) {
        return
      }
      setSaving(true)
      const response = await postDataWithoutParams(
        '/api/secure/teacher/private-notes/save',
        thisEventNoteData,
      )
      setSaving(false)
      if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
      } else {
        toast.error('Error saving')
      }
      getAllNotes()
    }

    useEffect(() => {
      getAllNotes()
    }, [])

    // Expose the saveNote function to be called from the parent
    useImperativeHandle(ref, () => ({
      saveNote,
    }))

    return (
      <div className="w-100">
        {!hideHeader && (
          <div style={{ marginBottom: '12px' }}>
            <div className="d-flex gap-2 align-items-center" style={{ marginBottom: '8px' }}>
              <PMPSectionInputLabel main className="d-flex gap-2 align-items-center">
                <LockIcon sx={{ fontSize: '18px', color: '#6366f1' }} />
                Private Notes {loading && <Spinner size="sm" variant="dark" />}
                {allNotes?.length > 0 && (
                  <div
                    style={{
                      cursor: 'pointer',
                      fontSize: '12px',
                      marginLeft: '12px',
                      color: '#6366f1',
                      fontWeight: '500',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      transition: 'all 0.2s',
                    }}
                    onClick={() => setAllNotesSectionOpen((prev) => !prev)}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = '#f0f4ff'
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = 'transparent'
                    }}
                  >
                    {allNotesSectionOpen ? 'Hide' : 'See'} History
                  </div>
                )}
              </PMPSectionInputLabel>
            </div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '12px',
              color: '#64748b',
              fontStyle: 'italic',
              padding: '6px 12px',
              backgroundColor: '#f8fafc',
              borderRadius: '8px',
              border: '1px solid #e2e8f0',
              marginTop: '4px',
            }}>
              <VisibilityOffIcon sx={{ fontSize: '14px', color: '#94a3b8' }} />
              <span>These notes are completely private and only visible to you</span>
            </div>
          </div>
        )}
        <div className="d-flex gap-1 w-100" style={{ position: 'relative' }}>
          <TextareaAutosize
            placeholder="Take notes here..."
            className="pmpTextarea-focus"
            style={{
              width: '100%',
              minHeight: '120px',
              padding: '14px 16px',
              border: '1px solid #e2e8f0',
              borderRadius: '12px',
              background: '#ffffff',
              fontSize: '14px',
              fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
              lineHeight: '1.6',
              color: '#1e293b',
              resize: 'vertical',
              transition: 'all 0.2s ease',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#6366f1'
              e.target.style.boxShadow = '0 0 0 3px rgba(99, 102, 241, 0.1)'
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#e2e8f0'
              e.target.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.05)'
            }}
            value={thisEventNoteData?.content}
            onChange={(e) => setThisEventNoteData((prev) => ({ ...prev, content: e.target.value }))}
          />
          {saving && (
            <div style={{
              position: 'absolute',
              top: '12px',
              right: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              color: '#6366f1',
              fontSize: '12px',
              fontWeight: '500',
            }}>
              <Spinner size="sm" variant="dark" />
              <span>Saving...</span>
            </div>
          )}
        </div>
        {allNotesSectionOpen && (
          <div style={{
            marginTop: '20px',
            padding: '16px',
            backgroundColor: '#f8fafc',
            borderRadius: '12px',
            border: '1px solid #e2e8f0',
          }}>
            <div style={{
              marginBottom: '12px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
              <div style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#1e293b',
              }}>
                Your private notes for {patientName}
              </div>
              <div
                onClick={() => setAllNotesSectionOpen(false)}
                style={{
                  fontSize: '12px',
                  cursor: 'pointer',
                  color: '#6366f1',
                  fontWeight: '500',
                  padding: '4px 12px',
                  borderRadius: '6px',
                  transition: 'all 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#f0f4ff'
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = 'transparent'
                }}
              >
                Hide
              </div>
            </div>
            {allNotes?.map((noteItem, noteItemIndex) => (
              <NoteHistorialItem
                key={noteItemIndex}
                noteItem={noteItem}
                callbackAfterAnyEdit={getAllNotes}
              />
            ))}
          </div>
        )}
      </div>
    )
  },
)

const NoteHistorialItem = ({ noteItem, callbackAfterAnyEdit }) => {
  const [editing, setEditing] = useState(false)
  const [text, setText] = useState('')
  const [loading, setLoading] = useState(false)

  async function deleteThisNote() {
    setEditing(false)
    setLoading(true)
    const response = await postDataWithoutParams(
      `/api/secure/teacher/private-notes/delete?bookedEventId=${noteItem?.bookedEventId}`,
      {},
    )
    setLoading(false)
    if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
    } else {
      toast.error('Delete failed')
    }
    if (callbackAfterAnyEdit) {
      callbackAfterAnyEdit()
    }
  }

  async function editThisNote() {
    setEditing(false)
    setLoading(true)
    const response = await postDataWithoutParams('/api/secure/teacher/private-notes/save', {
      ...noteItem,
      content: text,
    })
    setLoading(false)
    if (response?.status === 200 && isCommonResponseSuccessful(response?.data?.code)) {
    } else {
      toast.error('Error saving')
    }
    if (callbackAfterAnyEdit) {
      callbackAfterAnyEdit()
    }
  }

  return (
    <div
      style={{ border: '1px solid #cecece', borderRadius: '4px', padding: '8px', margin: '4px 0' }}
    >
      <div style={{ display: 'flex', justifyContent: 'right', width: '100%' }}>
        {editing && (
          <button
            style={{ background: 'green', color: '#fff', borderRadius: '4px' }}
            onClick={editThisNote}
          >
            Update
          </button>
        )}
        {!loading && !editing && (
          <EditIcon
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setEditing(true)
              setText(noteItem?.content || '')
            }}
          />
        )}
        {!loading && (
          <DeleteIcon
            style={{ marginLeft: '12px', color: 'red', cursor: 'pointer' }}
            onClick={deleteThisNote}
          />
        )}
        {loading && <Spinner variant="dark" size="sm" />}
      </div>
      {editing ? (
        <TextareaAutosize
          style={{ border: '1px solid #cecece', borderRadius: '4px', width: '100%' }}
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
      ) : (
        <div style={{ paddingTop: '8px' }}>{noteItem?.content}</div>
      )}
      <div
        style={{
          width: '100%',
          fontSize: '12px',
          color: '#000',
          textAlign: 'right',
          marginTop: '8px',
        }}
      >
        Edited{' '}
        {noteItem?.modifiedTime
          ? dayjs.utc(noteItem.modifiedTime).local().format('DD MMM, YY h:mm A')
          : 'No time available'}
      </div>
    </div>
  )
}

export const TwoHeadingComponent = ({ Comp1, Comp2 }) => {
  return (
    <div
      style={{
        display: 'flex',
        borderRadius: '8px',
        overflow: 'hidden',
        border: '1px solid #cecece',
      }}
    >
      <div style={{ background: '#fff', borderRight: '1px solid #cecece', padding: '4px 16px' }}>
        {Comp1}
      </div>
      <div style={{ background: '#f0f0f0', padding: '4px 16px' }}>{Comp2}</div>
    </div>
  )
}

export const CancelAndRedoComponent = ({
  showCancel = true,
  cancelClickFunction,
  redoClickFunction,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      {showCancel && (
        <Tooltip title="Clear all" arrow placement="top">
          <IconButton
            size="small"
            onClick={cancelClickFunction}
            sx={{
              color: '#dc2626',
              '&:hover': {
                backgroundColor: 'rgba(220, 38, 38, 0.08)',
                color: '#b91c1c',
              },
              padding: '6px',
            }}
          >
            <CancelIcon sx={{ fontSize: '18px' }} />
          </IconButton>
        </Tooltip>
      )}
      <Tooltip title="Undo clear" arrow placement="top">
        <IconButton
          size="small"
          onClick={redoClickFunction}
          sx={{
            color: '#4338ca',
            '&:hover': {
              backgroundColor: 'rgba(67, 56, 202, 0.08)',
              color: '#3730a3',
            },
            padding: '6px',
          }}
        >
          <UndoIcon sx={{ fontSize: '18px' }} />
        </IconButton>
      </Tooltip>
    </Box>
  )
}
